import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** eindeutige Id eines App Projektes */
  AppID: { input: string; output: string; }
  /** Handle zu einem lang laufenden Hintergrundprozess */
  BatchId: { input: any; output: any; }
  /** ein HEX colr Wert. '#ff0000' */
  Color: { input: any; output: any; }
  /** ein Datum im ISO Format mit Zeitzonen Angabe */
  Date: { input: Date; output: Date; }
  /** eindeutige Id zu einem File innerhalb eines FileStore */
  FSFileId: { input: any; output: any; }
  /** Id eines Filestore */
  FSId: { input: any; output: any; }
  /** Das brauchen wir zum Durchtunneln von generischen Maps */
  JSON: { input: any; output: any; }
  /** A date-time without a time-zone in the ISO-8601 calendar system, such as 2007-12-03T10:15:30. */
  LocalDateTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  /** Verweis auf eine bestimmte Rolle innerhalb der Rollenaufzählung im App Kontext. */
  RoleRef: { input: any; output: any; }
  /** ein temporärer File Upload, der automatisch nach einer gegebenen Zeit wieder gelöscht wird */
  UploadId: { input: any; output: any; }
  Url: { input: any; output: any; }
  /** Handle zu einem File im Workspace einer App */
  WSFileId: { input: any; output: any; }
};

/** Eingabe Daten zur Erzeuhung eines neuen Admin Benutzers */
export type AdminUserInput = {
  appIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** wurde eine Authenticator-App als 2FA aktiviert ? */
  authenticatorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cnumber?: InputMaybe<Scalars['String']['input']>;
  currentAppDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  /** Vor- und Zuname */
  firstname?: InputMaybe<Scalars['String']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  invalidLoginAttemps?: InputMaybe<Scalars['Int']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  technicalAppUser?: InputMaybe<Scalars['Boolean']['input']>;
  username: Scalars['String']['input'];
};

export type AndroidAppColors = {
  __typename?: 'AndroidAppColors';
  /** Toolbar Hintergrund */
  aos_headerBgColor?: Maybe<Scalars['String']['output']>;
  /** Toolbar Text */
  aos_headerTextColor?: Maybe<Scalars['String']['output']>;
  /** Menü Hintergrund */
  aos_menuBgColor?: Maybe<Scalars['String']['output']>;
  /** Menü Kopf Hintergrund */
  aos_menuHeaderBgColor?: Maybe<Scalars['String']['output']>;
  /** Menü Kopf Text */
  aos_menuHeaderTextColor?: Maybe<Scalars['String']['output']>;
  /** Menü Icon */
  aos_menuIconColor?: Maybe<Scalars['String']['output']>;
  /** Menü Textfarbe */
  aos_menuTextColor?: Maybe<Scalars['String']['output']>;
  /** Hintergrundfarbe aktiver Menüpunk */
  aos_selectedItemBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Textfarbe aktiver Menüpunkt */
  aos_selectedItemColor?: Maybe<Scalars['String']['output']>;
  /** Grundfarbe der App */
  appColor?: Maybe<Scalars['String']['output']>;
};

export type AndroidAppColorsInput = {
  /** Toolbar Hintergrund */
  aos_headerBgColor?: InputMaybe<Scalars['String']['input']>;
  /** Toolbar Text */
  aos_headerTextColor?: InputMaybe<Scalars['String']['input']>;
  /** Menü Hintergrund */
  aos_menuBgColor?: InputMaybe<Scalars['String']['input']>;
  /** Menü Kopf Hintergrund */
  aos_menuHeaderBgColor?: InputMaybe<Scalars['String']['input']>;
  /** Menü Kopf Text */
  aos_menuHeaderTextColor?: InputMaybe<Scalars['String']['input']>;
  /** Menü Icon */
  aos_menuIconColor?: InputMaybe<Scalars['String']['input']>;
  /** Menü Textfarbe */
  aos_menuTextColor?: InputMaybe<Scalars['String']['input']>;
  /** Hintergrundfarbe aktiver Menüpunk */
  aos_selectedItemBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Textfarbe aktiver Menüpunkt */
  aos_selectedItemColor?: InputMaybe<Scalars['String']['input']>;
  /** Grundfarbe der App */
  appColor?: InputMaybe<Scalars['String']['input']>;
};

/** App-Einstellungen der Android-App */
export type AndroidAppSettings = {
  __typename?: 'AndroidAppSettings';
  /** App Farben */
  colors?: Maybe<AndroidAppColors>;
};

/** App-Einstellungen der Android-App */
export type AndroidAppSettingsInput = {
  /** App Farben */
  colors?: InputMaybe<AndroidAppColorsInput>;
};

export type AndroidAppStoreSettingsInput = {
  aos_adverttext?: InputMaybe<Scalars['String']['input']>;
  aos_appname?: InputMaybe<Scalars['String']['input']>;
  aos_appstore_link?: InputMaybe<Scalars['String']['input']>;
  aos_askForUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  aos_category?: InputMaybe<Scalars['String']['input']>;
  aos_description?: InputMaybe<Scalars['String']['input']>;
  aos_dev_comment?: InputMaybe<Scalars['String']['input']>;
  aos_developer_account?: InputMaybe<Scalars['String']['input']>;
  aos_fcm_server_key?: InputMaybe<Scalars['String']['input']>;
  aos_firebase_project_id?: InputMaybe<Scalars['String']['input']>;
  aos_goinglive?: InputMaybe<Scalars['Date']['input']>;
  aos_lastUpdate?: InputMaybe<Scalars['Date']['input']>;
  aos_libVersion?: InputMaybe<Scalars['Int']['input']>;
  aos_short_description?: InputMaybe<Scalars['String']['input']>;
  aos_website?: InputMaybe<Scalars['String']['input']>;
};

/** Liefert Informationen zum Fortschritt eines lang laufenden Hintergrundprozesses */
export type AppBackgroundJob = {
  __typename?: 'AppBackgroundJob';
  androidMaxHits?: Maybe<Scalars['Int']['output']>;
  androidProgress?: Maybe<Scalars['Int']['output']>;
  filtered: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  iosMaxHits?: Maybe<Scalars['Int']['output']>;
  iosProgress?: Maybe<Scalars['Int']['output']>;
};

export type AppConfiguration = {
  __typename?: 'AppConfiguration';
  /**  ## Version der Library  */
  aos_libVersion?: Maybe<Scalars['Int']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  conferenceServer?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<AppConfigurationFeature>>>;
  groupLimit?: Maybe<Scalars['Int']['output']>;
  groupSpaceLimit?: Maybe<Scalars['Int']['output']>;
  ios_libVersion?: Maybe<Scalars['Int']['output']>;
  profileComponentId?: Maybe<Scalars['String']['output']>;
  projectSLA?: Maybe<ProjectServiceLevel>;
  projectType?: Maybe<ProjectType>;
  restrictedAccessMode?: Maybe<Scalars['Boolean']['output']>;
  storageQuota?: Maybe<Scalars['Long']['output']>;
};

export enum AppConfigurationFeature {
  /** @deprecated Field no longer supported */
  Audio = 'AUDIO',
  DosbImagepool = 'DOSB_IMAGEPOOL',
  Facebook = 'FACEBOOK',
  /** @deprecated Field no longer supported */
  ListPincode = 'LIST_PINCODE',
  /** @deprecated Field no longer supported */
  ListSearch = 'LIST_SEARCH',
  Livestream = 'LIVESTREAM',
  /** @deprecated Field no longer supported */
  MemberProfiles = 'MEMBER_PROFILES',
  /** @deprecated Field no longer supported */
  MemberProfilesExtended = 'MEMBER_PROFILES_EXTENDED',
  /** @deprecated Field no longer supported */
  PictureAlliance = 'PICTURE_ALLIANCE',
  ProductCatalogue = 'PRODUCT_CATALOGUE',
  PushChannel = 'PUSH_CHANNEL',
  VideoDownload = 'VIDEO_DOWNLOAD'
}

export type AppConfigurationInput = {
  conferenceServer?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<InputMaybe<AppConfigurationFeature>>>;
  groupLimit?: InputMaybe<Scalars['Int']['input']>;
  groupSpaceLimit?: InputMaybe<Scalars['Int']['input']>;
  projectSLA?: InputMaybe<ProjectServiceLevel>;
  projectType?: InputMaybe<ProjectType>;
  restrictedAccessMode?: InputMaybe<Scalars['Boolean']['input']>;
  storageQuota?: InputMaybe<Scalars['Long']['input']>;
};

/**
 * Das umfassende Container Objekt auf das sich der Vertrag bezieht. Zu einem Projekt
 * gibt es mindestens eine Projektversion - in der Regel die deutsche Sprachversion
 */
export type AppackProject = {
  __typename?: 'AppackProject';
  /** Basis Id für das ganze Projekt z.B 'PreviewApp' */
  id: Scalars['ID']['output'];
  /** welche Sprachen wurden bestellt */
  languages?: Maybe<Array<Maybe<Scalars['Locale']['output']>>>;
  /** globaler Strukturbaum. Hier sind alle versionsübergreifenden Komponenten zu finden */
  structureRootId: Scalars['ID']['output'];
  versions?: Maybe<Array<Maybe<AppackProjectVersion>>>;
};

export type AppackProjectVersion = {
  __typename?: 'AppackProjectVersion';
  /** Zusammengesetzte ID dieser Version z.B 'PreviewApp-de' */
  id: Scalars['ID']['output'];
  /** Der Projektname in der jeweiligen Sprache */
  label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['Locale']['output']>;
  /**
   * Diejenigen Nodes aus dem Strukturbaum, die als Navigationselemente in der App
   * auftauchen sollen.
   */
  navigationList?: Maybe<Array<Maybe<NavigationNode>>>;
  /**
   * alle Strukturknoten dieser Projektversion als flache ungeordnete Liste.
   * Die Hierarchie muss client seitig beginnend mit dem Wurzelknoten(root) aufgebaut werden.
   */
  structureNodes: Array<Maybe<StructureNode>>;
  /** Die Id des Wurzelknotens der Versionsstruktur */
  structureRootId: Scalars['ID']['output'];
};

export type ApplicationComponent = {
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
};

export enum ApplicationComponentType {
  Appointments = 'APPOINTMENTS',
  Chat = 'CHAT',
  Filestore = 'FILESTORE',
  Gallery = 'GALLERY',
  GroupSpace = 'GROUP_SPACE',
  News = 'NEWS',
  Pinboard = 'PINBOARD',
  PushSend = 'PUSH_SEND',
  ResourceManagement = 'RESOURCE_MANAGEMENT',
  Unknown = 'UNKNOWN'
}

export type ApplicationComponentUpdate = {
  /** Hilfeseite */
  helpPageId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Die notwendigen Angaben, die für eine Registrierung zu einem Event benötigt werden.
 * Wenn der Teilnehmer bereits über sein Profil bekannt ist, reicht die Angabe der Id und
 * die Daten werden aus dem Profil übernommen.
 */
export type AttendeeInput = {
  /** Kommentar zum Teilnehmer */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** eMail des Teilnehmers */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Vorname des Teilnehmer */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Additional custom fields */
  formData?: InputMaybe<Scalars['JSON']['input']>;
  /** Nachname aus dem Profil */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Telefonnummer des Teilnehmers */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Der Teilnehmer ist ein bekanntes Benutzerprofil */
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export type BadgeResult = {
  __typename?: 'BadgeResult';
  badge?: Maybe<Scalars['Int']['output']>;
  component: Scalars['String']['output'];
};

export type Barcode = {
  __typename?: 'Barcode';
  /** Art des Codes */
  barcodeValidationType?: Maybe<BarcodeValidationType>;
  /** zu welcher Komponente/Modul gehört der Code. Wichtig für die Validierung */
  componentSpecificationId?: Maybe<Scalars['String']['output']>;
  /** wann wurde der Code erstellt */
  creationDate?: Maybe<Scalars['Date']['output']>;
  /** der URL String, der zu Erzeugung des Codes final benutzt wird */
  data?: Maybe<Scalars['String']['output']>;
  /** Bewschreibung */
  description?: Maybe<Scalars['String']['output']>;
  /** aktiv oder nicht */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** wie lange ist die Gültigkeit */
  expireDate?: Maybe<Scalars['Date']['output']>;
  /** eindeutige Id */
  id: Scalars['ID']['output'];
  /** Wertigkeit dws Codes (bei Bonusheft) */
  score?: Maybe<Scalars['Int']['output']>;
};

/** Felder, die beim Erzeugen bze. der nachträglichen Änderung gesetzt werden können */
export type BarcodeUpdate = {
  /** Art des Codes */
  barcodeValidationType: BarcodeValidationType;
  /** zu welcher Komponente/Modul gehört der Code. Wichtig für die Validierung */
  componentSpecificationId: Scalars['String']['input'];
  /** Bewschreibung */
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  /** wie lange ist die Gültigkeit */
  expireDate?: InputMaybe<Scalars['Date']['input']>;
  /** Wertigkeit dws Codes (bei Bonusheft) */
  score: Scalars['Int']['input'];
};

export enum BarcodeValidationType {
  SimpleBarcode = 'SimpleBarcode',
  SimpleBarcodeSingle = 'SimpleBarcode_Single'
}

export type BasicResourceUpdateInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resourceCategoryId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResourceStatus>;
  user_category?: InputMaybe<Scalars['String']['input']>;
  user_comment?: InputMaybe<Scalars['String']['input']>;
  user_contact?: InputMaybe<Scalars['String']['input']>;
  user_title?: InputMaybe<Scalars['String']['input']>;
};

export type BonusBooklet = {
  __typename?: 'BonusBooklet';
  /** Ist die Ausgabe des Bonusheftes Aktiv? */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Farbe */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Hintergrundbild auf das sich die Stempelkoordinaten beziehen */
  bookletImage?: Maybe<Resource>;
  /** Hintergrundbild ID */
  bookletImageId?: Maybe<Scalars['ID']['output']>;
  /** Bild-Url des Booklets */
  bookletImageUrl?: Maybe<Scalars['String']['output']>;
  /** Coupon */
  coupon?: Maybe<Coupon>;
  /** Coupon */
  couponId?: Maybe<Scalars['ID']['output']>;
  /** Gültigkeit des Bonusheftes, entspricht der gültigkeit des Gutscheins */
  expires?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** wann wurde die Komponente erstellt bzw. zuletzt geändert */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** Bild, welches als 'Stempel' verwendet wird */
  stampImage?: Maybe<Resource>;
  /** Stempelbild ID */
  stampImageId?: Maybe<Scalars['ID']['output']>;
  /** Stempelbild URL */
  stampImageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Liste der Stempelfelder. Die Grösse des Arrays korrespondiert mit den Feldern auf dem Hintergrundbild und die Reihenfolge
   * definiert die Reihenfolge in der gestempelt wird."
   */
  stamps?: Maybe<Array<Maybe<Stamp>>>;
};

export type BonusBookletInput = {
  /** Ist die Ausgabe des Bonusheftes Aktiv? */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Farbe */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  bookletImageId?: InputMaybe<Scalars['ID']['input']>;
  couponId?: InputMaybe<Scalars['ID']['input']>;
  expires?: InputMaybe<Scalars['Date']['input']>;
  stampImageId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Liste der Stempelfelder. Die Grösse des Arrays korrespondiert mit den Feldern auf dem Hintergrundbild und die Reihenfolge
   * definiert die Reihenfolge in der gestempelt wird."
   */
  stamps?: InputMaybe<Array<InputMaybe<StampInput>>>;
};

export type Booking = {
  __typename?: 'Booking';
  comment?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  participants?: Maybe<Scalars['Int']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  profileMail?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<BookingResource>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type BookingBookmark = {
  __typename?: 'BookingBookmark';
  id: Scalars['ID']['output'];
  resourceId: Scalars['String']['output'];
};

export type BookingCalendarSimple = {
  __typename?: 'BookingCalendarSimple';
  end?: Maybe<Scalars['Date']['output']>;
  items?: Maybe<Array<Maybe<BookingStatus>>>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type BookingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  participants?: InputMaybe<Scalars['Int']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type BookingPagingResponse = {
  __typename?: 'BookingPagingResponse';
  content?: Maybe<Array<Maybe<Booking>>>;
  totalcount: Scalars['Int']['output'];
};

export type BookingResource = {
  __typename?: 'BookingResource';
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pool?: Maybe<Scalars['Boolean']['output']>;
  publicBookings?: Maybe<Scalars['Boolean']['output']>;
  responsibleProfile?: Maybe<UserProfile>;
  responsibleProfileId?: Maybe<Scalars['String']['output']>;
  responsibleRoles?: Maybe<Array<Maybe<CustomEnumValue>>>;
  rule?: Maybe<Scalars['String']['output']>;
  schedules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BookingResourceFilter = {
  bookmarkedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  day?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type BookingResourceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pool?: InputMaybe<Scalars['Boolean']['input']>;
  publicBookings?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleProfileId?: InputMaybe<Scalars['String']['input']>;
  responsibleRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rule?: InputMaybe<Scalars['String']['input']>;
  schedules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type BookingResourcePlan = {
  __typename?: 'BookingResourcePlan';
  resource?: Maybe<BookingResource>;
  rule?: Maybe<BookingRule>;
  slots?: Maybe<Array<Maybe<BookingSlot>>>;
};

export type BookingRule = {
  __typename?: 'BookingRule';
  id: Scalars['ID']['output'];
  information?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<ReservationInterval>;
  lastModification?: Maybe<Scalars['Date']['output']>;
  maxDaysInFuture?: Maybe<Scalars['Int']['output']>;
  maxTime?: Maybe<Scalars['Int']['output']>;
  minDeltaToNextSlot?: Maybe<Scalars['Int']['output']>;
  minTime?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timeUnit?: Maybe<ReservationTimeUnit>;
};

export type BookingRuleInput = {
  information?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<ReservationInterval>;
  lastModification?: InputMaybe<Scalars['Date']['input']>;
  maxDaysInFuture?: InputMaybe<Scalars['Int']['input']>;
  maxTime?: InputMaybe<Scalars['Int']['input']>;
  minDeltaToNextSlot?: InputMaybe<Scalars['Int']['input']>;
  minTime?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  timeUnit?: InputMaybe<ReservationTimeUnit>;
};

export type BookingSchedule = {
  __typename?: 'BookingSchedule';
  id: Scalars['ID']['output'];
  naDays?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
  weekPlanning?: Maybe<ScheduleWeekAvailability>;
};

export type BookingScheduleInput = {
  naDays?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
  weekPlanning?: InputMaybe<ScheduleWeekAvailabilityInput>;
};

export type BookingSearchPageRequestInput = {
  from: Scalars['Date']['input'];
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
  to: Scalars['Date']['input'];
};

export type BookingSlot = {
  __typename?: 'BookingSlot';
  available?: Maybe<Scalars['Boolean']['output']>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
};

export enum BookingStatus {
  Available = 'AVAILABLE',
  FullyBooked = 'FULLY_BOOKED',
  MostlyBooked = 'MOSTLY_BOOKED',
  NotAvailable = 'NOT_AVAILABLE'
}

export type BookingTag = {
  __typename?: 'BookingTag';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BookingTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CmsSettings = {
  __typename?: 'CMSSettings';
  /** Url auf das AppIcon im CMS */
  appIconUrl?: Maybe<Scalars['String']['output']>;
  /** Schlagworte für die Projektsuche */
  keywords?: Maybe<Scalars['String']['output']>;
  /** CMS-Manager-Email */
  managerEmail?: Maybe<Scalars['String']['output']>;
  /** Name der App im CMS */
  portalAppName?: Maybe<Scalars['String']['output']>;
  /** Projekt Beschreibung */
  projectDescription?: Maybe<Scalars['String']['output']>;
};

export type CmsSettingsInput = {
  /** Schlagworte für die Projektsuche */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** CMS-Manager-Email */
  managerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name der App im CMS */
  portalAppName?: InputMaybe<Scalars['String']['input']>;
  /** Projekt Beschreibung */
  projectDescription?: InputMaybe<Scalars['String']['input']>;
};

/** collection of events that form a logical group. */
export type Calendar = {
  __typename?: 'Calendar';
  /** App Kontext dieses Kalenders (Eigentümer App) */
  appId: Scalars['AppID']['output'];
  /**
   * Der Kalender kann vom anfragenden Benutzer gelesen werden, wenn keine Rollen zum lesen definiert wurden
   * oder der Benutzer eine der notwendigen Rollen besitzt.
   */
  canRead?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Der Kalender kann vom anfragenden Benutzer geschrieben werden, sofern der Kalender nicht extern verwaltet (iCal Feed)
   * und er eine für das Schreiben notwendige Rollen hat.
   */
  canWrite?: Maybe<Scalars['Boolean']['output']>;
  /** Optionale Kategorien des Events */
  categories?: Maybe<Array<Maybe<CalendarEventCategory>>>;
  /** HEX color Wert */
  color: Scalars['Color']['output'];
  /** optionale Komponente(n) Zugehörigkeit */
  componentIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Beschreibungstext für die Inhalte des Kalenders */
  description?: Maybe<Scalars['String']['output']>;
  /** Bis zu 3 der beim letzten iCal-Sync aufgetretenen Fehlermeldungen. */
  hints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Zeitpunkt der letzten iCal Synchronisation */
  iCalLastSynced?: Maybe<Scalars['Date']['output']>;
  /** sofern der Calendar aus einer iCal Quelle erzeugt erzeugt wurde, findet sich hier die Url zur Quelle */
  iCalUrl?: Maybe<Scalars['Url']['output']>;
  /** Primärschlüssel */
  id: Scalars['ID']['output'];
  /**
   * Ist gesetzt wenn es sich um einen Gruppenkalender handelt, der nur für die Mitgliedern der Gruppe
   * sichtbar sein soll und standardmäßig nur von den Gruppenleitern zu bearbeiten ist.
   */
  ownedByGroupId?: Maybe<Scalars['String']['output']>;
  /** Gruppen, welche den Kalender lesen dürfen */
  readerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  readerGroups?: Maybe<Array<Maybe<Group>>>;
  /**
   * wenn gesetzt, dann muss der Nutzer, der diesen Kalender lesen will ein Benutzerprofil haben
   * und mindestens eine der gelisteten Rollen.
   */
  readerRoles?: Maybe<Array<Maybe<CustomEnumValue>>>;
  /** Aufbewahrungsdauer (in Tagen) der Events */
  retainEventsForDays?: Maybe<Scalars['Int']['output']>;
  /** Titel */
  title: Scalars['String']['output'];
  /** Gruppen, welche den Kalender schreiben dürfen */
  writerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  writerGroups?: Maybe<Array<Maybe<Group>>>;
  /**
   * wenn gesetzt, dann können Einträge in diesem Kalender nur dann erzeugt bzw. bearbeitet werden, wenn
   * der Bearbeiter ein Profil mit mindestens einer der genannten Rollen hat.
   */
  writerRoles?: Maybe<Array<Maybe<CustomEnumValue>>>;
};

export type CalendarApplicationComponent = ApplicationComponent & {
  __typename?: 'CalendarApplicationComponent';
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Konfiguration */
  config?: Maybe<Scalars['JSON']['output']>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
  /** Kalender, die in dieser Komponente verwendet werden */
  usedCalendarIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type CalendarApplicationComponentUpdate = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Kalender, die in dieser Komponente verwendet werden */
  usedCalendarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** der eigentliche Ereignis/Termin/Veranstaltung Eintrag in einem Kalender. */
export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  /** es handelt sich um einen ganztägigen Event */
  allDay?: Maybe<Scalars['Boolean']['output']>;
  /** Soll das event ein badge auslösen? */
  badgeEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Kalender zu dem dieses Ereignis gehört */
  calendarId: Scalars['ID']['output'];
  /** Ist der aktuelle Benutzer berechtigt diesen Event zu ändern. */
  canWrite?: Maybe<Scalars['Boolean']['output']>;
  /** Abmeldeschluss (Offset in Minuten) vor Veranstaltungsbeginn */
  cancelRegistrationDeadlineOffsetMinutes?: Maybe<Scalars['Int']['output']>;
  /** welchen Kategorien aus dem Kalender wurde dieser Event zugeordnet */
  categories?: Maybe<Array<Maybe<CalendarEventCategory>>>;
  /** Das Profil des Ansprechpartners/Verantwortlichen */
  contact?: Maybe<UserProfile>;
  /** Verantwortliche Gruppe */
  contactGroup?: Maybe<Group>;
  /** Verantwotliche Gruppe ID */
  contactGroupId?: Maybe<Scalars['ID']['output']>;
  /** Die Id des Profils der die Rolle des Ansprechpartners/Verantwortlichen hat */
  contactId?: Maybe<Scalars['String']['output']>;
  /** Ende des ersten Termins. Aus der Differenz zwischen Start und Ende werden jeweils die Endzeitpunkte für alle Serientermine abgeleitet */
  dateEnd?: Maybe<Scalars['Date']['output']>;
  /**
   * erstes bzw. einziges Datum der ersten Auftretens dieses Ereignisses
   * Die Darstellung bzw. Serialisierung in JSON erfolgt immer in UTC Zeitzone
   */
  dateStart?: Maybe<Scalars['Date']['output']>;
  /** RFC 5455 Darstellung der Ende-Zeit */
  dateTimeEnd?: Maybe<Scalars['String']['output']>;
  /** RFC 5455 reprensentation of the start date */
  dateTimeStart?: Maybe<Scalars['String']['output']>;
  /** Es gibt einen Anmeldeschluss Minuten vor Veranstaltungsbeginn */
  deadlineStartOffsetMinutes?: Maybe<Scalars['Int']['output']>;
  /** ausführlicher Beschreibungstext, der auch HTML Markup enthalten kann */
  description?: Maybe<Scalars['String']['output']>;
  /** Link zu weiterführenden Informationen */
  detailLink?: Maybe<Scalars['String']['output']>;
  /** Darf ein Feedback gegeben werden? */
  feedbackAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Verweis auf Icon Bild */
  iconImage?: Maybe<MediaReference>;
  /** Primärschlüssel */
  id: Scalars['ID']['output'];
  /**
   * Wenn gewünscht erhält jeder Teilnehmer eine Registrierungsbestätigung per Mail. Der darin enthaltene QR-Code
   * kann dann zum Check-In für den Termin genutzt werden.
   */
  issueTicketsUponRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Letzte änderung */
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  /** Ende Zeit im ISO-8601 Format, ohne Angabe der Zeitzone z.B 2007-12-03T11:15:30 */
  localDateTimeEnd?: Maybe<Scalars['LocalDateTime']['output']>;
  /**
   * Start Zeit im ISO-8601 Format, ohne Angabe der Zeitzone z.B 2007-12-03T10:15:30
   * Die entspricht der Zeit, so wie der Anwender sie in der Oberfläche eingegeben hat
   */
  localDateTimeStart?: Maybe<Scalars['LocalDateTime']['output']>;
  /** Angabe zum Ort */
  location?: Maybe<Location>;
  /** Teilnehmerliste führen */
  manageAttendees?: Maybe<Scalars['Boolean']['output']>;
  /** Anzahl der Begleitpersonen in einer Reservierung/Anmeldung */
  maxAdditionalSignUps?: Maybe<Scalars['Int']['output']>;
  /** Maximale Dauer in Minuten die eine Reservierung gültig ist */
  maxReservationTime?: Maybe<Scalars['Int']['output']>;
  /** maximale Anzahl erlaubte Teilnehmer. Wenn nicht gesetzt bedeutet dies, dass es keine Limitierung gibt. */
  maxSignUps?: Maybe<Scalars['Int']['output']>;
  /** Sichtbarkeitsregel für die Teilnehmerliste */
  memberListVisibility?: Maybe<MemberListVisibility>;
  /** Mindestteilnehmer Anzahl die erforderlich ist, damit der Event stattfinden kann. */
  minSignUps?: Maybe<Scalars['Int']['output']>;
  /** Ist es bei Reservierungen erlaubt, mehrere Teilnehmer (Gruppe/Familie) gleichzeitig anzumelden */
  multiSignUpAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Gibt an, ob bei einer Registrierung eine Benachrichtigung an den Verantwortlichen des Events geschickt werden soll. */
  notifyEventContactPersonOnSignUp?: Maybe<Scalars['Boolean']['output']>;
  /** Ist dies eine Online-Konferenz? */
  onlineConference?: Maybe<Scalars['Boolean']['output']>;
  /** Liefert zurück, ob bereits ein Feedback für den Termin abgegeben wurde */
  ownFeedback?: Maybe<CalendarEventFeedback>;
  /** liefert die Reservierungen, die der User zu diesem Event durchgeführt hat, also alle Plätze für sich und andere */
  ownRegistrations?: Maybe<Array<Maybe<CalendarEventRegistration>>>;
  /** Der Benutzer, der den Event erstellt hat */
  owner?: Maybe<UserProfile>;
  /** Shortcut für owner.id sofern keine Details des Profils benötigt werden */
  ownerId?: Maybe<Scalars['String']['output']>;
  /** Dokumentiert die Bezahlung bei Teilnahme */
  paymentDocumentation?: Maybe<Scalars['Boolean']['output']>;
  products?: Maybe<Array<Maybe<ProductDefinition>>>;
  /** sind öffentliche Anmeldungen erlaubt ? */
  publicRegistrationAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** aktuelle Anzahl an Registrierungen, also die Grösse der Teilnehmerliste */
  registrationCount?: Maybe<Scalars['Int']['output']>;
  /** Formular */
  registrationForm?: Maybe<CalendarRegistrationForm>;
  /** ID des Anmeldeformulars */
  registrationFormId?: Maybe<Scalars['ID']['output']>;
  /** sind Anmeldungen notwendig */
  registrationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Erinnerung */
  reminder?: Maybe<CalendarEventReminder>;
  /** Anzahl der Reservierungsanfragen und damit Indikator für die Nachfrage */
  requestCount?: Maybe<Scalars['Int']['output']>;
  /** weitere Anhänge (Bilder, Videos, Audios) für die Detail Ansicht */
  resources?: Maybe<Array<Maybe<MediaReference>>>;
  /** Sitzbelegung im Falle eines registrierungspflichtigen Events. Liefert '[ ]' für leere Sitze oder '[x]' mit der zugeordneten Kartennummer */
  seats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Serien Id wenn über eine Widerholung erzeugt */
  seriesId?: Maybe<Scalars['ID']['output']>;
  /** Anmeldebeginn (Offset in Minuten) vor Veranstaltungsbeginn */
  startOfRegistrationOffsetMinutes?: Maybe<Scalars['Int']['output']>;
  /** Untertitel */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** Zeitenzone, in welcher der Termin stattfindet */
  timeZoneId: Scalars['String']['output'];
  /**
   * Zeitzonen Offset zwischen UTC und der Zeitzone des Termins zum Zeitpunkt des Termins
   * unter Berücksichtigung von Sommer/Winterzeit
   * z.B +02:00 bedeutet UTC+2 Stunden
   */
  timeZoneOffset?: Maybe<Scalars['String']['output']>;
  /** der Titel */
  title: Scalars['String']['output'];
  /** Warteliste aktiviert? */
  waitingListEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CalendarEventCategory = {
  __typename?: 'CalendarEventCategory';
  /** Hintergrundfarbe des Markers */
  color?: Maybe<Scalars['Color']['output']>;
  /** Primärschlüssel */
  id: Scalars['ID']['output'];
  /** Bezeichnung zur Verwendung in der Legende */
  title?: Maybe<Scalars['String']['output']>;
};

export type CalendarEventCategoryInput = {
  /** Hintergrundfarbe des Markers */
  color?: InputMaybe<Scalars['Color']['input']>;
  /** Primärschlüssel, falls vorhanden. Wenn nicht gesetzt wird ein neues Object erstellt */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Bezeichnung zur Verwendung in der Legende */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Rückmeldung eines App-Nutzers zu einem Event */
export type CalendarEventFeedback = {
  __typename?: 'CalendarEventFeedback';
  /** Der App-Nutzer */
  client?: Maybe<UserProfileBasicData>;
  /** Kommentar des App-Nutzers */
  comment?: Maybe<Scalars['String']['output']>;
  /** Erstellungsdatum */
  creationDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Status */
  status?: Maybe<CalendarEventFeedbackStatus>;
};

/** Rückmeldung schicken */
export type CalendarEventFeedbackInput = {
  /** Kommentar des App-Nutzers */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status: CalendarEventFeedbackStatus;
};

export enum CalendarEventFeedbackStatus {
  /** Vielleicht */
  Maybe = 'MAYBE',
  /** Negatives Feedback */
  Negative = 'NEGATIVE',
  /** Ausstehend */
  Pending = 'PENDING',
  /** Positiv */
  Positive = 'POSITIVE'
}

/** Teilnahme Registrierung zu einem Event bzw. Position in der Warteliste */
export type CalendarEventRegistration = {
  __typename?: 'CalendarEventRegistration';
  /** Ereignis auf das sich diese Anmeldung bezieht */
  calendarEvent?: Maybe<CalendarEvent>;
  /** Id des Ereignis auf das sich diese Anmeldung bezieht */
  calendarEventId: Scalars['ID']['output'];
  /** Kalender auf den sich diese Anmeldung bezieht */
  calendarId?: Maybe<Scalars['ID']['output']>;
  /** Der bekannte App Nutzer "hinter" der clientId, der die Registrierung durchgeführt hat. */
  client?: Maybe<UserProfileBasicData>;
  /**
   * bekannter Benutzer(Profil) der die Registrierung durchgeführt hat. Der Benutzer muss nicht
   * selbst ein Teilnehmer sein.
   */
  clientId: Scalars['String']['output'];
  /** Hinweise des Buchenden zu seiner Anmeldung */
  comment?: Maybe<Scalars['String']['output']>;
  /**
   * Zeitpunkt an dem die Registrierung eingegangen ist. Dies ist wichtig für eine eventuelle Warteliste bei einem
   * Ereignis mit einer maximalen Teilnehmerzahl
   */
  creationDate?: Maybe<Scalars['Date']['output']>;
  /**
   * technische ID des Geräts mit dem die Anmeldung durchgeührt wurde
   * Dies kann dazu benutzt werden, dem Benutzer eine Bestätigung per Push Benachrichtigung zu senden.
   */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Additional custom fields */
  formData?: Maybe<Scalars['JSON']['output']>;
  /** Primärschlüssel */
  id: Scalars['ID']['output'];
  /** Dokumentiert ob der Teilnehmer bereits gezahlt hat. */
  payed?: Maybe<Scalars['Boolean']['output']>;
  /** Sitzplatzinformation zu der Reservierung */
  seat: Seat;
  /**
   * Der Status der Registrierungsanfrage. Entweder "CONFIRMED" wenn die Registrierung erfolgreich war oder ATTENDED
   * nachdem die Teilnahme bestätigt wurde.
   */
  status?: Maybe<Scalars['String']['output']>;
  /** Falls für die Registrierung ein Ticket gekauft wurde */
  ticket?: Maybe<Ticket>;
  /** Wenn der Status QUEUED ist. Position in der Warteschlange. Gibt 0 zurück, wenn der Platz nicht ermittelt werden konnte */
  waitingPosition?: Maybe<Scalars['Int']['output']>;
};

/**
 * Registrieungsanfrage zu einem Termin. Bei der Anfrage werden so viele 'Plätze' reserviert
 * wie es Teilnehmer in der Anfrage gibt. Die Registrierung gelingt nur dann, wenn noch ausreichendes
 * Kontingent für alle Teilnehmer in dieser Anfrage vorhanden ist. Je nachdem, ob für den
 * Termin eine Warteliste verwaltet werden soll, erhält man entsprechend eine Fehlermeldung oder
 * zugeteilte Positionen.
 * Je nach Einstellung des betreffenden Termins werden dabei nur registrierte Benutzerprofile zugelassen
 * oder die eingegeben Daten werden nicht validiert.
 */
export type CalendarEventRegistrationRequest = {
  /** optionale Liste der weiteren Teilnehmer bzw. Begleitpersonen */
  attendees?: InputMaybe<Array<InputMaybe<AttendeeInput>>>;
  /** Ereignis auf das sich diese Anmeldung bezieht */
  calendarEventId: Scalars['ID']['input'];
};

export type CalendarEventReminder = {
  __typename?: 'CalendarEventReminder';
  /** Aktiviert oder deaktiviert */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Nachricht */
  message?: Maybe<Scalars['String']['output']>;
  /** true, wenn eine Nachricht bereits verschickt wurde.  */
  triggered?: Maybe<Scalars['Boolean']['output']>;
  /** Wert in Tagen */
  value?: Maybe<Scalars['Int']['output']>;
};

export type CalendarEventReminderInput = {
  /** Aktivieren oder deaktivieren */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nachricht */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Wert in Tagen */
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** Vorlagen Event auf dessen Basis eine Instanz bzw. eine Serie erzeugt oder geändert werden soll. */
export type CalendarEventTemplate = {
  /** es handelt sich um einen ganztägigen Event */
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soll das event ein badge auslösen? */
  badgeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID des Kalenders. Wird nur benötigt, wenn ein Event bzw. eine Serie in einen anderen Kalender verschoben werden soll */
  calendarId?: InputMaybe<Scalars['ID']['input']>;
  /** Abmeldeschluss (Offset in Minuten) vor Veranstaltungsbeginn */
  cancelRegistrationDeadlineOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Liste der Kategorien (aus der Menge der beim dem Kalender hinterlegten) die dem Event zugeordnet werden sollen. */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Die Id der Gruppe, welches für dieses Event verantwortlich ist */
  contactGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Die Id des Profils der die Rolle des Ansprechpartners/Verantwortlichen hat */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** Optionaler Endzeitpunkt des Events */
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Datum des Events bzw. des ersten Auftretens im Fall einer Serie */
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  /** Es gibt einen Anmeldeschluss Minuten vor Veranstaltungsbeginn */
  deadlineStartOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** ausführlicher Beschreibungstext, der auch HTML Markup enthalten kann */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Link zu weiterführenden Informationen */
  detailLink?: InputMaybe<Scalars['String']['input']>;
  /** Darf ein Feedback gegeben werden? */
  feedbackAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gruppeneinladung */
  groupInvitation?: InputMaybe<Scalars['String']['input']>;
  /** Teilnehmer dieser Gruppe werden automatisch als Teilnehmer in dem Event eingetragen */
  groupRegistration?: InputMaybe<Scalars['ID']['input']>;
  /** optionale Referenz auf ein Vorschaubild */
  iconImage?: InputMaybe<MediaReferenceInput>;
  /**
   * Wenn gewünscht erhält jeder Teilnehmer eine Registrierungsbestätigung per Mail. Der darin enthaltene QR-Code
   * kann dann zum Check-In für den Termin genutzt werden.
   */
  issueTicketsUponRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  /** optionale Referenz zu einem Veranstaltungsort */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Teilnehmerliste führen */
  manageAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Anzahl der Begleitpersonen in einer Reservierung/Anmeldung */
  maxAdditionalSignUps?: InputMaybe<Scalars['Int']['input']>;
  /** Maximale Dauer in Minuten die eine Reservierung gültig ist */
  maxReservationTime?: InputMaybe<Scalars['Int']['input']>;
  /** maximale Anzahl erlaubte Teilnehmer. Wenn nicht gesetzt bedeutet dies, dass es keine Limitierung gibt. */
  maxSignUps?: InputMaybe<Scalars['Int']['input']>;
  /** Sichtbarkeitsregel für die Teilnehmerliste */
  memberListVisibility?: InputMaybe<MemberListVisibility>;
  /** Mindestteilnehmer Anzahl die erforderlich ist, damit der Event stattfinden kann. */
  minSignUps?: InputMaybe<Scalars['Int']['input']>;
  /** Ist es bei Reservierungen erlaubt, mehrere Teilnehmer (Gruppe/Familie) gleichzeitig anzumelden */
  multiSignUpAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gibt an, ob bei einer Registrierung eine Benachrichtigung an den Verantwortlichen des Events geschickt werden soll. */
  notifyEventContactPersonOnSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ist dies eine Online-Konferenz? Dadurch wird ein Raum im Jitsi gebucht. */
  onlineConference?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dokumentiert die Bezahlung bei Teilnahme */
  paymentDocumentation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Produkte */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** sind öffentliche Anmeldungen erlaubt ? */
  publicRegistrationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Formular, welches bei der Registrierung ausgefüllt werden muss. */
  registrationFormId?: InputMaybe<Scalars['ID']['input']>;
  /** erfordert die Teilname eine Registrierung ? */
  registrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reminder, wann die Teilnehmer an das Event erinnert werden sollen */
  reminder?: InputMaybe<CalendarEventReminderInput>;
  /** weitere Resource Referenzen für die Detailansicht */
  resources?: InputMaybe<Array<InputMaybe<MediaReferenceInput>>>;
  /**
   * for details to the RRULE syntax see https://jakubroztocil.github.io/rrule/
   * if this is set an implicit seriesId will be created that correlates
   * the cretaed instances.
   */
  rrule?: InputMaybe<Scalars['String']['input']>;
  /** Von welcher Application ging das erstellen aus? */
  sourceApplication?: InputMaybe<Scalars['String']['input']>;
  /** Anmeldebeginn (Offset in Minuten) vor Veranstaltungsbeginn */
  startOfRegistrationOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Untertitel */
  subTitle?: InputMaybe<Scalars['String']['input']>;
  /** Zeitenzone, in welcher der Termin stattfindet */
  timeZoneId?: Scalars['String']['input'];
  /** Aktuelles offset */
  timeZoneOffset?: InputMaybe<Scalars['String']['input']>;
  /** der Titel */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Warteliste aktiviert? */
  waitingListEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Eingabe Daten zur Erzeugung einer Kalender Instanz. */
export type CalendarInput = {
  /** Farbe des Kalenders */
  color?: InputMaybe<Scalars['Color']['input']>;
  /** Beschreibungstext für die Inhalte des Kalenders */
  description?: InputMaybe<Scalars['String']['input']>;
  /** iCalUrl */
  iCalUrl?: InputMaybe<Scalars['Url']['input']>;
  /** Gruppen, welche den Kalender lesen dürfen */
  readerGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Optionale Liste von Rollen Keys (aus der aktuellen App) für welche der Calender sichtbar sein soll.
   * Wenn nichts angegeben wird ist es damit ein öffentlicher Kalender.
   */
  readerRoles?: InputMaybe<Array<InputMaybe<Scalars['RoleRef']['input']>>>;
  /** Aufbewahrungsdauer (in Tagen) der Events */
  retainEventsForDays?: InputMaybe<Scalars['Int']['input']>;
  /** Titel des Kalenders */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Gruppen, welche den Kalender schreiben dürfen */
  writerGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * wenn gesetzt, dann können Einträge in diesem Kalender nur dann erzeugt bzw. bearbeitet werden, wenn
   * der Bearbeiter ein Profil mit mindestens einer der genannten Rollen hat.
   */
  writerRoles?: InputMaybe<Array<InputMaybe<Scalars['RoleRef']['input']>>>;
};

export type CalendarRegistrationForm = {
  __typename?: 'CalendarRegistrationForm';
  /** Feldkonfiguration */
  fields?: Maybe<Array<Maybe<WorksheetColumnMetaData>>>;
  /** Text nach dem Formular */
  footer?: Maybe<Scalars['String']['output']>;
  /** Text vor dem Formular */
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Name des Formulars */
  name?: Maybe<Scalars['String']['output']>;
  usedInEventsCount?: Maybe<Scalars['Long']['output']>;
};

export type CalendarRegistrationFormInput = {
  /** Feldkonfiguration */
  fields?: InputMaybe<Array<InputMaybe<WorksheetColumnMetaDataInput>>>;
  /** Text nach dem Formular */
  footer?: InputMaybe<Scalars['String']['input']>;
  /** Text vor dem Formular */
  header?: InputMaybe<Scalars['String']['input']>;
  /** Name des Formulars */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Ergebnis eines Captcha Requests in Form eines verfremdeten Bildes einer alphanumerischen Zeichenfolge. */
export type Captcha = {
  __typename?: 'Captcha';
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
};

export type CaptchaSolution = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type CartLineItem = {
  /** welches Produkt aus dem Sortiment */
  productDefinitionId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ChannelInfoInput = {
  /** Hintergrund-Farbe */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Hintergrund-Bild */
  backgroundImageId?: InputMaybe<Scalars['ID']['input']>;
  /** Beshreibung des Kanals */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Chat-Historie für alle Sichtbar oder erst ab Beitrittsdatum */
  historyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Icon-Bild */
  iconId?: InputMaybe<Scalars['ID']['input']>;
  /** Name des Kanals */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Unterstüzung von Beziehungen */
  supportRelatedProfiles?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Für den App-Nutzer im Kanal verfügbare Aktionen */
export type ChatActions = {
  __typename?: 'ChatActions';
  /** Erlaubt es alle Nachrichten im Chat zu löschen */
  clearMessages?: Maybe<Scalars['Boolean']['output']>;
  /** Erlaubt es Umfragen zu erstellen */
  createPoll?: Maybe<Scalars['Boolean']['output']>;
  /** Kann die Nachrichten anderer Nutzer löschen */
  deleteMsg?: Maybe<Scalars['Boolean']['output']>;
  /** Kann andere Nutzer in den Chat einladen */
  invite?: Maybe<Scalars['Boolean']['output']>;
  /** Kann andere Nutzer aus dem Chat entfernen */
  kick?: Maybe<Scalars['Boolean']['output']>;
  /** Kann selbst den Chat verlassen */
  leave?: Maybe<Scalars['Boolean']['output']>;
  /** Erlaubt es das Bild des Kanals und den Namen zu ändern */
  modifyChannelSettings?: Maybe<Scalars['Boolean']['output']>;
  /** Erlaubt es die Nachricht anzuheften */
  pin?: Maybe<Scalars['Boolean']['output']>;
  /** Erlaubt es in den Kanal zu schreiben */
  write?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatApplicationComponent = ApplicationComponent & {
  __typename?: 'ChatApplicationComponent';
  /** Direktkommunikation erlauben */
  allowDirectCommunication?: Maybe<Scalars['Boolean']['output']>;
  /** Multiuser conversationen erlauben */
  allowMultiUserConversations?: Maybe<Scalars['Boolean']['output']>;
  /** Umfragen für nicht admins erlauben */
  allowPollForNonAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Pseudonyme erlauben */
  allowPseudonyms?: Maybe<Scalars['Boolean']['output']>;
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Aufbewahrungsdauer (in Tagen) der Nachrichten */
  retainMessagesForDays?: Maybe<Scalars['Int']['output']>;
  /** Chatregeln */
  rulesPage?: Maybe<IwsFile>;
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
  /** Version des Chats */
  version?: Maybe<Scalars['Int']['output']>;
};

export type ChatApplicationComponentInput = {
  /** Direktkommunikation erlauben */
  allowDirectCommunication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Multiuser conversationen erlauben */
  allowMultiUserConversations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Umfragen für nicht admins erlauben */
  allowPollForNonAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pseudonyme erlauben */
  allowPseudonyms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aufbewahrungsdauer (in Tagen) der Nachrichten */
  retainMessagesForDays?: InputMaybe<Scalars['Int']['input']>;
  /** Chatregeln */
  rulesPageId?: InputMaybe<Scalars['ID']['input']>;
  /** Version des Chats */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatChannel = {
  __typename?: 'ChatChannel';
  /** Verfügbare Aktionen innerhalb des Kanals für den aktuelle Nutzer */
  actions?: Maybe<ChatActions>;
  /** Ist der Channel aktiv oder deaktiviert */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Admin-Gruppe */
  adminGroup?: Maybe<Group>;
  /** Admin-Gruppe */
  adminGroupId?: Maybe<Scalars['ID']['output']>;
  /** Admins */
  adminMemberIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Pseudonyme erlauben? */
  allowPseudonyms?: Maybe<Scalars['Boolean']['output']>;
  /** Zugewiesene Profile für den aktuellen Nutzer */
  assignedRelationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Nutzer in dieser Gruppe, werden automatisch am Kanal subscribed */
  autoSubscribedGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Nutzer mit dieser Rolle, werden automatisch am Kanal subscribed */
  autoSubscribedRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Löst die Bild-Resource auf */
  backgroundImage?: Maybe<MediaReference>;
  backgroundImageId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use backgroundImage instead. */
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  componentId?: Maybe<Scalars['String']['output']>;
  /** Bezeichnung */
  description?: Maybe<Scalars['String']['output']>;
  /** Direkte Admin-Profile */
  directAdminProfiles?: Maybe<Array<Maybe<UserProfile>>>;
  /** Direkte Admin-Profile */
  directAdminProfilesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Prüft ob das eine 1:1 Direktconversation ist */
  directConversation?: Maybe<Scalars['Boolean']['output']>;
  /** Name des Gruppenraumes (nur gefüllt, wenn es ein Group-Space-Chat) ist */
  groupSpaceName?: Maybe<Scalars['String']['output']>;
  /** Chat-Verlauf für alle sichtbar oder erst ab Beitrittsdatum */
  historyVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Löst die Bild-Resource auf */
  icon?: Maybe<MediaReference>;
  iconId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use icon instead. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** eindeutige Id der Komponente */
  id: Scalars['ID']['output'];
  /** Bezeichnung */
  label?: Maybe<Scalars['String']['output']>;
  /** Letzte veribindung im Kanal */
  lastConnected?: Maybe<Scalars['Date']['output']>;
  /** Letzte Nachricht im Kanal */
  lastMessage?: Maybe<ChatMessage>;
  /** Mitglieder des Kanals */
  members?: Maybe<Array<Maybe<ChatUserProfile>>>;
  /** Ist die Benachrichtigung für diesen Chat für den aktuellern Nutzer aktiv */
  notificationEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** PinCode zum Teilnehmen an der Gruppe */
  pinCode?: Maybe<Scalars['String']['output']>;
  /** Schreibgeschützt. (nur Admin kann schreiben) */
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Benötigt einen Code zum beitreten? */
  requiresPinCode?: Maybe<Scalars['Boolean']['output']>;
  /** Berechnete Anzahl an Teilnehmern */
  subscriptionsCount?: Maybe<Scalars['Long']['output']>;
  /** Werden Beziehungen unterstützt */
  supportRelatedProfiles?: Maybe<Scalars['Boolean']['output']>;
  /** Ungelesene Nachrichten */
  unreadMessages?: Maybe<Scalars['Int']['output']>;
  /** Gibt an welche Departments diesen Kanal sehen können */
  visibleByDepartments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Gibt an welche Rollen diesen Kanal sehen können */
  visibleByProfileRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ChatChannelInput = {
  /** Ist der Channel aktiv oder deaktiviert */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Admin-Gruppe */
  adminGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Pseudonyme erlauben? */
  allowPseudonyms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nutzer in dieser Gruppe, werden automatisch am Kanal subscribed */
  autoSubscribedGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Nutzer mit dieser Rolle, werden automatisch am Kanal subscribed */
  autoSubscribedRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundImageId?: InputMaybe<Scalars['ID']['input']>;
  /** Direkte Admin-Profile */
  directAdminProfilesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Chat-Verlauf für alle sichtbar oder erst ab Beitrittsdatum */
  historyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Löst die Bild-Resource auf */
  iconId?: InputMaybe<Scalars['ID']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Bezeichnung */
  label: Scalars['String']['input'];
  /** PinCode zum Teilnehmen an der Gruppe */
  pinCode?: InputMaybe<Scalars['String']['input']>;
  /** Schreibgeschützt. (nur Admin kann schreiben) */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Werden Beziehungen unterstützt */
  supportRelatedProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gibt an welche Departments diesen Kanal sehen können */
  visibleByDepartments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Gibt an welche Rollen diesen Kanal sehen können */
  visibleByProfileRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChatChannelInvitation = {
  __typename?: 'ChatChannelInvitation';
  /** Kanal */
  channel?: Maybe<ChatChannel>;
  /** Zeitpunkt der Einladung */
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Nachricht */
  message?: Maybe<Scalars['String']['output']>;
  /** Ziel */
  receiver?: Maybe<ChatUserProfile>;
  /** Absender */
  sender?: Maybe<ChatUserProfile>;
};

export type ChatChannelInvitationInput = {
  /** Kanal, kann auch leer sein beim öffnen einer 1:1 Direktkommunikation */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** Nachricht */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Ziel */
  receiverId: Scalars['ID']['input'];
};

export enum ChatChannelInvitationResponse {
  Accept = 'ACCEPT',
  Cancel = 'CANCEL',
  Decline = 'DECLINE'
}

export type ChatComponent = {
  __typename?: 'ChatComponent';
  accentColor?: Maybe<Scalars['String']['output']>;
  allowDirectCommunication?: Maybe<Scalars['Boolean']['output']>;
  allowGroups?: Maybe<Scalars['Boolean']['output']>;
  allowPoll?: Maybe<Scalars['Boolean']['output']>;
  allowPollForNonAdmin?: Maybe<Scalars['Boolean']['output']>;
  allowVideo?: Maybe<Scalars['Boolean']['output']>;
  appId: Scalars['AppID']['output'];
  /** @deprecated Field no longer supported */
  channels?: Maybe<Array<Maybe<ChatChannel>>>;
  /** Url zu der WebApp */
  chatHomeUrl?: Maybe<Scalars['String']['output']>;
  defaultAvatarUrl?: Maybe<Scalars['String']['output']>;
  helpPage?: Maybe<IwsFile>;
  helpPageId?: Maybe<Scalars['String']['output']>;
  helpPageUrl?: Maybe<Scalars['String']['output']>;
  /** eindeutige Id der Komponente */
  id: Scalars['ID']['output'];
  /** wann wurde die Komponente erstellt bzw. zuletzt geändert */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** wer hat die letzte Änderung durchgeführt */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  restrictDirectCommunicationToSameRole?: Maybe<Scalars['Boolean']['output']>;
  restrictedDirectCommunicationRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  restrictedShowContactRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rulePageUrl?: Maybe<Scalars['String']['output']>;
  rulesPage?: Maybe<IwsFile>;
  rulesPageId?: Maybe<Scalars['String']['output']>;
  showContacts?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ChatComponentInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  allowDirectCommunication?: InputMaybe<Scalars['Boolean']['input']>;
  allowGroups?: InputMaybe<Scalars['Boolean']['input']>;
  allowPoll?: InputMaybe<Scalars['Boolean']['input']>;
  allowPollForNonAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  allowVideo?: InputMaybe<Scalars['Boolean']['input']>;
  chatHomeUrl?: InputMaybe<Scalars['String']['input']>;
  defaultAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  helpPageId?: InputMaybe<Scalars['String']['input']>;
  helpPageUrl?: InputMaybe<Scalars['String']['input']>;
  restrictDirectCommunicationToSameRole?: InputMaybe<Scalars['Boolean']['input']>;
  restrictedDirectCommunicationRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  restrictedShowContactRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rulesPageId?: InputMaybe<Scalars['String']['input']>;
  showContacts?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  /** Content */
  body?: Maybe<Scalars['String']['output']>;
  /** Kanal-ID */
  chatId?: Maybe<Scalars['String']['output']>;
  /** Videokonferenz */
  conference?: Maybe<Conference>;
  /** Datum der Nachricht */
  created?: Maybe<Scalars['Date']['output']>;
  /** Externes Bild, beispielsweise für Tenor GiF */
  externalImage?: Maybe<Scalars['String']['output']>;
  /** Dateien, falls vorhanden */
  files?: Maybe<Array<Maybe<FsFile>>>;
  /** Absender Profil */
  from?: Maybe<ChatUserProfile>;
  /** Location des Nutzers */
  geo?: Maybe<ChatUserLocation>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Name */
  nickname?: Maybe<Scalars['String']['output']>;
  /** Angehefted */
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** wenn die Nachricht eine Umfrage ist, ansonsten null */
  poll?: Maybe<ChatPoll>;
  /** Antwort auf Nachricht */
  quotedMessage?: Maybe<ChatMessage>;
  /** Wie oft wurde welche Reaktion gewählt? */
  reactionCount?: Maybe<Array<Maybe<ReactionCount>>>;
  /** Reaktionen */
  reactions?: Maybe<Array<Maybe<ChatMessageReaction>>>;
  /** Gelesen von */
  readByProfiles?: Maybe<Array<Maybe<ChatUserProfile>>>;
  /** Absender */
  sender?: Maybe<Scalars['ID']['output']>;
  /** Base64-VCard */
  vCard?: Maybe<Scalars['String']['output']>;
  /** Name des Kontaktes */
  vCardName?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageInput = {
  /** Content */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Wenn eine Konferenz erstellt wurde und diese in der Nachricht angezeigt werden soll. */
  conferenceRoomName?: InputMaybe<Scalars['String']['input']>;
  /** Externes Bild, beispielsweise für Tenor GiF */
  externalImage?: InputMaybe<Scalars['String']['input']>;
  /** Dateien */
  files?: InputMaybe<Array<InputMaybe<Scalars['FSFileId']['input']>>>;
  /** Location des Nutzers */
  geo?: InputMaybe<ChatUserLocationInput>;
  /** Antwort auf Nachricht */
  quotedMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Base64-VCard */
  vCard?: InputMaybe<Scalars['String']['input']>;
  /** Name des Kontaktes */
  vCardName?: InputMaybe<Scalars['String']['input']>;
};

export enum ChatMessageOrder {
  Future = 'FUTURE',
  Past = 'PAST'
}

/** Eine Reaktion auf eine Chat-Nachricht */
export type ChatMessageReaction = {
  __typename?: 'ChatMessageReaction';
  reaction?: Maybe<ChatMessageReactionEnum>;
  sender?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
};

export enum ChatMessageReactionEnum {
  /**  👏 U+1F44F  */
  SmileyClap = 'SMILEY_CLAP',
  /**  😎 U+1F60E  */
  SmileyCool = 'SMILEY_COOL',
  /**  🔥 U+1F525  */
  SmileyFire = 'SMILEY_FIRE',
  /**  😊 U+1F60A  */
  SmileyHappy = 'SMILEY_HAPPY',
  /**  ❤️ U+2764  */
  SmileyHeart = 'SMILEY_HEART',
  /**  😂 U+1F602  */
  SmileyLaugh = 'SMILEY_LAUGH',
  /**  🧐 U+1F9D0  */
  SmileyMonocle = 'SMILEY_MONOCLE',
  /**  🥳 U+1F973  */
  SmileyParty = 'SMILEY_PARTY',
  /**  🙏 U+1F64F  */
  SmileyPray = 'SMILEY_PRAY',
  /**  😢 U+1F622  */
  SmileySad = 'SMILEY_SAD',
  /**  ⭐ U+2B50  */
  SmileyStar = 'SMILEY_STAR',
  /**  👎 U+1F44E  */
  SmileyThumbsdown = 'SMILEY_THUMBSDOWN',
  /**  👍 U+1F44D  */
  SmileyThumbsup = 'SMILEY_THUMBSUP',
  /**  😉 U+1F609  */
  SmileyWink = 'SMILEY_WINK'
}

/** Eine Reaktion auf eine Chat-Nachricht */
export type ChatMessageReactionInput = {
  reaction?: InputMaybe<ChatMessageReactionEnum>;
};

export type ChatMessageUpdateInput = {
  /** Angehefted */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Eine Umfrage */
export type ChatPoll = {
  __typename?: 'ChatPoll';
  channelId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<ChatPollOption>>>;
  owner?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerProfileImageThumbId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ChatPollSettings>;
  signups?: Maybe<Array<Maybe<ChatPollSignup>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ChatPollInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<ChatPollOptionInput>>>;
  settings?: InputMaybe<ChatPollSettingsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ChatPollOption = {
  __typename?: 'ChatPollOption';
  id?: Maybe<Scalars['ID']['output']>;
  maxSignups?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ChatPollOptionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  maxSignups?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ChatPollSettings = {
  __typename?: 'ChatPollSettings';
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  limitSignUpPerOptionEnabled?: Maybe<Scalars['Boolean']['output']>;
  limitSignUpPerUser?: Maybe<Scalars['Boolean']['output']>;
  polltype?: Maybe<Scalars['String']['output']>;
  polltypeDateTimeRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatPollSettingsInput = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  limitSignUpPerOptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  limitSignUpPerUser?: InputMaybe<Scalars['Boolean']['input']>;
  polltype?: InputMaybe<Scalars['String']['input']>;
  polltypeDateTimeRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatPollSignup = {
  __typename?: 'ChatPollSignup';
  id?: Maybe<Scalars['ID']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  ownerImageThumbId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pollId?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['JSON']['output']>;
};

export type ChatPollSignupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  ownerImageThumbId?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  pollId?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Scalars['JSON']['input']>;
};

export type ChatProfileRelation = {
  __typename?: 'ChatProfileRelation';
  /** Profil ID von welcher die Relation ausgeht */
  from?: Maybe<ChatUserProfile>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Zielprofil */
  to?: Maybe<ChatUserProfile>;
  /** Relations-Typ */
  type: UserProfileRelationType;
};

export type ChatProfileSettings = {
  __typename?: 'ChatProfileSettings';
  /** Chat-Regeln akzeptiert */
  chatRulesAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** Ändert den Nickname */
  nickname?: Maybe<Scalars['String']['output']>;
  /** Wenn aktiv, wird das aktuelle Profil im Chat-Nutzer-Verzeichnis nur für Mitglieder aus gemeinsamen Gruppen aufgeführt */
  restrictToOwnGroups?: Maybe<Scalars['Boolean']['output']>;
  /** Wenn aktiv, wird das aktuelle Profil im Chat-Nutzer-Verzeichnis aufgeführt */
  showInUserDirectory?: Maybe<Scalars['Boolean']['output']>;
  /** Soll der Nickname benutzt werden */
  useNickname?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatProfileSettingsInput = {
  /** Chat-Regeln akzeptiert */
  chatRulesAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ändert den Nickname */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Wenn aktiv, wird das aktuelle Profil im Chat-Nutzer-Verzeichnis nur für Mitglieder aus gemeinsamen Gruppen aufgeführt */
  restrictToOwnGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** Wenn aktiv, wird das aktuelle Profil im Chat-Nutzer-Verzeichnis aufgeführt */
  showInUserDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soll der Nickname benutzt werden */
  useNickname?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatUserLocation = {
  __typename?: 'ChatUserLocation';
  /** Breitengrad */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Längengrad */
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type ChatUserLocationInput = {
  /** Breitengrad */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Längengrad */
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type ChatUserProfile = {
  __typename?: 'ChatUserProfile';
  id?: Maybe<Scalars['String']['output']>;
  /** Bild des Chat-Profiles */
  image?: Maybe<MediaReference>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** RelatedProfiles */
  relations?: Maybe<Array<Maybe<ChatProfileRelation>>>;
};

/** Ein Sensor hat einen neuen Wert geliefert */
export type ChirpStackEvent = {
  __typename?: 'ChirpStackEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  metaData?: Maybe<Scalars['JSON']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type CloudflareStreamData = {
  __typename?: 'CloudflareStreamData';
  dashPlaybackUrl?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  hlsPlaybackUrl?: Maybe<Scalars['String']['output']>;
  pctComplete?: Maybe<Scalars['Float']['output']>;
  processingStatus?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

/**
 * Definition einer Aktivierungsmöglichkeit für eine Komponente. Eine Komponente kann über einen Link
 * (direct activation), einen QR-Code-Scan oder einen PIN-Code aktiviert werden.
 */
export type ComponentActivator = {
  __typename?: 'ComponentActivator';
  /** Kommentar: intern */
  comment?: Maybe<Scalars['String']['output']>;
  /** Komponente */
  componentId?: Maybe<Scalars['String']['output']>;
  /** wann wurde der Code erstellt */
  creationDate?: Maybe<Scalars['Date']['output']>;
  /** eindeutige Id */
  id: Scalars['ID']['output'];
  pinCode?: Maybe<Scalars['String']['output']>;
  /** Code */
  qrCode?: Maybe<Barcode>;
};

export type ComponentActivatorInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  pinCode?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentReference = {
  __typename?: 'ComponentReference';
  badgeEnabled?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconSet?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  state: ComponentState;
  title?: Maybe<Scalars['String']['output']>;
  type: ComponentReferenceType;
  typeMetaData?: Maybe<Scalars['String']['output']>;
  visibleByProfileGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  visibleByProfileRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ComponentReferenceType {
  About = 'About',
  Application = 'Application',
  BlueCode = 'BlueCode',
  BonusCampaign = 'BonusCampaign',
  BonusProgram = 'BonusProgram',
  Booklet = 'Booklet',
  Chat = 'Chat',
  ContactBook = 'ContactBook',
  Coupons = 'Coupons',
  Custom = 'Custom',
  DsawsIdCard = 'DSAWS_IDCard',
  FileShare = 'FileShare',
  Gallery = 'Gallery',
  Help = 'Help',
  ImageNavigation = 'ImageNavigation',
  InteractiveList = 'InteractiveList',
  ItemTracker = 'ItemTracker',
  List = 'List',
  Map = 'Map',
  Profile = 'Profile',
  PushHistory = 'PushHistory',
  Recommendation = 'Recommendation',
  ResourceUpload = 'ResourceUpload',
  TextImage = 'TextImage',
  TwoShotImageProvider = 'TwoShotImageProvider',
  WifiConnect = 'WIFIConnect',
  WikitudeAr = 'Wikitude_AR',
  WlanAccessComponent = 'WlanAccessComponent',
  Workbook = 'Workbook'
}

export enum ComponentState {
  Draft = 'DRAFT',
  Group = 'GROUP',
  Invisible = 'INVISIBLE',
  Profile = 'PROFILE',
  Public = 'PUBLIC'
}

/** collection of events that form a logical group. */
export type Conference = {
  __typename?: 'Conference';
  /** Aktive Teilnehmer */
  activeOccupants?: Maybe<Scalars['Int']['output']>;
  /** Ende der Konferenz */
  end: Scalars['Date']['output'];
  /** Öffentlicher Link zur Konferenz */
  guestUrl: Scalars['String']['output'];
  /** Konferenz-ID */
  id: Scalars['ID']['output'];
  /** Name des Raumes */
  room: Scalars['String']['output'];
  /** Privater Link zur Konferenz */
  url?: Maybe<Scalars['String']['output']>;
};

export type ConferenceInput = {
  /** Gültigkeit der Signatur. Maximal 24h in der Zukunft */
  end?: InputMaybe<Scalars['Date']['input']>;
  /** ID der Konferenz */
  id: Scalars['ID']['input'];
  /** Name der Konferenz, wird als Parameter in der URL übergeben */
  room?: InputMaybe<Scalars['String']['input']>;
};

/** Informationen zu einem Vertrag */
export type ContractInfo = {
  __typename?: 'ContractInfo';
  /** Vertragsnummer, welche auch in den Rechnungsnummern verwendet wird */
  contractNo: Scalars['Int']['output'];
  /** Termin bis zu dem Betriebskosten anfallen */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Start des Vertrages und damit Beginn der Betriebskosten */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** 'aktiv' oder 'gekündigt' */
  status: Scalars['String']['output'];
};

/** Ein Gutschein bzw. eine Vorlage dazu */
export type Coupon = {
  __typename?: 'Coupon';
  /** Gesetzt, wenn der Gutschein zu einem Bonusheft gehört */
  bonusBookletId?: Maybe<Scalars['ID']['output']>;
  /** Gesetzt, wenn der Gutschein zu einem Bonusprogram gehört */
  bonusProgramId?: Maybe<Scalars['ID']['output']>;
  /** Coupon-ID */
  couponSpecificationId?: Maybe<Scalars['ID']['output']>;
  /** Beschreibung des Gutscheins */
  description?: Maybe<Scalars['String']['output']>;
  /** true, wenn der Gutschein aktiv ist */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Ablaufdatum des Gutscheins */
  expireDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Resource>;
  /** Bild des Gutscheins */
  imageId?: Maybe<Scalars['ID']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  /** Letzte Änderung */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** Gutschein wird automatisch ausgegeben */
  startupCoupon?: Maybe<Scalars['Boolean']['output']>;
  /** Gutschein wrid ab Datum automatisch ausgegeben */
  startupCouponDispatchDate?: Maybe<Scalars['Date']['output']>;
  /** Gutschein-Status */
  status?: Maybe<CouponStatus>;
  /** Gutschein-Titel */
  title?: Maybe<Scalars['String']['output']>;
  /** Ist der Gutschein bereits eingelöst? */
  used?: Maybe<Scalars['Boolean']['output']>;
  /** Datum, wann der Gutschein eingelöst wurde */
  usedDate?: Maybe<Scalars['Date']['output']>;
  /** Wert des Gutscheins */
  value?: Maybe<Scalars['Int']['output']>;
};

export type CouponStatistic = {
  __typename?: 'CouponStatistic';
  /** davon aktiv */
  activeCoupons: Scalars['Int']['output'];
  /** eingelöste */
  cashedCoupons: Scalars['Int']['output'];
  /** Id der Gutschein-Vorlage */
  couponSpecificationId: Scalars['ID']['output'];
  couponUrl: Scalars['String']['output'];
  /** Anzahl der ausgegebenen Instanzen */
  dispatchedCoupons: Scalars['Int']['output'];
  /** abgelaufen */
  expiredCoupons: Scalars['Int']['output'];
  /** davon inaktiv */
  inactiveCoupons: Scalars['Int']['output'];
  /** Titel */
  title: Scalars['String']['output'];
};

export enum CouponStatus {
  /** Aktiv */
  Active = 'active',
  /** Abgelaufen */
  Expired = 'expired',
  /** Inaktiv */
  Inactive = 'inactive',
  /** Wird verarbeitet */
  Processing = 'processing',
  /** Bereits eingelöst */
  Used = 'used'
}

/** Gutschein-Vorlage auf dessen Basis die Gutschein Instanzen dann erzeugt werden */
export type CouponTemplate = {
  /** Beschreibung des Gutscheins */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Ablaufdatum des Gutscheins */
  expireDate?: InputMaybe<Scalars['Date']['input']>;
  /** Bild des Gutscheins */
  imageId: Scalars['ID']['input'];
  /** Gutschein wird automatisch ausgegeben */
  startupCoupon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gutschein wrid ab Datum automatisch ausgegeben */
  startupCouponDispatchDate?: InputMaybe<Scalars['Date']['input']>;
  /** Gutschein-Titel */
  title: Scalars['String']['input'];
  /** Wert des Gutscheins */
  value?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Felder, die bei einer Gutschein-Vorlage geändert werden können.
 * Änderungen greifen nicht für bereits vorhandene Gutschein-Instanuzen.
 */
export type CouponUpdate = {
  /** Beschreibung des Gutscheins */
  description: Scalars['String']['input'];
  /** Ablaufdatum des Gutscheins */
  expireDate: Scalars['Date']['input'];
  /** Bild des Gutscheins */
  imageId: Scalars['ID']['input'];
  /** Gutschein wird automatisch ausgegeben */
  startupCoupon: Scalars['Boolean']['input'];
  /** Gutschein wrid ab Datum automatisch ausgegeben */
  startupCouponDispatchDate: Scalars['Date']['input'];
  /** Gutschein-Titel */
  title: Scalars['String']['input'];
  /** Wert des Gutscheins */
  value: Scalars['Int']['input'];
};

export type CustomEnum = {
  __typename?: 'CustomEnum';
  id?: Maybe<Scalars['ID']['output']>;
  keys: Array<Maybe<Scalars['String']['output']>>;
  locales: Array<Maybe<Scalars['String']['output']>>;
  translations?: Maybe<Array<Maybe<EnumTranslation>>>;
};

/**
 * Zu einer Aufzählung, z.B Abteilungen oder angepasste Rollen werden
 * neue Keys eingefügt.
 */
export type CustomEnumKeyInput = {
  /** Die Id der Aufzählung */
  enumId: Scalars['String']['input'];
  /** Der technische Key des Wertes innerhalb der Aufzählung */
  enumKey: Scalars['String']['input'];
  locales: Array<InputMaybe<Scalars['String']['input']>>;
  /** Der die sprachabhängige Text zu dem enum */
  values: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Verweis auf einen Wert in einer benutzerdefinierten Aufzählung */
export type CustomEnumValue = {
  __typename?: 'CustomEnumValue';
  /** Die Id der Aufzählung */
  enumId?: Maybe<Scalars['String']['output']>;
  /** Der technische Key des Wertes innerhalb der Aufzählung */
  enumKey?: Maybe<Scalars['String']['output']>;
  /** Der die sprachabhängige Text zu dem enum */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input type zum Erzeugen einer benutzeer definierten Aufzählung */
export type CustomEnumValueInput = {
  enumId?: InputMaybe<Scalars['String']['input']>;
  enumKey?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Datenschutzeinstellungen */
export type DataConsentInput = {
  privacy?: InputMaybe<DataConsentPageInput>;
  termsOfUse?: InputMaybe<DataConsentPageInput>;
};

/** Datenschutzseite */
export type DataConsentPageInput = {
  /** Datenschutzseite, ID der Ressource */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Konfiguriert ob die Datenschutzseite beim Start der App angezeigt wird. */
  showOnAppStart?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vesion der privacy page */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type DataContent = {
  __typename?: 'DataContent';
  privacy?: Maybe<DataContentPage>;
  termsOfUse?: Maybe<DataContentPage>;
};

/** Datenschutzseite */
export type DataContentPage = {
  __typename?: 'DataContentPage';
  /** Datenschutzseite */
  resource?: Maybe<IwsFile>;
  /** Datenschutzseite-ID */
  resourceId?: Maybe<Scalars['String']['output']>;
  /** Url */
  resourceUrl?: Maybe<Scalars['String']['output']>;
  /** Konfiguriert ob die Datenschutzseite beim Start der App angezeigt wird. */
  showOnAppStart?: Maybe<Scalars['Boolean']['output']>;
  /** Vesion der privacy page */
  version?: Maybe<Scalars['Int']['output']>;
};

/** Definition eines Zeitraums, um Abfragen zeitlich einzugrenzen. [from >= datum <= to] */
export type DateRange = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  adminDevice?: Maybe<Scalars['Boolean']['output']>;
  aosPushToken?: Maybe<Scalars['String']['output']>;
  appId: Scalars['String']['output'];
  created?: Maybe<Scalars['Date']['output']>;
  deviceId: Scalars['String']['output'];
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceSystem?: Maybe<Scalars['String']['output']>;
  iosPushToken?: Maybe<Scalars['String']['output']>;
  lastConnect?: Maybe<Scalars['Date']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
};

/** Eine Kurzinfo zu einem mit dem Benutzerprofil verknüpften Gerät */
export type DeviceSummary = {
  __typename?: 'DeviceSummary';
  deviceId: Scalars['String']['output'];
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceSystem?: Maybe<Scalars['String']['output']>;
  lastConnect?: Maybe<Scalars['Date']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
};

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DispatchMode {
  /** nur admin Geräte */
  AdminDevices = 'adminDevices',
  /** Alle Geräte der App */
  All = 'all',
  /** User, die den Gutschein noch nicht hatten */
  CustomersNeverHadCoupon = 'customersNeverHadCoupon',
  /** Benutzer ohne einen aktiven Gutschein */
  CustomersNoActive = 'customersNoActive',
  /** App-Nutzer, die Mitglied in einer der genannten Gruppen sind */
  GroupMembers = 'groupMembers',
  /** App-Nutzer, die eine der genannten Rollen haben */
  RoleMembers = 'roleMembers'
}

export type Division = {
  __typename?: 'Division';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DownloadHistory = {
  __typename?: 'DownloadHistory';
  appId: Scalars['AppID']['output'];
  /** der historische Verlauf */
  history?: Maybe<Array<Maybe<DownloadHistoryEntry>>>;
};

export type DownloadHistoryEntry = {
  __typename?: 'DownloadHistoryEntry';
  android: Scalars['Int']['output'];
  ios: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/** spezielle TimeSeries welche den Installationsverlauf je App und Tag enthält. Siehe Dashboard/Download Statistik */
export type DownloadStatsData = {
  __typename?: 'DownloadStatsData';
  /** Summe der Android Installationen */
  android: Scalars['Int']['output'];
  /** Auf wievielen Android-Geräten wurde die App an diesem Tag neu installiert */
  android_delta: Scalars['Int']['output'];
  appId: Scalars['AppID']['output'];
  /** Der Tag in ISO Form JJJJ-MM-DD */
  day?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Summe der IOS Installationen */
  ios: Scalars['Int']['output'];
  /** Auf wievielen iOS-Geräten wurde die App an diesem Tag neu installiert */
  ios_delta: Scalars['Int']['output'];
  /** Summierte Anzahl der bekannten Installationen */
  total: Scalars['Int']['output'];
  ts: Scalars['Date']['output'];
};

export type EnumTranslation = {
  __typename?: 'EnumTranslation';
  label?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  map?: Maybe<Scalars['JSON']['output']>;
};

export type EnumValue = {
  __typename?: 'EnumValue';
  /** Der technische Key des Wertes innerhalb der Aufzählung */
  key?: Maybe<Scalars['String']['output']>;
  /** Der die sprachabhängige Text zu dem enum */
  value?: Maybe<Scalars['String']['output']>;
};

export type FsFile = {
  __typename?: 'FSFile';
  /** Der Alternative text für Screenreader */
  altText?: Maybe<Scalars['String']['output']>;
  /** Größe der Datei */
  contentLength?: Maybe<Scalars['Long']['output']>;
  /** Mimetype des Files, z.B application/pdf. Nicht gesetzt Bei Foldern */
  contentType?: Maybe<Scalars['String']['output']>;
  /** Erstellt am */
  created?: Maybe<Scalars['Date']['output']>;
  /** Erstellt von */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** true, wenn es ein Verzeichnis ist */
  directory?: Maybe<Scalars['Boolean']['output']>;
  /** Das Property displayName stellt den benutzerdefinierten Namen eines Objekts oder einer Datei dar, der zur Anzeige in der Benutzeroberfläche verwendet wird. Dieser Name kann vom Benutzer bearbeitet werden und dient ausschließlich der visuellen Darstellung, ohne den tatsächlichen System- oder Dateinamen zu beeinflussen. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** URL of the file */
  downloadUrl?: Maybe<Scalars['Url']['output']>;
  /** eTag */
  eTag?: Maybe<Scalars['String']['output']>;
  /** Id des FileStores zu dem dieses File gehört */
  fsId: Scalars['FSId']['output'];
  /** Id des Files */
  id: Scalars['FSFileId']['output'];
  /** Zuletzt geändert */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** Zuletzt geändert von */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Der Dateiname, der angezeigt werden soll */
  name: Scalars['String']['output'];
  /** Falls, es ein Video oder Audio ist, könnte eine optimierte Version zur Verfügung stehen */
  optimizedUrl?: Maybe<Scalars['Url']['output']>;
  /** Id des übergeordneten Folders oder Null, wenn auf der Root Ebene */
  parentId?: Maybe<Scalars['FSFileId']['output']>;
  /** Status der Datei */
  status?: Maybe<FsFileStatus>;
  /** Vorschaubild */
  thumbnailImageUrl?: Maybe<Scalars['Url']['output']>;
  /** Put-URL to update the file */
  uploadUrl?: Maybe<Scalars['Url']['output']>;
};

export enum FsFileStatus {
  /** File noch nicht hochgeladen */
  Pending = 'PENDING',
  /** File vollständig hochgeladen */
  Ready = 'READY',
  /** Upload läuft */
  Uploaded = 'UPLOADED'
}

/** Upload */
export type FsFileUpdateInput = {
  /** Der Alternative Text für Screenreader */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** Das Property displayName stellt den benutzerdefinierten Namen eines Objekts oder einer Datei dar, der zur Anzeige in der Benutzeroberfläche verwendet wird. Dieser Name kann vom Benutzer bearbeitet werden und dient ausschließlich der visuellen Darstellung, ohne den tatsächlichen System- oder Dateinamen zu beeinflussen. */
  displayName?: InputMaybe<Scalars['String']['input']>;
};

/** Upload */
export type FsFileUploadRequest = {
  /** Größe der Datei */
  contentLength?: InputMaybe<Scalars['Long']['input']>;
  /** Mimetype des Files, z.B application/pdf. Nicht gesetzt Bei Foldern */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Das Property displayName stellt den benutzerdefinierten Namen eines Objekts oder einer Datei dar, der zur Anzeige in der Benutzeroberfläche verwendet wird. Dieser Name kann vom Benutzer bearbeitet werden und dient ausschließlich der visuellen Darstellung, ohne den tatsächlichen System- oder Dateinamen zu beeinflussen. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Der Dateiname, der angezeigt werden soll */
  name: Scalars['String']['input'];
};

export type FacebookCollection = {
  __typename?: 'FacebookCollection';
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FacebookLongLiveAccessToken = {
  __typename?: 'FacebookLongLiveAccessToken';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  tokenExpired?: Maybe<Scalars['Boolean']['output']>;
};

/** minimale Angaben zur Erzeugung des Profils eines Familienmitgliedes. In der Regel Kinder, die noch keine eigene Mail Adresse haben. */
export type FamilyMemberInput = {
  /** Geburtsdatum */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /** email Adresse muss bei der Neuanlage zwingend mitgegeben werden */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Vorname */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Mitgliedsnummer. */
  membershipNumber?: InputMaybe<Scalars['String']['input']>;
  /** Nachname */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Anrede */
  salutation?: InputMaybe<CustomEnumValueInput>;
};

export type FileRef = {
  __typename?: 'FileRef';
  /** Kommentar */
  comment?: Maybe<Scalars['String']['output']>;
  /** Grösse in Bytes */
  contentLength?: Maybe<Scalars['Int']['output']>;
  /** mimeType */
  contentType?: Maybe<Scalars['String']['output']>;
  /** Benutzer, der die Datei erzeugt hat */
  creator?: Maybe<Scalars['String']['output']>;
  /** Anzeigename */
  displayName?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  /** Daten der letzen Änderung */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** Dateiname */
  name: Scalars['String']['output'];
  /** signierte URL it zeitlich begrenzter Gültigkeit */
  url?: Maybe<Scalars['String']['output']>;
  /** vom User vergebene Tags/Suchfilter */
  userDefinedTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Sichtbarkeit */
  visibility?: Maybe<FileVisibility>;
  /** welche Rollen, dürfen die Datei sehen */
  visibilityRoles?: Maybe<Array<Maybe<CustomEnumValue>>>;
};

/** Angaben zur Neu-Erzeugung bzw. Update */
export type FileRefInput = {
  /** Kommentar */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Anzeigename */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Dateiname */
  name: Scalars['String']['input'];
  /** vom User vergebene Tags/Suchfilter */
  userDefinedTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sichtbarkeit */
  visibility?: InputMaybe<FileVisibility>;
  /** welche Rollen, dürfen die Datei sehen. Nur die Keys bezogen auf das App eigene Role Enum */
  visibilityRoleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Informationen, die bei einem bestehenden File geändert werden können */
export type FileRefUpdate = {
  /** Kommentar */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** der Anzeigename */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** existierendes File */
  id: Scalars['ID']['input'];
  /** vom User vergebene Tags/Suchfilter */
  userDefinedTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sichtbarkeit */
  visibility?: InputMaybe<FileVisibility>;
  /** welche Rollen, dürfen die Datei sehen. Nur die Keys bezogen auf das App eigene Role Enum */
  visibilityRoleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FileShareComponent = {
  __typename?: 'FileShareComponent';
  /** Ids der Profile mit Admin Rechten */
  adminProfiles?: Maybe<Array<Maybe<UserProfile>>>;
  /** zu welcher App gehört die Komponente */
  appId: Scalars['AppID']['output'];
  /** URL zum Einstieg in index Seite */
  fileShareHomeUrl?: Maybe<Scalars['String']['output']>;
  /** die Files */
  files?: Maybe<Array<Maybe<FileRef>>>;
  /** eindeutige Id der Komponente */
  id: Scalars['ID']['output'];
  /** verfügbarer Speicher in MB */
  quotaMB?: Maybe<Scalars['Int']['output']>;
  /** welche Rollen dürfen Daten hochladen */
  uploaderRoles?: Maybe<Array<Maybe<CustomEnumValue>>>;
};

export type FileShareComponentSettings = {
  /** wer sind die Admins */
  adminProfileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** welche Rollen dürfen Daten hochladen */
  uploaderRoleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FileStore = {
  __typename?: 'FileStore';
  /** Erlaubte Dateitypen */
  acceptedFileTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Die Files in undefinierter Reihenfolge, da die Sortierung in der Oberfläche erfolgt */
  files?: Maybe<Array<Maybe<FsFile>>>;
  /** eindeutige Id. Diese ist identisch mit der Id des 'Besitzers' also z.B einer Gruppe oder einem User Profil */
  id: Scalars['ID']['output'];
  /** Hat Zugriff auf die Protokolle */
  operationLogAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Hat der aktuelle Nutzer Schreibzugriff */
  writeAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type FileStoreApplicationComponent = ApplicationComponent & {
  __typename?: 'FileStoreApplicationComponent';
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Leseberechtigte Gruppen */
  readerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
  /** Schreibberechtigte Gruppen */
  writerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FileStoreApplicationComponentUpdate = {
  /** Leseberechtigte Gruppen */
  readerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Schreibberechtigte Gruppen */
  writerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FileStoreOperationLog = {
  __typename?: 'FileStoreOperationLog';
  /** Erstellt am */
  created?: Maybe<Scalars['Date']['output']>;
  /** Name der Destination */
  destination?: Maybe<Scalars['String']['output']>;
  /** Wenn Datei noch existiert */
  downloadUrl?: Maybe<Scalars['Url']['output']>;
  /** Wer hat die Operation durchgeführt */
  executor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Typ der Operation */
  operationType?: Maybe<FileStoreOperationType>;
  /** Name der Quelle */
  source?: Maybe<Scalars['String']['output']>;
};

export enum FileStoreOperationType {
  /** Änderung des Alternativen Texts für Screenreader */
  ChangeAltText = 'CHANGE_ALT_TEXT',
  /** Änderung des Display names */
  ChangeDisplayName = 'CHANGE_DISPLAY_NAME',
  /** Verzeichnis erstellt */
  CreateDirectory = 'CREATE_DIRECTORY',
  /** Datei erstellt */
  CreateFile = 'CREATE_FILE',
  /** Löschoperation */
  Delete = 'DELETE',
  /** Verschiebeoperation */
  Move = 'MOVE',
  /** Rename-Operation */
  Rename = 'RENAME'
}

export enum FileVisibility {
  Admin = 'ADMIN',
  Public = 'PUBLIC',
  WithProfile = 'WITH_PROFILE',
  WithRole = 'WITH_ROLE'
}

export type Gallery = {
  __typename?: 'Gallery';
  appId: Scalars['AppID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<GalleryData>>>;
  id: Scalars['ID']['output'];
  /** wann wurde die Komponente erstellt bzw. zuletzt geändert */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** wer hat die letzte Änderung durchgeführt */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Network configurationId */
  socialNetworkCollectionId?: Maybe<Scalars['String']['output']>;
  /** Network configurationId */
  socialNetworkConfigurationId?: Maybe<Scalars['String']['output']>;
  /** Zeigt an, wann die Galerie zuletzt synchronisiert wurde */
  socialNetworkLastSync?: Maybe<Scalars['Date']['output']>;
  /** Letzter Fehler bei der synchronisation */
  socialNetworkSyncError?: Maybe<Scalars['String']['output']>;
  /** Erlaubt das Teilen der Bilder */
  socialShare?: Maybe<Scalars['Boolean']['output']>;
  /** Video-Unterstützung */
  videoSupport?: Maybe<Scalars['Boolean']['output']>;
};

export type GalleryAlbum = {
  __typename?: 'GalleryAlbum';
  appId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  mediaData?: Maybe<Array<Maybe<GalleryAlbumMediaData>>>;
  newsSourceId?: Maybe<Scalars['String']['output']>;
  previewImageRef?: Maybe<MediaReference>;
  readerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  videoCount?: Maybe<Scalars['Int']['output']>;
  writerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Input Daten, um ein neues Album anzulegen oder eins zu editieren. */
export type GalleryAlbumDataInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  mediaData?: InputMaybe<Array<InputMaybe<GalleryAlbumMediaDataInput>>>;
  newsSourceId?: InputMaybe<Scalars['String']['input']>;
  previewImageId?: InputMaybe<Scalars['String']['input']>;
  readerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  writerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GalleryAlbumMediaData = {
  __typename?: 'GalleryAlbumMediaData';
  entryCreated?: Maybe<Scalars['Date']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  mediaRef?: Maybe<MediaReference>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Input Daten der Medien eines Albums. */
export type GalleryAlbumMediaDataInput = {
  entryCreated?: InputMaybe<Scalars['Date']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  mediaRefId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum GalleryAlbumVisualizationType {
  /** Bilderanzeige mit einem Bild pro Zeile */
  OneImagePerColumn = 'ONE_IMAGE_PER_COLUMN',
  /** Bilderanzeige wie in dynamischer Galerie v3 */
  PatternInColumn = 'PATTERN_IN_COLUMN',
  /** Vorschau Bild und darunter ein Slider */
  PreviewWithSlider = 'PREVIEW_WITH_SLIDER',
  /** Bilderanzeige mit zwei Bildern pro Zeile */
  TwoImagesPerColumn = 'TWO_IMAGES_PER_COLUMN'
}

export type GalleryApplicationComponent = ApplicationComponent & {
  __typename?: 'GalleryApplicationComponent';
  allowShare?: Maybe<Scalars['Boolean']['output']>;
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
  /** Liste der IDs der verwendeten GalleryAlben */
  usedAlbumIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  visualization?: Maybe<GalleryAlbumVisualizationType>;
};

export type GalleryApplicationComponentUpdate = {
  /** Teilen der Bilder ist erlaubt */
  allowShare?: InputMaybe<Scalars['Boolean']['input']>;
  /** Liste der zu verwendenden Datenquellen */
  usedAlbumIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Text der über den Newsbeiträgen angezeigt wird */
  visualization?: InputMaybe<GalleryAlbumVisualizationType>;
};

export type GalleryData = GalleryImageData | GalleryVideoData;

/** Daten zur Erzeugung einer neuen Bild-Referenz innerhalb einer Galerie */
export type GalleryDataInput = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: GalleryDataType;
  /** Sind nur beim Video Type relevant */
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum GalleryDataType {
  /** Ein Bild */
  Image = 'IMAGE',
  /** ein Video */
  Video = 'VIDEO'
}

export type GalleryImageData = {
  __typename?: 'GalleryImageData';
  imageId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GalleryDataType>;
};

export type GalleryInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Array<InputMaybe<GalleryDataInput>>>;
  /** Network configurationId */
  socialNetworkCollectionId?: InputMaybe<Scalars['String']['input']>;
  /** Network configurationId */
  socialNetworkConfigurationId?: InputMaybe<Scalars['String']['input']>;
  /** Erlaubt das teilen von Bildern */
  socialShare?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soll die Galerie Videos unterstützen? */
  videoSupport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GalleryVideoData = {
  __typename?: 'GalleryVideoData';
  imageId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GalleryDataType>;
  videoId?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type GenericRow = {
  __typename?: 'GenericRow';
  autoId?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastModified?: Maybe<Scalars['Date']['output']>;
  sheet?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userProfile?: Maybe<UserProfileBasicData>;
  userProfileId?: Maybe<Scalars['String']['output']>;
};

/** Eine Gruppe von Benutzern, z.B eine Manschaft oder eine Abteilung */
export type Group = {
  __typename?: 'Group';
  /** gehört zu welcher App */
  appId: Scalars['AppID']['output'];
  /** Individuelle Beschreibung der Gruppe */
  description?: Maybe<Scalars['String']['output']>;
  /** Ist ein Group-Space angelegt? */
  groupSpaceEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Falls ein Gruppenraum existiert, wird der Name geliefert */
  groupSpaceName?: Maybe<Scalars['String']['output']>;
  /** Gruppensymbol */
  icon?: Maybe<Resource>;
  /** Gruppensymbol-Id */
  iconId?: Maybe<Scalars['String']['output']>;
  /** technische ID */
  id: Scalars['ID']['output'];
  /** Schlüssel/Kürzel, welches beim Excel Import von Benutzern verwendet wird, um Gruppenmitgliedschaften zu erstellen */
  key?: Maybe<Scalars['String']['output']>;
  /** Ist das aktuelle Profil Gruppenleiter */
  leader?: Maybe<Scalars['Boolean']['output']>;
  /** Ids der Gruppenleiter */
  leaderIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Gruppeleiter */
  leaders?: Maybe<Array<Maybe<UserProfileBasicData>>>;
  /** Gruppe soll gelistet werden */
  listedGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Mitglieder der Gruppe */
  memberIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Profile der Mitglieder der Gruppe */
  members?: Maybe<Array<Maybe<UserProfileBasicData>>>;
  /** Name der Grupe */
  name: Scalars['String']['output'];
  /** Anzahl der Mitglieder */
  numberOfMembers?: Maybe<Scalars['Int']['output']>;
  /** In öffentliche Gruppen kann man ohne Einladung / Anfrage eintreten */
  publicGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Rollenbasierte Gruppe */
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Gibt ab, ob es sich um eine Systemrolle handelt. Diese können aus dem System nicht gelöscht werden. */
  system?: Maybe<Scalars['Boolean']['output']>;
};

export type GroupAccessInvitationRequestInput = {
  groupId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  /** E-Mail-Adresse */
  recipient?: InputMaybe<Scalars['String']['input']>;
};

export type GroupAccessRequest = {
  __typename?: 'GroupAccessRequest';
  creationDate: Scalars['Date']['output'];
  group?: Maybe<Group>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  inquirer?: Maybe<UserProfile>;
  inquirerId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type GroupAccessRequestAnswerInput = {
  answer: GroupAccessRequestAnswerType;
  message?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};

export enum GroupAccessRequestAnswerType {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type GroupAccessRequestInput = {
  groupId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Input zum Erzeugen einer Gruppe */
export type GroupInput = {
  /** Individuelle Beschreibung der Gruppe */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Aktiviert / Deaktiviert den Group Space */
  groupSpaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gruppensymbol-Id */
  iconId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  leaderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Soll diese Gruppe in der Gruppensuche aufgelistet werden */
  listedGroup?: InputMaybe<Scalars['Boolean']['input']>;
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
  /** In öffentliche Gruppen kann man ohne Einladung / Anfrage eintreten */
  publicGroup?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GroupSpace = {
  __typename?: 'GroupSpace';
  /** Badge des Spaces */
  badge?: Maybe<Scalars['Int']['output']>;
  /** Videokonferenz */
  conferenceRoom?: Maybe<Conference>;
  /** Videokonferenz aktiviert */
  conferenceRoomEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Beschreibung */
  description?: Maybe<Scalars['String']['output']>;
  /** FileStore Aktiviert */
  fileStoreEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Wenn gesetzt, dürfen alle Mitglieder Schreiboperationen auf dem Filestore durchführen. Wenn nicht, dürfen nur die Gruppenleiter Schreiboperationen durchführen. */
  fileStoreMembersWrite?: Maybe<Scalars['Boolean']['output']>;
  /** Bild */
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** Ist das aktuelle Profil Gruppenleiter */
  leader?: Maybe<Scalars['Boolean']['output']>;
  /** Gruppenleiter */
  leaders?: Maybe<Array<Maybe<UserProfileBasicData>>>;
  /** alle Referenzierten Module bzw. Chat-Kanäle */
  links?: Maybe<Array<Maybe<GroupSpaceLink>>>;
  /** Mitglieder */
  members?: Maybe<Array<Maybe<UserProfileBasicData>>>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Name of the Group */
  originalGroupName?: Maybe<Scalars['String']['output']>;
  /** Unterstüzung von Beziehungen */
  supportRelatedProfiles?: Maybe<Scalars['Boolean']['output']>;
  /** Unterstüzung von Beziehungen. Eingeschränkt auf Leaders */
  supportRelatedProfilesRestricted?: Maybe<Scalars['Boolean']['output']>;
};

export type GroupSpaceApplicationComponent = ApplicationComponent & {
  __typename?: 'GroupSpaceApplicationComponent';
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
};

export type GroupSpaceLink = {
  __typename?: 'GroupSpaceLink';
  /** Badge-Value */
  badge?: Maybe<Scalars['Int']['output']>;
  /** eindeutige Id des Links innerhalb des Group Spaces */
  id?: Maybe<Scalars['ID']['output']>;
  /** Mode der externen Url */
  linkMode?: Maybe<Scalars['String']['output']>;
  /** Art des Ziels */
  linkType?: Maybe<GroupSpaceLinkType>;
  /** Beschriftung des Buttons */
  name?: Maybe<Scalars['String']['output']>;
  /** Das referenzierte Objekt gehört dem Gruppenraum und wird entfernen gelöscht */
  ownedByGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Zielobjekt innerhalb des Moduls */
  target?: Maybe<Scalars['String']['output']>;
  /** Modul das angesprungen werden soll */
  targetComponentId?: Maybe<Scalars['String']['output']>;
};

export enum GroupSpaceLinkType {
  AppointmentModule = 'APPOINTMENT_MODULE',
  ChatChannel = 'CHAT_CHANNEL',
  ExternalUrl = 'EXTERNAL_URL',
  ProfileModule = 'PROFILE_MODULE'
}

export type GroupSpaceUpdate = {
  /** Videokonferenz aktiviert */
  conferenceRoomEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Beschreibung */
  description?: InputMaybe<Scalars['String']['input']>;
  /** FileStore Aktiviert */
  fileStoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Wenn gesetzt, dürfen alle Mitglieder Schreiboperationen auf dem Filestore durchführen. Wenn nicht, dürfen nur die Gruppenleiter Schreiboperationen durchführen. */
  fileStoreMembersWrite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aktualisiert das Dashboard Bild */
  headerImageUpload?: InputMaybe<Scalars['UploadId']['input']>;
  /** Ändert den Namen */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Unterstüzung von Beziehungen */
  supportRelatedProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterstüzung von Beziehungen. Eingeschränkt auf Leaders */
  supportRelatedProfilesRestricted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Eine Tabelle zu einem Team */
export type GroupTableDto = {
  __typename?: 'GroupTableDTO';
  championshipRegion?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupNickname?: Maybe<Scalars['String']['output']>;
  list?: Maybe<Array<Maybe<GroupTableTeamDto>>>;
  seasonNickname?: Maybe<Scalars['String']['output']>;
};

/** Informationen zu einem Team im Kontext einer Tabelle */
export type GroupTableTeamDto = {
  __typename?: 'GroupTableTeamDTO';
  /** Begegnungen */
  meetings?: Maybe<Scalars['Int']['output']>;
  /** Gegentore */
  otherMatches?: Maybe<Scalars['Int']['output']>;
  /** Niederlagen */
  otherMeetings?: Maybe<Scalars['Int']['output']>;
  otherPoints?: Maybe<Scalars['Float']['output']>;
  /** eigene Tore */
  ownMatches?: Maybe<Scalars['Int']['output']>;
  ownMatchesSingle?: Maybe<Scalars['Int']['output']>;
  /** Siege */
  ownMeetings?: Maybe<Scalars['Int']['output']>;
  ownPoints?: Maybe<Scalars['Float']['output']>;
  /** Rang */
  tableRank?: Maybe<Scalars['Int']['output']>;
  /** Name des Teams */
  team: Scalars['String']['output'];
  teamId?: Maybe<Scalars['String']['output']>;
  teamNr?: Maybe<Scalars['Int']['output']>;
  teamUri?: Maybe<Scalars['String']['output']>;
  /** Untentschieden */
  tieMeetings?: Maybe<Scalars['Int']['output']>;
};

/** Ergebnis einer IBAN Validierung */
export type IbanValidationResult = {
  __typename?: 'IBANValidationResult';
  /** optionaler Name der Bank, wenn dieser gefunden werden konnte */
  bankName?: Maybe<Scalars['String']['output']>;
  /** optionaler BIC sofern vorhnaden */
  bic?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type ICategory = {
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
};

export type IosAppColors = {
  __typename?: 'IOSAppColors';
  /** Grundfarbe der App */
  appColor?: Maybe<Scalars['String']['output']>;
  /** Grundton */
  iosBaseTintColor?: Maybe<Scalars['String']['output']>;
  /** Navigationsmenü Buttons */
  iosButtonTintColor?: Maybe<Scalars['String']['output']>;
  /** Navigationsmenü Title */
  iosNavigationTitleTintColor?: Maybe<Scalars['String']['output']>;
  /** Tabbar - Selektiert */
  iosTabbarColor?: Maybe<Scalars['String']['output']>;
  /** Tabbar */
  iosTabbarTintColor?: Maybe<Scalars['String']['output']>;
  /** Tabbar - Unselektiert */
  iosTabbarTintColorUnselected?: Maybe<Scalars['String']['output']>;
};

export type IosAppColorsInput = {
  /** Grundfarbe der App */
  appColor?: InputMaybe<Scalars['String']['input']>;
  /** Grundton */
  iosBaseTintColor?: InputMaybe<Scalars['String']['input']>;
  /** Navigationsmenü Buttons */
  iosButtonTintColor?: InputMaybe<Scalars['String']['input']>;
  /** Navigationsmenü Title */
  iosNavigationTitleTintColor?: InputMaybe<Scalars['String']['input']>;
  /** Tabbar - Selektiert */
  iosTabbarColor?: InputMaybe<Scalars['String']['input']>;
  /** Tabbar */
  iosTabbarTintColor?: InputMaybe<Scalars['String']['input']>;
  /** Tabbar - Unselektiert */
  iosTabbarTintColorUnselected?: InputMaybe<Scalars['String']['input']>;
};

/** App-Einstellungen der IOS-App */
export type IosAppSettings = {
  __typename?: 'IOSAppSettings';
  /** App Farben */
  colors?: Maybe<IosAppColors>;
  /** Navigationstyp */
  navigationType?: Maybe<IosNavigationType>;
};

export type IosAppSettingsInput = {
  /** App Farben */
  colors?: InputMaybe<IosAppColorsInput>;
  /** Navigationstyp */
  navigationType?: InputMaybe<IosNavigationType>;
};

export type IosAppStoreSettingsInput = {
  ios_app_short_name?: InputMaybe<Scalars['String']['input']>;
  /**   ## IOS Apple-Account  */
  ios_apple_Account?: InputMaybe<Scalars['String']['input']>;
  ios_appname?: InputMaybe<Scalars['String']['input']>;
  ios_appstore_link?: InputMaybe<Scalars['String']['input']>;
  ios_askForUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /**  ## IOS Bundle id of app */
  ios_bundle_id?: InputMaybe<Scalars['String']['input']>;
  ios_category_a?: InputMaybe<Scalars['String']['input']>;
  ios_category_b?: InputMaybe<Scalars['String']['input']>;
  ios_copyright?: InputMaybe<Scalars['String']['input']>;
  ios_description?: InputMaybe<Scalars['String']['input']>;
  ios_dev_comment?: InputMaybe<Scalars['String']['input']>;
  ios_developer_Account?: InputMaybe<Scalars['String']['input']>;
  ios_goinglive?: InputMaybe<Scalars['Date']['input']>;
  /**  ## IOS Team id of app */
  ios_iosVersion?: InputMaybe<Scalars['String']['input']>;
  ios_keywords?: InputMaybe<Scalars['String']['input']>;
  ios_lastUpdate?: InputMaybe<Scalars['Date']['input']>;
  ios_libVersion?: InputMaybe<Scalars['Int']['input']>;
  ios_marketing_url?: InputMaybe<Scalars['String']['input']>;
  ios_note?: InputMaybe<Scalars['String']['input']>;
  ios_promotext?: InputMaybe<Scalars['String']['input']>;
  ios_subname?: InputMaybe<Scalars['String']['input']>;
  ios_support_url?: InputMaybe<Scalars['String']['input']>;
  /**  ## IOS Team id of app */
  ios_team_id?: InputMaybe<Scalars['String']['input']>;
};

export enum IosNavigationType {
  /** Keine Navigation */
  None = 'none',
  /** Sidebar */
  Sidebar = 'sidebar',
  /** Tabbar */
  Tabbar = 'tabbar'
}

/** Allgemeine Informationen zu Files im Object Store. */
export type IwsFile = {
  /** Bermrekungen, Hinweise, Notizen */
  description?: Maybe<Scalars['String']['output']>;
  /** eindeutiges Handle auf das File */
  id: Scalars['WSFileId']['output'];
  /** Key innerhalb des Object Store */
  key?: Maybe<Scalars['String']['output']>;
  /** Wann wurde die letzte Änderung gemacht */
  lastModified: Scalars['Date']['output'];
  /** Wer hat zuletzt etwas geändert */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Name des Files */
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  /** true, wenn keine Bearbeitung möglich */
  readonly: Scalars['Boolean']['output'];
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Art der Datei */
  type: WsFileType;
  /** Id des Workspace root, in dem dieses File enthalten ist */
  workspaceId: Scalars['WSFileId']['output'];
};

/**
 * Bild, das in eine HTML Mail inline eingfügt werden soll als Base64 kodierter String.
 * Über eine cid:name Referenz muss das Bild dann an der Stelle im Quellcode eingesetzt werden.
 */
export type InlineImage = {
  base64: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type InstagramLongLiveAccessToken = {
  __typename?: 'InstagramLongLiveAccessToken';
  accessToken?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  tokenExpired?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** eine Rechnung */
export type Invoice = {
  __typename?: 'Invoice';
  appName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  gross?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  net?: Maybe<Scalars['Float']['output']>;
  signedUrl?: Maybe<Scalars['Url']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

export type ItemTrackerComponent = {
  __typename?: 'ItemTrackerComponent';
  geoJson?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  mapComponentReference?: Maybe<ComponentReference>;
};

export type ItemTrackerComponentInput = {
  mapComponentReferenceId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListComponent = {
  __typename?: 'ListComponent';
  androidWidescreenEnabled?: Maybe<Scalars['Boolean']['output']>;
  appId: Scalars['AppID']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImageId?: Maybe<Scalars['ID']['output']>;
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  componentReference?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  /** die eigentlichen Einträge in der Liste */
  entries?: Maybe<Array<Maybe<ListEntry>>>;
  /** eindeutige Id der Komponente */
  id: Scalars['ID']['output'];
  lastExternalDataSourceUpdate?: Maybe<Scalars['Date']['output']>;
  /** wann wurde die Komponente erstellt bzw. zuletzt geändert */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** wer hat die letzte Änderung durchgeführt */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Externe Datenquelle */
  newsFeedDatasourceId?: Maybe<Scalars['ID']['output']>;
  pinList?: Maybe<Scalars['Boolean']['output']>;
  precache?: Maybe<Scalars['Boolean']['output']>;
  /** Ist vorhande, wenn ein Fehler bei der Verarbeitung des RSS aufgetreten ist. */
  rssError?: Maybe<Scalars['String']['output']>;
  rssPushChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rssTargetComponent?: Maybe<ComponentReference>;
  rssTargetComponentId?: Maybe<Scalars['ID']['output']>;
  rssTimerEnabled?: Maybe<Scalars['Boolean']['output']>;
  rssUrl?: Maybe<Scalars['String']['output']>;
  sectionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  sortField: Scalars['String']['output'];
  timeBasedPublication?: Maybe<Scalars['Boolean']['output']>;
};

export type ListComponentInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Zeigt auf das Bild in der Mediathek. Kommt zum Tragen wenn Liste als Audioguide verwendet wird */
  backgroundImageId?: InputMaybe<Scalars['ID']['input']>;
  componentReference?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Externe Datenquelle */
  newsFeedDatasourceId?: InputMaybe<Scalars['ID']['input']>;
  pinList?: InputMaybe<Scalars['Boolean']['input']>;
  precache?: InputMaybe<Scalars['Boolean']['input']>;
  rssPushChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rssTargetComponentId?: InputMaybe<Scalars['ID']['input']>;
  rssTimerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rssUrl?: InputMaybe<Scalars['String']['input']>;
  sectionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  timeBasedPublication?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListEntry = {
  __typename?: 'ListEntry';
  address?: Maybe<Scalars['String']['output']>;
  appId: Scalars['AppID']['output'];
  audio?: Maybe<Resource>;
  audioId?: Maybe<Scalars['ID']['output']>;
  /** Audio */
  audioUrl?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  componentId?: Maybe<Scalars['String']['output']>;
  componentLink?: Maybe<ComponentReference>;
  componentLinkId?: Maybe<Scalars['ID']['output']>;
  content?: Maybe<IwsFile>;
  contentId?: Maybe<Scalars['ID']['output']>;
  /** Inhalt */
  contentUrl?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  eventEnd?: Maybe<Scalars['Date']['output']>;
  eventStart?: Maybe<Scalars['Date']['output']>;
  /** Zusatzbild */
  extraImageId?: Maybe<Scalars['ID']['output']>;
  extraImageUrl?: Maybe<Scalars['String']['output']>;
  facebookEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** eindeutige Id des Eintrags */
  id: Scalars['ID']['output'];
  imageId?: Maybe<Scalars['ID']['output']>;
  /** Bild */
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  pinCode?: Maybe<Scalars['String']['output']>;
  poiId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  previewImageId?: Maybe<Scalars['ID']['output']>;
  /** Bild Listenansicht */
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  publicationEnd?: Maybe<Scalars['Date']['output']>;
  publicationStart?: Maybe<Scalars['Date']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoDownload?: Maybe<Resource>;
  videoDownloadId?: Maybe<Scalars['ID']['output']>;
  /** VideoDownload */
  videoDownloadUrl?: Maybe<Scalars['String']['output']>;
  visibleByProfileRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zoomEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Felder die bei einem Listen-Eintrag geändert werden können */
export type ListEntryInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** Audio */
  audioId?: InputMaybe<Scalars['ID']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  componentLink?: InputMaybe<Scalars['ID']['input']>;
  /** Inhalt (Seite) */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventEnd?: InputMaybe<Scalars['Date']['input']>;
  eventStart?: InputMaybe<Scalars['Date']['input']>;
  /** Zusatzbild */
  extraImageId?: InputMaybe<Scalars['ID']['input']>;
  facebookEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bild */
  imageId?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  pinCode?: InputMaybe<Scalars['String']['input']>;
  poiId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Bild Listenansicht */
  previewImageId?: InputMaybe<Scalars['ID']['input']>;
  publicationEnd?: InputMaybe<Scalars['Date']['input']>;
  publicationStart?: InputMaybe<Scalars['Date']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** VideoDownload */
  videoDownloadId?: InputMaybe<Scalars['ID']['input']>;
  visibleByProfileRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zoomEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Ein Ort wie z.B eine Sporthalle oder Geschäftsstelle die im Kontext einer
 * App verwendet werden, um Termine dort zu planen, Die Position auf einer Karte einzublenden
 * oder Ressourcen dort zu buchen.
 */
export type Location = {
  __typename?: 'Location';
  /** App Kontext */
  appId: Scalars['AppID']['output'];
  /** Stadt */
  city?: Maybe<Scalars['String']['output']>;
  /** Erstellt am */
  created?: Maybe<Scalars['Date']['output']>;
  /** Erstellt von */
  createdBy?: Maybe<Scalars['String']['output']>;
  /**
   * ID des Ortes aus einem externen System, z.B im Falle eines Ortes aus einem ical-Feed.
   * Ein Abgleich über diese ID verhindet, dass Orte bei jedem Sync Vorgang neu angelegt werden.
   */
  externalId?: Maybe<Scalars['String']['output']>;
  /** GPS Breitengrad */
  geoLat?: Maybe<Scalars['Float']['output']>;
  /** GPS Längengrad */
  geoLng?: Maybe<Scalars['Float']['output']>;
  /** Primärschlüssel */
  id: Scalars['ID']['output'];
  /** Letzte Änderung */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** Postleitzahl */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Straße */
  street?: Maybe<Scalars['String']['output']>;
  /** Bezeichnung */
  title: Scalars['String']['output'];
  /** Verwendungen */
  usages?: Maybe<LocationUsages>;
};

export type LocationInput = {
  /** Street */
  city?: InputMaybe<Scalars['String']['input']>;
  /** externe Id ändern */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** GPS Breitengrad */
  geoLat?: InputMaybe<Scalars['Float']['input']>;
  /** GPS Längengrad */
  geoLng?: InputMaybe<Scalars['Float']['input']>;
  /** Postleitzahl */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Straße */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Bezeichnung */
  title: Scalars['String']['input'];
};

export type LocationUsages = {
  __typename?: 'LocationUsages';
  calendarEvents?: Maybe<Scalars['Long']['output']>;
};

export type LogTail = {
  __typename?: 'LogTail';
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Index des letzten Listenelements dieses Logs */
  pos?: Maybe<Scalars['Int']['output']>;
};

export type LoginPushNotificationInput = {
  loginConfirmationUrl: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type MapComponent = {
  __typename?: 'MapComponent';
  /** GeoJSON */
  geoJson?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Geografische Breite */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Längengrad */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   * Karten-Typ
   * STANDARD = 1;
   * HYBRID = 4;
   * SATELLITE = 2;
   */
  mapType?: Maybe<Scalars['Int']['output']>;
  /** Legenden-Punkte (Label) */
  markerLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Legenden-Punkte (Schlüssel) */
  markersUsed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Pos der Karte */
  pois?: Maybe<Array<Maybe<MapComponentPoi>>>;
  /** Eigene Position auf der Karte anzeigen? */
  showUserLocation?: Maybe<Scalars['Boolean']['output']>;
  /** Zoom Einstellung */
  zoomLevel?: Maybe<Scalars['Int']['output']>;
  /** Karte auf die Position des App-Nutzers zentrieren */
  zoomToUserLocation?: Maybe<Scalars['Boolean']['output']>;
};

export type MapComponentInput = {
  /** GeoJSON Input */
  geoJson?: InputMaybe<Scalars['JSON']['input']>;
  /** Geografische Breite */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Längengrad */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Karten-Typ
   * STANDARD = 1;
   * HYBRID = 4;
   * SATELLITE = 2;
   */
  mapType?: InputMaybe<Scalars['Int']['input']>;
  /** Legenden-Punkte (Label) */
  markerLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Legenden-Punkte (Schlüssel) */
  markersUsed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Eigene Position auf der Karte anzeigen? */
  showUserLocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Zoom Einstellung */
  zoomLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Karte auf die Position des App-Nutzers zentrieren */
  zoomToUserLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MapComponentPoi = {
  __typename?: 'MapComponentPoi';
  icon?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  /** Breitengrad */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Link zu einer Seite */
  link?: Maybe<IwsFile>;
  linkId?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** Interner Verweis auf eine Listen-Komponente */
  list_reference?: Maybe<ComponentReference>;
  /** ID des eintrags in der Liste */
  list_reference_entry?: Maybe<ListEntry>;
  /** Längengrad */
  longitude?: Maybe<Scalars['Float']['output']>;
  marker?: Maybe<Scalars['String']['output']>;
  markerText?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** Untertitel des Pois */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Titels des Pois */
  title?: Maybe<Scalars['String']['output']>;
};

export type MapComponentPoiInput = {
  /** Interner Verweis auf eine Listen-Komponente */
  internallink_component?: InputMaybe<Scalars['String']['input']>;
  /** ID des eintrags in der Liste */
  internallink_id?: InputMaybe<Scalars['String']['input']>;
  /** Breitengrad */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  linkId?: InputMaybe<Scalars['String']['input']>;
  /** Längengrad */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  marker?: InputMaybe<Scalars['String']['input']>;
  markerText?: InputMaybe<Scalars['String']['input']>;
  /** ausgewählt? */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Untertitel des Pois */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Titels des Pois */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MapPoiImportSettings = {
  /** Löscht alle POIS vor dem Import */
  clearDatabase?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Repräsentiert eine Begegnung zweiter Teams im Rahmen einer Tourniers. Innerhalb Ihres Lebenszyklus wird ein Match
 * zunächst geplant, dann der Termin fixiert und am Spieltag über einen Countdown bis zum Anfiff durchlaufen.
 * Im Live Betrieb wird die Ansicht in kurzen Abständen aktualisiert um die aktuellen Events möglichst zeitnah in einem
 * Live-Ticker darzustellen. Nach Abschluss des Spiels können ggfs. noch statistische Daten ergänzt werden.
 */
export type Match = {
  __typename?: 'Match';
  /** Spielstand Gast */
  awayScore?: Maybe<Scalars['Int']['output']>;
  /** Gast Mannschaft */
  awayTeam: Team;
  /** Gast Mannschaft */
  awayTeamId: Scalars['ID']['output'];
  /** Name des Turniers auf das sich der Turnierkalender bezieht */
  competitionName?: Maybe<Scalars['String']['output']>;
  /** Beschreibung zum Spiel. In der Regel in der Form 'Heim gegen Gast' */
  description?: Maybe<Scalars['String']['output']>;
  /** Ereignisse aus dem Spiel. Nur bei bereits abgeschlossenen Spielen vorhanden */
  events?: Maybe<Array<Maybe<MatchEvent>>>;
  /** Der Termin ist fixiert. */
  fixed: Scalars['Boolean']['output'];
  /** Spielstand Heim */
  homeScore?: Maybe<Scalars['Int']['output']>;
  /** Heim Mannschaft */
  homeTeam: Team;
  /** Heim Mannschaft */
  homeTeamId: Scalars['ID']['output'];
  /** Tag an dem das Spiel stattfinden soll bzw. stattgefunden hat in der lokalen Zeit bezogen zum Austragungsort des Spiels */
  localDate?: Maybe<Scalars['String']['output']>;
  /** Uhrzeit an dem das Spiel stattfinden soll bzw. stattgefunden hat in der lokalen Zeit bezogen zum Austragungsort des Spiels */
  localTime?: Maybe<Scalars['String']['output']>;
  /** der 'Spieltag' bezogen auf den Tournierkalender */
  matchDay?: Maybe<Scalars['Int']['output']>;
  /** eindeutige Id des Spiels */
  matchId: Scalars['ID']['output'];
  /** Status des Soiels (Fixture, Played) */
  matchStatus: Scalars['String']['output'];
  /** Name der Runde innerhalb des Turnierbaums */
  stageName?: Maybe<Scalars['String']['output']>;
  /** optionale statistische Informationen zum Spiel. */
  statistics?: Maybe<MatchStatistics>;
  /** auf welchen Turnierkalender (z.B Bundesliga 25/26) bezieht sich das Match */
  tournamentCalendarId: Scalars['String']['output'];
};

/** Ein Ereignis im Rahmen eines Spiels */
export type MatchEvent = {
  __typename?: 'MatchEvent';
  /** eideutige Id des Events */
  eventId: Scalars['ID']['output'];
  /** um welche Art von Event handelt es sich */
  eventType: Scalars['String']['output'];
  /** Spiel auf welches sich der Event bezieht */
  matchId: Scalars['ID']['output'];
  /** in welchem Spielabschnitt befinden wir uns */
  periodId?: Maybe<Scalars['Int']['output']>;
  /** Eigenschaften des Events, abhängig von Typ */
  properties: Scalars['JSON']['output'];
  /** auf welches Team bezieht sich das Ereignis */
  teamId: Scalars['ID']['output'];
  /** Wann im Spiel ist der Event aufgetreten? */
  timeMinSec?: Maybe<Scalars['String']['output']>;
};

/** Ein Ereignis in einem Spiel wird über eine Admin Oberfläche oder ein externes System gemeldet. */
export type MatchEventInput = {
  /** optionale Id des externen Systems. Wenn nicht vorhanden, erzeugen wir intern eine ID */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Zeitpunkt an dem der Event aufgetreten ist. Wenn nicht gesetzt wird der Zeitpunkt eingetragen
   * zu dem der Event publiziert wurde.
   */
  eventTime?: InputMaybe<Scalars['Date']['input']>;
  /** Art des Events */
  eventType: Scalars['String']['input'];
  /** auf welches Spiel bezieht sich der Event */
  gameId: Scalars['ID']['input'];
  /** Wann im Spiel ist der Event aufgetreten? */
  timeMinSec?: InputMaybe<Scalars['String']['input']>;
};

/** Optionale Daten zu einem Match, die in der Regel nur von einem professionellen Anbieter geliefert werden. */
export type MatchStatistics = {
  __typename?: 'MatchStatistics';
  /** Statistiken zur Gast Mannschaft */
  awayStats: Scalars['JSON']['output'];
  /** wer ist die Gast Mannschaft */
  awayTeamId: Scalars['String']['output'];
  /** Statistiken zur Heim Mannschaft */
  homeStats: Scalars['JSON']['output'];
  /** wer ist die Heim Mannschaft */
  homeTeamId: Scalars['String']['output'];
  /** Spiel auf welches sich die Daten beziehen */
  matchId: Scalars['ID']['output'];
};

export type MediaReference = {
  __typename?: 'MediaReference';
  altText?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MediaReferenceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Ein Meeting ist ein Element des Spielplans */
export type MeetingAbbrDto = {
  __typename?: 'MeetingAbbrDTO';
  /** Name der Meisterschaft */
  championshipNickname?: Maybe<Scalars['String']['output']>;
  /** Region der Meisterschaft */
  championshipRegion?: Maybe<Scalars['String']['output']>;
  /** Id der Halle der Veranstaltung */
  courtHallId?: Maybe<Scalars['String']['output']>;
  /** Name der Halle der Veranstaltung */
  courtHallName?: Maybe<Scalars['String']['output']>;
  /** Name der Liga */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Logo der Gastmannschaft */
  guestImageUri?: Maybe<Scalars['String']['output']>;
  /** Logo der Heimmannschaft */
  homeImageUri?: Maybe<Scalars['String']['output']>;
  /** Punktestand Gastmannschaft */
  matchesGuest?: Maybe<Scalars['Int']['output']>;
  /** Punktestand Heimmannschaft */
  matchesHome?: Maybe<Scalars['Int']['output']>;
  meetingId: Scalars['ID']['output'];
  /** Nr. */
  meetingNumber?: Maybe<Scalars['Int']['output']>;
  meetingState?: Maybe<MeetingState>;
  /** Spielbericht */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Schiedsrichter */
  referee?: Maybe<Scalars['String']['output']>;
  /** Name der Runde/Spieltag */
  roundName?: Maybe<Scalars['String']['output']>;
  scheduled?: Maybe<Scalars['Date']['output']>;
  /** Gastmannschaft */
  teamGuest?: Maybe<Scalars['String']['output']>;
  /** Id des Clubs der Gast Mannschaft */
  teamGuestClubNr?: Maybe<Scalars['String']['output']>;
  /** Id des Gast Teams */
  teamGuestId?: Maybe<Scalars['String']['output']>;
  /** Heim Mannschaft */
  teamHome?: Maybe<Scalars['String']['output']>;
  /** Id des Clubs der Heim Mannschaft */
  teamHomeClubNr?: Maybe<Scalars['String']['output']>;
  /** Id der Heim Mannschaft */
  teamHomeId?: Maybe<Scalars['String']['output']>;
};

export enum MeetingState {
  Finished = 'FINISHED',
  Intermediate = 'INTERMEDIATE',
  New = 'NEW',
  Quickentry = 'QUICKENTRY'
}

export enum MemberListVisibility {
  Admin = 'ADMIN',
  Members = 'MEMBERS',
  Profile = 'PROFILE'
}

/** Gibt an, worauf sich eine Lösch- bzw. Änderungsaktion bezieht. */
export enum ModificationScope {
  All = 'ALL',
  Selected = 'SELECTED',
  Subsequent = 'SUBSEQUENT'
}

/**
 * Eine Menge von zusammengehörenden Modulen über die grenzen einer Projektversion hinweg.
 * Z.B alle Startseiten der verschiedenen Sprachversionen. Sinn dieses Containers ist es, dem Anwender zu ermöglichen
 * zu erkennen, dass eine Änderung an einem Modul höchstwahrscheinlich auch Änderungen in den anderen Modulen
 * des Containers bedeutet, z.B eine Änderung in der deutschen Version einer Seite in der englischen Version der
 * gleichen Seite nachgezogen werden muss.
 */
export type ModuleContainer = {
  __typename?: 'ModuleContainer';
  id?: Maybe<Scalars['ID']['output']>;
  references?: Maybe<Array<Maybe<ModuleReference>>>;
  /** Referenz zu einem Modultyp */
  type?: Maybe<ComponentReferenceType>;
};

export type ModuleIcon = {
  __typename?: 'ModuleIcon';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ModuleReference = {
  __typename?: 'ModuleReference';
  icon?: Maybe<Scalars['String']['output']>;
  /** Sprache des referenzierten Inhalts */
  language: Scalars['Locale']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Fügt eine App Nutzer Profil zu einer Gruppe hinzu und macht diese damit zum Mitglied.
   * Dies kann im Kontext der Gruppen Administration im CMS erfolgen oder auf der Mitgliederliste
   * in einem Gruppenraum durch einen Gruppenleiter.
   */
  addGroupMember?: Maybe<Group>;
  /** Beantwortet die Frage nach einer Gruppenmitgliedschaft */
  answerGroupAccessRequest?: Maybe<Scalars['Boolean']['output']>;
  /** hinzufügen von Werten zu einer Serie */
  appendDataToTimeSeries: Array<Maybe<TimeSeriesData>>;
  /**
   * Erstellt Standard-Kategorien für das aktuelle Projekt (in der Regel ein Bestandsprojekt).
   * Sofern das Projekt noch keine Kategorien hat.
   */
  applyDefaultCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Weist der Subscription / Kanal die Relations zu. */
  assignChatChannelRelationIds?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Der Benutzer scannt einen QR-Code, der in der Datenbank seinem Profil zugeordnet und ihm übergeben wurde, um
   * die Verbindung zu seinem Gerät herzustellen.
   */
  assignDeviceToProfileByCode?: Maybe<UserProfileRegistrationResult>;
  /**
   * Der Benutzer möchte sein Gerät über die eingegebene Mail Adresse mit seinem Benutzerprofil verbinden.
   * Sofern die Konfiguration die Verwendung einer verifizierten Mobilnummer erfordert, wird der
   * Verifikationsprozess parallel zum Mail-Versand gestartet.
   */
  assignDeviceToUserProfile?: Maybe<UserProfileRegistrationResult>;
  /**
   * Die Reservierung wird storniert. Bei Erfolg wird der aktualisierte Event geliefert - jeweils mit der
   * reduzierten Teilnehmerzahl und Sitzplatzbelegung.
   */
  cancelCalendarEventRegistration?: Maybe<CalendarEvent>;
  /** Bricht die Mitgliedschaftsanfrage ab */
  cancelGroupAccessRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Bricht den Zuweisungsprozess für ein Gerät zu einem Profil ab */
  cancelPendingDeviceAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Bricht den wechsel einer Telefonnummer ab */
  cancelPhoneNumberChange?: Maybe<Scalars['Boolean']['output']>;
  /** Ändert die Benutzereinstellungen */
  changeUserSettings?: Maybe<User>;
  /** Markiert die Nachricht als gelesen */
  chatMessageReceived?: Maybe<Scalars['Boolean']['output']>;
  /** Profil schreibt gerade eine Nachricht */
  chatProfileWriting?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht alle Einträge im Kalender */
  clearCalendar?: Maybe<Scalars['Int']['output']>;
  /** Löscht alle Chat-Nachrichten aus einem Kanal */
  clearChatMessages?: Maybe<Scalars['Boolean']['output']>;
  /** Dupliziert mehrere Einträge und gibt die neuen Einträge zurück */
  cloneListEntries?: Maybe<Array<Maybe<ListEntry>>>;
  /** fügt alle Arbeitsblätter des Quell-Workbooks an das Ende des Ziel-Workbooks */
  cloneWorkbook?: Maybe<WorkbookComponent>;
  /**
   * Der Veranstalter/Verantwortliche des Events, bestätigt die Teilnahme. Dies erfolgt entweder
   * durch manuelles "abhaken" oder durch scannen des QR-Codes von der Registierungsbestätigung (Ticket) welches
   * der Teilnehmer vorzeigt.
   * Dies kann nur von einem zuständigen Ansprechpartner des Termins am Tag des Termins durchgeführt werden.
   */
  confirmEventAttendance?: Maybe<CalendarEventRegistration>;
  /**
   * Die Bezahlung einer ggfs. kostenpflichtigen Termin-Anmeldung wird bestätigt.
   * Dies kann entweder über ein passendes gültiges Ticket geschehen, welches dann entwertet wird oder manuell
   * durch den Veranstalter/Verantwortlichen des Events, durch manuelle Bestätigung
   */
  confirmEventPayment?: Maybe<CalendarEventRegistration>;
  /** Kopiert eine Datei in eine andere App. Gibt die neue Datei zurück */
  copyWorkspaceFileToApp?: Maybe<IwsFile>;
  /** Erzeugt Activator für eine Komponente */
  createActivator?: Maybe<ComponentActivator>;
  /** Erstellt einen Administrator (INTERNAL) */
  createAdminUser?: Maybe<User>;
  /** Erzeugt einen neuen Barcode */
  createBarcode?: Maybe<Barcode>;
  /** Erstellt Buchungen */
  createBookingBookmark?: Maybe<BookingBookmark>;
  /** Erstellt eine Resource */
  createBookingResource?: Maybe<BookingResource>;
  /** Erstellt eine Regel */
  createBookingRule?: Maybe<BookingRule>;
  /** Update oder aktualisiert eine Schedule */
  createBookingSchedule?: Maybe<BookingSchedule>;
  /** Erstellt ein Tag */
  createBookingTag?: Maybe<BookingTag>;
  /** Erstellt Buchungen */
  createBookings?: Maybe<Array<Maybe<Booking>>>;
  /** Erstellt einen neuen Kalender. */
  createCalendar?: Maybe<Calendar>;
  /** erzeugt eine einzelne oder eine Serie von Ereignissen innerhalb eines Kalender. */
  createCalendarEvents: Array<Maybe<CalendarEvent>>;
  /** Erzeugt einen Kalender, der diesem Gruppenraum/der Gruppe zugeordnet ist */
  createCalendarInGroupSpace?: Maybe<GroupSpaceLink>;
  /** Erstellt ein Formular */
  createCalendarRegistrationForm?: Maybe<CalendarRegistrationForm>;
  /** Erwartet das Input Objekt und die ID der Chat-Komponente */
  createChatChannel?: Maybe<ChatChannel>;
  /** Erzeugt einen neuen Chat-Kanal, der diesem Gruppenraum/der Gruppe zugeordnet ist */
  createChatChannelInGroupSpace?: Maybe<GroupSpaceLink>;
  /** erstellt eine Umfrage */
  createChatPoll?: Maybe<ChatMessage>;
  /** erzeugt eine Gutschein-Vorlage */
  createCouponTemplate?: Maybe<Coupon>;
  /**
   * Zu einer Aufzählung, z.B Abteilungen oder angepasste Rollen wird ein neuer Key
   * und mindestens eine Sprachversion eingefügt.
   */
  createCustomEnumValue?: Maybe<CustomEnum>;
  /** Erstellt ein Feedback */
  createEventFeedback?: Maybe<CalendarEventFeedback>;
  /** erzeugt einen neuen File Eintrag auf Basis eines vorherigen Uploads */
  createFileRef?: Maybe<FileRef>;
  /** Erstellt ein Verzeichnis */
  createFileStoreDirectory?: Maybe<FsFile>;
  /** Erstellt eine leere Datei. Bereit zum Upload */
  createFileStoreFile?: Maybe<FsFile>;
  /** Erzeugt eine neue Galerie, und fügt die optional gegebenen Bilder ein */
  createGallery?: Maybe<Gallery>;
  /** Erstellt ein neues, leeres Album */
  createGalleryAlbum?: Maybe<GalleryAlbum>;
  /** Erzeugt eine neue Gruppe. Der Name darf noch nicht vergeben sein */
  createGroup?: Maybe<Group>;
  /** Erzeugt einen neuen Link im Group-Space */
  createLinkInGroupSpace?: Maybe<GroupSpaceLink>;
  /** Anlegen einer neuen Eintrags */
  createListEntry?: Maybe<ListEntry>;
  /** creates a new location in the current app scope */
  createLocation: Location;
  /** Erzeugt einen neuen manuellen Eintrag in einem Newsfeed des Typs MANUAL */
  createManualNewsFeedEntry?: Maybe<NewsFeedEntry>;
  /** Erstellt ein POI */
  createMapComponentPoi?: Maybe<MapComponentPoi>;
  /** Creates a multi user chat conversation */
  createMultiUserConversation?: Maybe<ChatChannel>;
  /** Erzeugt eine neue News Datenquelle */
  createNewsFeedDatasource?: Maybe<NewsFeedDataSource>;
  /** Fügt dem Kalender eine neue Event Kategorie hinzu. */
  createOrUpdateCalendarEventCategory: CalendarEventCategory;
  /** Erzeugt eine Payment Session mit einem Link, um das zugehörige Formular mit dem Warenkorb darzustellen. */
  createPaymentSession?: Maybe<PaymentSession>;
  /** Erstellt eine Karte in einer Pinboardcategorie */
  createPinboardCard?: Maybe<PinboardCard>;
  /** Erstellt eine Pinboardkategorie */
  createPinboardCategory?: Maybe<PinboardCardCategory>;
  /** Create Product Definition */
  createProduct?: Maybe<ProductDefinition>;
  /** Erzeugt ein neues Projekt optional als Kopie eines anderen */
  createProject?: Maybe<ProjectSpecification>;
  /** fügt mehrere Strukturknoten (Module/Komponenten) zu einem Projekt hinzu */
  createProjectStructureNodes?: Maybe<Array<Maybe<ProjectStructureNode>>>;
  /** Erstellt einen Pushkanal */
  createPushChannel?: Maybe<PushChannel>;
  /** erstellt eine Kategorie. Aktuell valide Scopes sind: IMAGES oder HTML */
  createResourceCategory?: Maybe<ResourceCategory>;
  /** Generiert Signed Upload URLs. Mit dieser URL kann per Post direkt in das S3 kompatible Storage geladen werden. Die Resourcen werden im Status uploading erstellt und werden später als abgeschlossen markiert. */
  createSignedResourceUpload?: Maybe<Array<Maybe<ResourceUploadSigningResponse>>>;
  /** Zeigt dem Server an, dass die Upload abgeschlossen wurde. Es werden dann die notwendigen Post-Upload-Prozesse gestartet. */
  createSignedResourceUploadCompleted?: Maybe<Array<Maybe<Resource>>>;
  /** Erstellt eine neue Verbindung */
  createSocialNetworkConfiguration?: Maybe<SocialNetworkConfiguration>;
  /** Erzeugt eine Kategorie */
  createStructureNodeCategory?: Maybe<ProjectStructureNodeCategory>;
  /** erzeugt einen neuen temporären technischen Benutzer und gibt die Credentials zurück */
  createTemporaryTechnicalUser?: Maybe<User>;
  createTextImageComponent: TextImageComponent;
  /** Creates a new Text-Widget */
  createTextWidget?: Maybe<TextWidget>;
  /** erzeugt eine neue Serie mit Namen und Einheit zu der dann Werte eingetragen werden können */
  createTimeSeries: TimeSeries;
  /** Erstellt ein neues Item */
  createTrackedItem?: Maybe<TrackedItem>;
  /**  Erstellt einen App-Administrator */
  createUser?: Maybe<User>;
  /** Erstellen eines Benutzerprofils aus dem CMS Kontext, d.h mit erweiterten Rechten */
  createUserProfile?: Maybe<UserProfile>;
  /** Generiert ein neuen Aktivierungscode */
  createUserProfileActivationCode?: Maybe<Scalars['String']['output']>;
  /** Erstellt ein Benutzerprofil von einem Gerät */
  createUserProfileFromDevice?: Maybe<UserProfile>;
  /** Erstellt eine Relation zwischen 2 Nutzern */
  createUserProfileRelation?: Maybe<UserProfileRelation>;
  /** Erstellt ein neues Worksheet */
  createWorksheet?: Maybe<Worksheet>;
  /** Erzeugt einen neuen Eintrag */
  createWorksheetRow?: Maybe<GenericRow>;
  /** Erzeugt eine neue HTML Seite mit gegebenem Inhalt. */
  createWorkspaceContentWithText?: Maybe<WsTextContent>;
  /** Erzeugt ein neues File per Upload. */
  createWorkspaceFileWithUpload?: Maybe<WsBinary>;
  /** Erzeugt ein Verzeichnis. */
  createWorkspaceFolder?: Maybe<WsFolder>;
  /** Erzeugt eine neuen Seitenverweis. */
  createWorkspaceLink?: Maybe<WsLink>;
  /** Löscht den Activator */
  deleteActivator?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht einen Administrator (INTERNAL) */
  deleteAdminUser?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht den Barcode */
  deleteBarcode?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht eine Buchung */
  deleteBooking?: Maybe<Booking>;
  /** Löscht einen Bookmark */
  deleteBookingBookmark?: Maybe<BookingBookmark>;
  /** Löscht eine Resource */
  deleteBookingResource?: Maybe<BookingResource>;
  /** Löscht eine Buchungsregel */
  deleteBookingRule?: Maybe<BookingRule>;
  /** Löscht einen Zeitplan */
  deleteBookingSchedule?: Maybe<BookingSchedule>;
  /** Löscht ein Tag */
  deleteBookingTag?: Maybe<BookingTag>;
  /** Löscht einen Kalender und alle Ereingnisse darin. */
  deleteCalendar?: Maybe<Scalars['Int']['output']>;
  /**
   * löscht das Ereignis aus dem Kalender, sofern der Benutzer Zugriff auf dieses Ereignis hat.
   * Es wird je nach scope nur das Ereignis gelöscht oder zusätzlich alle nachfolgenden bzw. alle der gleichen Serie.
   */
  deleteCalendarEvent?: Maybe<Scalars['Int']['output']>;
  /** löscht eine Kategorie aus dem zugehörigen Kalender, sofern diese Kategorie nicht verwendet wird */
  deleteCalendarEventCategory?: Maybe<Calendar>;
  /** Löscht ein Formular */
  deleteCalendarRegistrationForm?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht eine Chat-Nachricht */
  deleteChatMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht die Gutschein Vorlage und zugehörigen Instanzen. */
  deleteCouponsBySpecificationId?: Maybe<Scalars['Int']['output']>;
  /** Löscht ein Key von einem Enum */
  deleteCustomEnumValue?: Maybe<CustomEnum>;
  /** Löscht ein Feedback */
  deleteEventFeedback?: Maybe<Scalars['Boolean']['output']>;
  /** löscht das File */
  deleteFileRef: Scalars['ID']['output'];
  /** Löscht eine Datei oder ein Verzeichnis. Dieses Funktion löscht rekursiv! */
  deleteFileStoreFiles?: Maybe<Scalars['Int']['output']>;
  /** Löscht ein Album. */
  deleteGalleryAlbum?: Maybe<GalleryAlbum>;
  /** Löschen eine Gruppe */
  deleteGroup?: Maybe<Group>;
  /** Entfernt ein Mitglied aus einer Gruppe */
  deleteGroupMember?: Maybe<Group>;
  /** Löscht einen Link innerhalb eines Gruppenraums. Aktuell werden nur externe Links unterstützt. */
  deleteLinkInGroupSpace?: Maybe<Scalars['Boolean']['output']>;
  /** Löschen mehrerer Einträge */
  deleteListEntries?: Maybe<Scalars['Int']['output']>;
  /** delete location */
  deleteLocation: Scalars['ID']['output'];
  /** löscht den gegebenen NewsFeed Eintrag und gibt bei erfolg true zurück */
  deleteManualNewsFeedEntry?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht einen Poi */
  deleteMapComponentPois?: Maybe<MapComponent>;
  /** löscht die gegebene Datenquelle und alle gespeicherten zugehörigen Einträge und gibt deren Anzahl zurück */
  deleteNewsFeedDatasource?: Maybe<Scalars['Long']['output']>;
  /** Löscht ein Produkt */
  deleteProduct?: Maybe<Scalars['Boolean']['output']>;
  /** Achtung: Löscht das komplette Project mit allen Inhalten */
  deleteProject?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht eine Strukturknoten aus dem Projekt */
  deleteProjectStructureNode?: Maybe<Scalars['Boolean']['output']>;
  /** löscht ein Kanal aus dem System */
  deletePushChannel?: Maybe<Scalars['String']['output']>;
  /** löscht eine Nachricht aus dem System */
  deletePushNotification?: Maybe<Scalars['String']['output']>;
  /** löscht eine Resource */
  deleteResource?: Maybe<Resource>;
  /** Löscht die Kategorie aus dem System. Alle Verweise auf die Kategorie werden zurücksetzt. */
  deleteResourceCategory?: Maybe<ResourceCategory>;
  /** löscht mehrere Resourcen */
  deleteResources?: Maybe<Array<Maybe<Resource>>>;
  /** Löscht eine Kategorie */
  deleteStructureNodeCategory?: Maybe<Scalars['Boolean']['output']>;
  /** löscht die Serie und alle Werte */
  deleteTimeSeries?: Maybe<Scalars['ID']['output']>;
  /** Löscht das Item */
  deleteTrackedItem?: Maybe<TrackedItem>;
  /**  Löscht einen App-Administrator */
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** Löscht ein Benutzerprofil */
  deleteUserProfile?: Maybe<Scalars['ID']['output']>;
  /** Löscht das aktuelle Benutzerprofilbild */
  deleteUserProfileImage?: Maybe<Scalars['ID']['output']>;
  /** Löscht eine Relation */
  deleteUserProfileRelation?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes the worksheet */
  deleteWorksheet?: Maybe<Scalars['Int']['output']>;
  /** Löscht mehrere Einträge */
  deleteWorksheetRows?: Maybe<Scalars['Int']['output']>;
  /** Löscht ein File und ggfs. alle untergeordneten Verzeichnisse! */
  deleteWorkspaceFile?: Maybe<Scalars['Int']['output']>;
  /** Degradiert ein Gruppenleiter zu einem Mitglied */
  demoteToGroupMember?: Maybe<Group>;
  /** Nimmt eine Registration aus der Warteschlange und fügt Sie als Teilnehmer ein. */
  dequeueCalendarEventRegistration?: Maybe<CalendarEvent>;
  /**
   * Gibt den Gutschein gemäß dem Ausgabemodus aus. Über den zurückgegebenen Handle kann der Fortschritt dann
   * periodisch abgefragt werden.
   * Optional kann eine Push Nachricht gesendet werden.
   * Optional eine Menge von IDs, die entweder ein Rollen-Key oder Gruppen-ID sind
   */
  dispatchCoupon: Scalars['ID']['output'];
  /** Dupliziert eine bestehende Row */
  duplicateWorksheetRow?: Maybe<GenericRow>;
  /** Dupliziert ein File innerhalb des gleichen Verzeichnisses */
  duplicateWorkspaceFile: IwsFile;
  /** Verifiziert ein Nummernwechsel. Gibt die verifizierte Telefonnummer zurück */
  endPhoneNumberVerification?: Maybe<Scalars['String']['output']>;
  /**
   * Spezielle Version der "requestCalendarEventRegistration" für Administratoren, wobei verschiedene Prüfungen
   * auf Teilnehmerbegrenzung und Zeitpunkt ausser Kraft gesetzt werden.
   */
  enforceCalendarEventRegistration: Array<Maybe<CalendarEventRegistration>>;
  /** Schickt Daten in die Queue des Geräts */
  enqueueDataToDevice: Scalars['ID']['output'];
  /** Stellt sicher, dass es eine Direktkommunikation zwischen den Teilnehmern gibt */
  ensureDirectCommunicationExists?: Maybe<ChatChannel>;
  /** exportiert die POIs der Map Komponente in eine Excel-Datei */
  exportMapComponentPois?: Maybe<Scalars['UploadId']['output']>;
  /**
   * exportiert die Liste aller App Nutzer, die den gegebenen Filter-Kriterien entsprechen in eine Datei
   * des gewünschten Formats
   */
  exportUserProfiles?: Maybe<Scalars['UploadId']['output']>;
  /** exportiert alle Daten des Arbeitsblattes in eine Excel-Datei */
  exportWorksheet?: Maybe<Scalars['UploadId']['output']>;
  /** Überprüft das Token mit dem externen Identitätsdienst und synchronisiert die Daten */
  externalOpenIdConnectAuthenticated?: Maybe<ProfileValidationStatus>;
  /** Verschiebt die Dateien und verzeichnisse in der Struktur */
  fileStoreMoveFiles?: Maybe<Array<Maybe<FsFile>>>;
  /** Der Upload wurde abgeschlossen. Post-Prozesse werden gestartet */
  fileStoreUploadComplete?: Maybe<FsFile>;
  /**
   * Sendet den aktuellen User-Context an die Session
   * @deprecated will be removed
   */
  fillLoginSession?: Maybe<Scalars['Boolean']['output']>;
  /** Genertiert ein Api Token, falls dies für den User aktiviert ist */
  generateAPIToken?: Maybe<Scalars['String']['output']>;
  /**
   * Importiert die Kalenderdaten aus einer XLSX Datei im die aus dem ehemaligen Terminmodul exportiert wurde.
   * Die Daten werden zu dem gegebenen Kalender hinzugefügt.
   */
  importCalendarExcelFile: Scalars['Int']['output'];
  /** Erstellt ein neues Album und füllt es mit den Bildern aus einem angegebenen Galerie-Modul */
  importFromOldGalleryToAlbum?: Maybe<GalleryAlbum>;
  /** Importiert die Kalenderdaten aus einer ICS Datei im iCal Format in den bestehenden Kalender. */
  importICSFile: Scalars['Int']['output'];
  /** Importiert POIs von einer Excel-Datei */
  importMapComponentPois?: Maybe<MapComponent>;
  /** importiert eine Excel Liste mit geplanten PushNachrichten, welche zu dem gegebenen Zeitpunkt versendet werden sollen. */
  importScheduledPushNotificationsExcel?: Maybe<Scalars['Int']['output']>;
  /**
   * Importiert Benutzerprofile von einer Excel-Datei.
   * Als Ergebnis wird der Log-Output geliefert.
   */
  importUserProfiles?: Maybe<Scalars['String']['output']>;
  /**
   * importiert die Daten in das gegebene Arbeitsblatt. Wenn clear gesetzt, dann werden vorhandene Daten
   * gelöscht, andernfalls werden die Daten angehängt.
   * Als Ergebnis wird die Anzahl der importieren Zeilen geliefert.
   */
  importWorksheet?: Maybe<Scalars['Int']['output']>;
  /**
   * Initialisiert alle relations von der importierten Familiennummer.
   * Mit der Option clearAllRelations, kann optional alle Beziehungen vorher gelöscht werden.
   */
  initRelationsFromFamilyNumber?: Maybe<Scalars['Int']['output']>;
  /** Schickt eine Einladung an ein Profil */
  inviteChatProfile?: Maybe<ChatChannelInvitation>;
  /** Lädt eine Person zu der Gruppe ein */
  inviteToGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Gibt dem Nutzer eine Gutschrift für ein Produkt in sein Wallet */
  issueProductCredit?: Maybe<Scalars['Boolean']['output']>;
  /** Eine Person mit Kontovollmacht schickt das SEPA Formular ab. */
  issueSEPAMandate: Scalars['String']['output'];
  /** Beitritt zu einem öffentlichen Kanal */
  joinChatChannel?: Maybe<ChatChannel>;
  /** Wirft ein Profil aus dem Kanal */
  kickChatProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Verlässt den Chat-Kanal */
  leaveChatChannel?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Löst die Verbindung zwischen Appack und Facebook oder Instagram
   * Wenn delete auf true gesetzt wird, wird das Netzwerk komplett vom System entfernt
   */
  logoutSocialNetwork?: Maybe<SocialNetworkConfiguration>;
  /** Migration auf Bais einer gegebenen Workbook Id */
  migrateLegacyCalendarWorkbook?: Maybe<Calendar>;
  /** Verschiebt eine Datei / Verzeichnis in der Struktur */
  moveWorkspaceFile: IwsFile;
  /**
   * Liest die Daten einer Arbeitsmappe vom Typ 'Schwarzes Brett' und fügt diese
   * der Pinnwand hinzu.
   */
  populatePinboardFromWorkbookComponent?: Maybe<PinboardApplicationComponent>;
  /** Befördert ein Mitglied zu einem Gruppenleiter */
  promoteToGroupLeader?: Maybe<Group>;
  /** Ein Ereignis in einem Spiel wird über eine Admin Oberfläche oder ein externes System gemeldet. */
  publishGameEvent?: Maybe<MatchEvent>;
  /**
   * Sofern der Kalender mit einer iCal Datenquelle verbunden ist, werden die Daten von dort neu geladen
   * und unsere lokale Kopie entsprechend aktualisiert.
   * Dies kann entweder über einen expliziten Refresh (Button in der UI) oder periodisch per
   * Hintergrundprozess erfolgen.
   */
  refreshCalendarFromICal?: Maybe<Calendar>;
  /** Registriert das Gerät als Admin-Gerät */
  registerDeviceInfoAdmin?: Maybe<DeviceInfo>;
  /**
   * Das Produkt wird in der Konfiguration und dem aktuellen Preis beim Bezahldienstleister registriert.
   * Nur registrierte Produkte können auch verkauft werden.
   */
  registerWithPaymentProvider?: Maybe<ProductDefinition>;
  /**
   * Widerruft die Teilnahme am Event
   * Dies kann nur von einem zuständigen Ansprechpartner des Termins am Tag des Termins durchgeführt werden.
   */
  rejectEventAttendance?: Maybe<CalendarEventRegistration>;
  /** Der Veranstalter/Verantwortliche des Events zieht die Bezahlbestätigung zurück */
  rejectEventPayment?: Maybe<CalendarEventRegistration>;
  /** Löscht einen Kanal aus der Chat-Komponente */
  removeChatChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Benennt eine Datei oder ein Verzeichnis um */
  renameFileStoreFile?: Maybe<FsFile>;
  /** Bennennt einen Link im Gruppenraum um. */
  renameLinkInGroupSpace?: Maybe<Scalars['Boolean']['output']>;
  /** Ändert den Dateinamen */
  renameWorkspaceFile?: Maybe<IwsFile>;
  /** Meldet eine Chat-Nachricht an den Chat-Admin und Appack */
  reportChatMessage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * # request IOS Update
   * # returns true if update requested
   */
  requestAndroidAppUpdate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Registrieungsanfrage zu einem Termin. Bei der Anfrage werden so viele 'Plätze' reserviert
   * wie es Teilnehmer in der Anfrage gibt. Die Registrierung gelingt nur dann, wenn noch ausreichendes
   * Kontingent für alle Teilnehmer in dieser Anfrage vorhanden ist. Je nachdem, ob für den
   * Termin eine Warteliste verwaltet werden soll, erhält man entsprechend eine Fehlermeldung oder
   * zugeteilte Positionen.
   */
  requestCalendarEventRegistration: Array<Maybe<CalendarEventRegistration>>;
  /** Erzeugt ein Captcha Bild in der gwünschten Grösse */
  requestCaptcha?: Maybe<Captcha>;
  /**
   * Fragt die Mitgliedschaft in einer Gruppe an
   * Gibt true zurück, wenn es eine öffentliche Gruppe ist und automatisch beigetreten wurde. Gibt false zurück, wenn es einer Bestätigung bedarf
   */
  requestGroupAccess?: Maybe<Scalars['Boolean']['output']>;
  /**
   * # request IOS Update
   * # returns true if update requested
   */
  requestIOSAppUpdate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Spezielle Version der "requestCalendarEventRegistration" zum einbinden in die öffentliche Webseite über
   * unser CalendarWidget. Nur erlaubt bei Terminen, die mit 'öffentliche Anmeldung erlauben' markiert sind.
   * Der Request benötigt nur die Felder Name, Vorname, EMail. Um Mißbrauch über ein Skript zu verhindern
   * muss zusätzlich noch ein Captcha gelöst werden. Technisch werden die Personen vom Termin-Verantwortlichen
   * als Begleitpersonen angemeldet.
   */
  requestPublicCalendarEventRegistration: Array<Maybe<CalendarEventRegistration>>;
  /** Fordert das aktualisieren eines Zertifikats an */
  requestPushNotificationCertificate?: Maybe<Scalars['Boolean']['output']>;
  /** Setzt das Passwort eines Administrators zurück(INTERNAL) */
  resetAdminUserPassword?: Maybe<Scalars['Boolean']['output']>;
  /**  Setzt das Passwort eines App-Administrators */
  resetUserPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Resources Uploaded */
  resourceUploadComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Speichert die Auswahl einer Umfrage */
  saveChatPollSignUp?: Maybe<ChatPollSignup>;
  /**
   * Registriert das Gerät als Admin-Gerät
   * @deprecated Please use registerDeviceInfoAdmin
   */
  security_app_assign_admin?: Maybe<DeviceInfo>;
  /**
   * erzeugt einen neuen temporären technischen Benutzer und gibt die Credentials zurück
   * @deprecated Please use createTemporaryTechnicalUser
   */
  security_create_temporary_technical_user?: Maybe<User>;
  /** Schickt eine Antwort auf eine Einladung */
  sendChatInvitationResponse?: Maybe<ChatChannel>;
  /** verschickt eine Chat-Nachricht */
  sendChatMessage?: Maybe<ChatMessage>;
  /** Verschickt eine Reaktion */
  sendChatMessageReaction?: Maybe<Scalars['Boolean']['output']>;
  /** Eine interne Operation, die vom Login- Server benutzt wird, um Push Nachrichten zu senden */
  sendLoginNotificationToDevices?: Maybe<PushNotification>;
  /**
   * Formatiert eine HTML e-Mail auf Basis der gegebenen Vorlage und den zu ersetzenden Variablen
   * und sendet diese an die Empfänger. Aus Sicherheitsgründen erlauben wir nur die Verwendung von Empfänger-Mailadressen,
   * die in unserem System bekannt sind, also entweder von Portal Benutzern oder App Nutzer Profilen.
   */
  sendMail: Scalars['ID']['output'];
  /** Verschickt eine Reaktion */
  sendNewsFeedReaction?: Maybe<Scalars['Boolean']['output']>;
  /**
   * sendet die Push Nachricht an alle registrierten Empfänger Geräte
   * der App oder eine ausgeählte Teilmenge.
   */
  sendPushNotificationToDevices?: Maybe<PushNotification>;
  /** Eine interne Operation, die vom Chat Server benutzt wird, um Push Nachrichten zu senden */
  sendPushNotificationToDevicesAdmin?: Maybe<PushNotification>;
  /**
   * Sendet eine Push-Nachricht an alle angemeldeten Teilnhemer eines Events, sofern diese
   * ein Profil besitzen. Liefert die Anzahl der Teilnehmer mit Profil.
   * Kann zusätzlich auf ProfilIds eingeschränkt werden (optional)
   */
  sendPushNotificationToEventAttendees?: Maybe<Scalars['Int']['output']>;
  /** Sendet eine Push-Nachricht an ein Profil */
  sendPushNotificationToProfile?: Maybe<PushNotification>;
  /**
   * setzt bzw. ändert die oberen und unteren Grenzwerte zu einer Serie, die zu einer entsprechenden
   * Push Mitteilung führen, sobald diese unter- bzw. überschritten werden
   */
  setPersonalThreshold?: Maybe<Threshold>;
  /** Schaltet die Sichtbarkeit einer Serie ein oder aus */
  setTimeSeriesVisibility?: Maybe<TimeSeries>;
  /** Sortiert die Links anhand von einem Array aus IDs. */
  sortLinksInGroupSpace?: Maybe<Scalars['Boolean']['output']>;
  /** Startet den Wechsel der Telefonnummer */
  startPhoneNumberVerification?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Sofern zu der aktuellen App ein Vertrag hinterlegt ist, der noch kein SEPA Mandat zugeordnet hat, kann der
   * Prozess gestartet werden. Es wird eine E-Mail mit einem Link zu dem SEPA Formular an den angemeldeten CMS
   * User gesendet. Dieser leitet die Mail dann an die zuständige Person weiter.
   * Aus der Vertragsnummer bildet das Formular bei der Anzeige die Mandatsreferenz "R-JJJJ-MM-DD-VVVV".
   */
  startSEPAMandateFlow: Scalars['Int']['output'];
  /** Subscribe device to push channel */
  subscribePushChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Synchronisert ein social network to gallery */
  syncSocialNetworkToGallery?: Maybe<Gallery>;
  /**
   * Sendet an die gegebene Zieladresse eine Mail mit einer PIN, welche für 5 Minuten gilt,
   * die benutzt werden kann, um ein Token mit den Berechtigungen des zugehörigen
   * Benutzerprofils zu bekommen. Siehe query 'getTokenByMailAndPin'.
   */
  triggerLoginByMail?: Maybe<Scalars['Boolean']['output']>;
  /**
   * forciert ein ad-hoc update der Datenquelle. Andernfalls erfolgt das Update in der
   * angegebenen Aktualisierungsfrequenz im Hintergrund.
   */
  triggerNewsFeedDatasourceUpdate?: Maybe<NewsFeedDataSource>;
  /** Es wird die Benachrichtigung für Grenzwertmeldungen zu einer Serie aktiv angestossen. */
  triggerTimeSeriesChangedListener?: Maybe<Scalars['ID']['output']>;
  /** Das Device soll von dem aktuellen Benutzerprofil getrennt werden */
  unlinkDevice?: Maybe<Array<Maybe<DeviceSummary>>>;
  /** Das Device soll vom aktuellen CMS-Benutzer getrennt werden */
  unlinkUserDevice?: Maybe<Array<Maybe<DeviceSummary>>>;
  /** Removes subscription */
  unsubscribePushChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Änderungen an bestehendem Activator */
  updateActivator?: Maybe<ComponentActivator>;
  /** Updated einen Administrator (INTERNAL) */
  updateAdminUser?: Maybe<User>;
  /** Aktualisiert die Werbegrafik */
  updateAdvertiseGraphic?: Maybe<ProjectMetadata>;
  /** Aktualisiert die Einstellungen der Android-App */
  updateAndroidAppSettings?: Maybe<AndroidAppSettings>;
  /**
   * # Aktualisiert eine Datei für den Android Store
   * #     valid resourceTypes:
   * #     appicon
   * #     splashscreen
   * #     functionicon
   */
  updateAndroidAppStoreResource?: Maybe<ProjectMetadata>;
  /** # Aktualisiert die Appstore informationen */
  updateAndroidAppStoreSettings?: Maybe<ProjectMetadata>;
  /** Aktualisiert die App-Konfiguration */
  updateAppConfiguration?: Maybe<AppConfiguration>;
  /** Aktualisiert die Komponente */
  updateApplicationComponent?: Maybe<ApplicationComponent>;
  /** Änderungen an bestehendem Code */
  updateBarcode?: Maybe<Barcode>;
  /** ersetzt ein Base64 Bild in einer Zelle durch das Neue */
  updateBase64ImageInWorksheetCell: Scalars['JSON']['output'];
  /** Aktualisiert ein Bonusheft */
  updateBonusBooklet?: Maybe<BonusBooklet>;
  /** Update einer Resource */
  updateBookingResource?: Maybe<BookingResource>;
  /** Erstellt eine Regel */
  updateBookingRule?: Maybe<BookingRule>;
  /** Altualisiert Schedule */
  updateBookingSchedule?: Maybe<BookingSchedule>;
  /** Altualisiert ein  Tag */
  updateBookingTag?: Maybe<BookingTag>;
  /** Passt die Lesezeichen des Users an */
  updateBookmarks?: Maybe<UserBookmarks>;
  /** Aktualisiert die CMS-Settings */
  updateCMSSettings?: Maybe<CmsSettings>;
  /** Aktualisiert Kalender Einstellungen. */
  updateCalendar?: Maybe<Calendar>;
  /** Aktualisiert eine Kalendar Application */
  updateCalendarApplicationComponent?: Maybe<CalendarApplicationComponent>;
  /** Aktualisiert die Embed-Url der Komponente */
  updateCalendarEmbedUrl?: Maybe<Scalars['Url']['output']>;
  /**
   * An einem vorhandenen Event wurden Änderungen vorgenommen. Die in dem Template gesendeten Änderungen werden
   * auf dem Event mit der gegebenen Id übertragen. Sofern die SerienId gesetzt wird, werden auch alle Events innerhalb
   * der Serie auf die gleiche Weise geändert, die auf den genannten Event folgen.
   */
  updateCalendarEvents: Array<Maybe<CalendarEvent>>;
  /** Ändert ein Formular */
  updateCalendarRegistrationForm?: Maybe<CalendarRegistrationForm>;
  /** Aktualisiert die Komponente */
  updateChatApplicationComponent?: Maybe<ChatApplicationComponent>;
  /** Aktualisiert einen Chat-Kanal */
  updateChatChannel?: Maybe<ChatChannel>;
  /** Speichert die KanalInfo */
  updateChatChannelInfo?: Maybe<ChatChannel>;
  /** Aktiviert oder deaktiviert die Notifications für den Kanal */
  updateChatChannelNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Ändert die Einstellungen der Chat-Komponente */
  updateChatComponent?: Maybe<ChatComponent>;
  /** Aktualisiert eine Nachricht */
  updateChatMessage?: Maybe<ChatMessage>;
  /** updated eine Umfrage */
  updateChatPoll?: Maybe<ChatPoll>;
  /** Aktualisiert die Chat-Profileinstellungen */
  updateChatProfileSettings?: Maybe<ChatProfileSettings>;
  /** Aktualisiert die Datenschutzeinstellungen */
  updateConsentSettings?: Maybe<DataContent>;
  /** Wechselt die aktuelle app des Benutzers */
  updateCurrentApp?: Maybe<Scalars['Boolean']['output']>;
  /** Updated einen Key */
  updateCustomEnumValue?: Maybe<CustomEnum>;
  /** Update eines Familienmitgliedes */
  updateFamilyMember?: Maybe<UserProfile>;
  /** Update eines bestehenden Files */
  updateFileRef?: Maybe<FileRef>;
  /** Es werden Einstellungen an den Komponente selbst verändert */
  updateFileShareComponentSettings?: Maybe<FileShareComponent>;
  /** Aktualisiert eine Filestore Application */
  updateFileStoreApplicationComponent?: Maybe<FileStoreApplicationComponent>;
  /** Aktualisiert file store metadata */
  updateFileStoreFile?: Maybe<FsFile>;
  /** Aktualisiert die Galerie mit der gegebenen Id */
  updateGallery?: Maybe<Gallery>;
  /** Aktualisiert die Optionen eines Albums. */
  updateGalleryAlbum?: Maybe<GalleryAlbum>;
  /** Aktualisiert eine Gallery Application */
  updateGalleryApplicationComponent?: Maybe<NewsApplicationComponent>;
  /** Gruppe ändern (Name oder Mitglieder) */
  updateGroup?: Maybe<Group>;
  /** Aktualisiert ein Group Space */
  updateGroupSpace?: Maybe<GroupSpace>;
  /** Aktualisiert die Einstellungen der IOS-App */
  updateIOSAppSettings?: Maybe<IosAppSettings>;
  /**
   * # Aktualisiert eine Datei für den IOS Store
   * # appicon
   * # splasscreen
   * # high_resolution
   */
  updateIOSAppStoreResource?: Maybe<ProjectMetadata>;
  /** # Aktualisiert die Appstore informationen */
  updateIOSAppStoreSettings?: Maybe<ProjectMetadata>;
  /** Aktualisiert das Modul */
  updateItemTracker?: Maybe<ItemTrackerComponent>;
  /** Einstellungen der Liste werden geändert */
  updateListComponent?: Maybe<ListComponent>;
  /**
   * Der Eintrag wird im CMS zeilenweise bearbeitet, d.h es werden auch die Felder gesendet, die
   * nicht geändert wurden!
   */
  updateListEntry?: Maybe<ListEntry>;
  /** Aktualisiert die Sortierung in der Liste */
  updateListOrder?: Maybe<ListComponent>;
  /** updates location */
  updateLocation: Location;
  /** Aktualisiert einen manuellen Eintrag in einem Newsfeed des Typs MANUAL */
  updateManualNewsFeedEntry?: Maybe<NewsFeedEntry>;
  /** Aktualisiert die Komponente */
  updateMapComponent?: Maybe<MapComponent>;
  /** Aktualisiert ein POI */
  updateMapComponentPoi?: Maybe<MapComponentPoi>;
  /** Aktualisiert eine News Application */
  updateNewsApplicationComponent?: Maybe<NewsApplicationComponent>;
  /** Aktualisiert die Embed-Url der Komponente */
  updateNewsApplicationEmbedUrl?: Maybe<Scalars['Url']['output']>;
  /** Erzeugt eine neue News Datenquelle */
  updateNewsFeedDatasource?: Maybe<NewsFeedDataSource>;
  /**
   * Sobald ein User das erste Mal ein News Modul öffnet, werden für das Gerät alle
   * Datenquellen des Moduls abonniert. Über Checkboxen an der Datenquelle kann
   * das Abonnement dann ein/aus geschaltet werden.
   * Ein User abonniert eine Datenquelle im Kontext einer News Application.
   * Push Nachrichten die dann bei neuen Einträgen erzeugzt werden, führen bei Auswahl in das
   * jeweilige News Modul. Schaltet abwechselnd das Abonnement an/aus.
   */
  updateNewsFeedSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  /** Aktualisiert die Credentials mit dem Zahlungsanbieter und testet diese. Gibt im Fehlerfall eine Exception zurück. */
  updatePaymentProviderApiSettings?: Maybe<PaymentProviderApiStatus>;
  /** Aktualisiert eine Gallery Application */
  updatePinboardApplicationComponent?: Maybe<PinboardApplicationComponent>;
  /** Ändert Felder einer existierenden Karte */
  updatePinboardCard?: Maybe<PinboardCard>;
  /** Aktualisiert das CMS-Portal-Icon */
  updatePortalAppIcon?: Maybe<Scalars['String']['output']>;
  /** Aktualisiert ein Produkt */
  updateProduct?: Maybe<ProductDefinition>;
  /** aktualisiert einen Strukturknoten */
  updateProjectStructureNode?: Maybe<ProjectStructureNode>;
  /** Updated einen Pushkanal */
  updatePushChannel?: Maybe<PushChannel>;
  /** aktualisiert eine bestehende Push-Configuration */
  updatePushConfiguration: PushConfiguration;
  /** aktualisiert eine bestehende Push-Historien-Komponente */
  updatePushHistoryComponent: PushHistoryComponent;
  /** Updated eine Push-Nachricht im System */
  updatePushNotification?: Maybe<PushNotification>;
  /** Aktualisiert diverse Eigenschaften der Resource */
  updateResource?: Maybe<Resource>;
  /** aktualisiert eine Kategorie. Aktuell valide Scopes sind: IMAGES oder HTML */
  updateResourceCategory?: Maybe<ResourceCategory>;
  /** Aktualisiert die Komponente */
  updateResourceUploadComponent?: Maybe<ResourceUploadComponent>;
  /** Aktualisiert eine Verbindung */
  updateSocialNetworkConfiguration?: Maybe<SocialNetworkConfiguration>;
  updateStatistics?: Maybe<UsageStatistics>;
  updateStatusIndicator?: Maybe<StatusIndicator>;
  /** Aktualisiert eine Kategorie */
  updateStructureNodeCategory?: Maybe<ProjectStructureNodeCategory>;
  /** Aktualisiert eine Gutschein Vorlage. Bereits ausgegebene Inszanzen dieser Vorlage werden nicht geändert. */
  updateTemplateCoupon?: Maybe<Coupon>;
  /** aktualisiert eine bestehende TextImage Komponente */
  updateTextImageComponent: TextImageComponent;
  /** Update widget content */
  updateTextWidget?: Maybe<TextWidget>;
  /** einen existierenden Datenpunkt aktualisieren */
  updateTimeSeriesData: TimeSeriesData;
  /** Aktualisert ein Item */
  updateTrackedItem?: Maybe<TrackedItem>;
  /**  Aktualisiert einen App-Administrator */
  updateUser?: Maybe<User>;
  /** Wechselt die aktuelle App */
  updateUserCurrentApp?: Maybe<User>;
  /** Update eines Benutzerprofils */
  updateUserProfile?: Maybe<UserProfile>;
  /** Speichert Änderungen an der Profil Konfiguration. Partielles Update wird nicht unterstützt */
  updateUserProfileConfiguration: UserProfileConfiguration;
  /** Aktualisiert ein Benutzerprofil von einem Gerät */
  updateUserProfileFromDevice?: Maybe<UserProfile>;
  /** Lädt ein neues Profilbild hoch und gibt die neue ID zurück */
  updateUserProfileImage?: Maybe<UserProfile>;
  /** Aktualisiert das Profilbild eines Nutzerprofils von einem Gerät. Optional kann die ProfilId eines Familienmitgliedes mitgegeben werden. */
  updateUserProfileImageFromDevice?: Maybe<Scalars['ID']['output']>;
  /** Update settings */
  updateWidgetSettings?: Maybe<WidgetSettings>;
  /** Updates Workbook info */
  updateWorkbook?: Maybe<WorkbookComponent>;
  /** Aktualisiert das Worksheet */
  updateWorksheet?: Maybe<Worksheet>;
  /** Ändert eine bestehende Row */
  updateWorksheetRow?: Maybe<GenericRow>;
  /** Aktualisiert eine Seite */
  updateWorkspaceContentWithText?: Maybe<WsTextContent>;
  /** Aktualisiert Metadaten einer Datei */
  updateWorkspaceFileMeta?: Maybe<IwsFile>;
  /** Aktualisiert ein Link */
  updateWorkspaceLink?: Maybe<WsLink>;
  /**  Im Falle von IOS muss in regelmäßigen Abständen ein Zertifikat erneuert werden. */
  uploadPushNotificationCertificate?: Maybe<PushCertificateInfo>;
  /**
   * Das Profil aus dem JWT Token wird validiert. Sofern die Telefonnummer auch geprüft werden muss, ist
   * diese und der Code mitzugeben.
   */
  verifyProfile?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddGroupMemberArgs = {
  id: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
  sendWelcome?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAnswerGroupAccessRequestArgs = {
  answer: GroupAccessRequestAnswerInput;
};


export type MutationAppendDataToTimeSeriesArgs = {
  data: Array<TimeSeriesDataInput>;
  seriesId: Scalars['ID']['input'];
};


export type MutationAssignChatChannelRelationIdsArgs = {
  channelId: Scalars['ID']['input'];
  relationIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationAssignDeviceToProfileByCodeArgs = {
  input: UserProfileAssignDeviceCodeInput;
};


export type MutationAssignDeviceToUserProfileArgs = {
  input: UserProfileAssignDeviceInput;
};


export type MutationCancelCalendarEventRegistrationArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  registrationId: Scalars['ID']['input'];
};


export type MutationCancelGroupAccessRequestArgs = {
  groupId: Scalars['ID']['input'];
};


export type MutationChangeUserSettingsArgs = {
  settings: UserSettingsInput;
};


export type MutationChatMessageReceivedArgs = {
  message: Scalars['ID']['input'];
};


export type MutationChatProfileWritingArgs = {
  channelId: Scalars['ID']['input'];
};


export type MutationClearCalendarArgs = {
  calendarId: Scalars['ID']['input'];
};


export type MutationClearChatMessagesArgs = {
  channelId: Scalars['ID']['input'];
};


export type MutationCloneListEntriesArgs = {
  componentId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCloneWorkbookArgs = {
  copyData?: InputMaybe<Scalars['Boolean']['input']>;
  destinationId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationConfirmEventAttendanceArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationConfirmEventPaymentArgs = {
  registrationId: Scalars['ID']['input'];
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCopyWorkspaceFileToAppArgs = {
  appId: Scalars['String']['input'];
  file: Scalars['WSFileId']['input'];
};


export type MutationCreateActivatorArgs = {
  componentId: Scalars['ID']['input'];
  input: ComponentActivatorInput;
};


export type MutationCreateAdminUserArgs = {
  request: AdminUserInput;
  sendPassword?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateBarcodeArgs = {
  input: BarcodeUpdate;
};


export type MutationCreateBookingBookmarkArgs = {
  componentId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
};


export type MutationCreateBookingResourceArgs = {
  componentId: Scalars['ID']['input'];
  resource: BookingResourceInput;
};


export type MutationCreateBookingRuleArgs = {
  componentId: Scalars['ID']['input'];
  rule: BookingRuleInput;
};


export type MutationCreateBookingScheduleArgs = {
  componentId: Scalars['String']['input'];
  schedule: BookingScheduleInput;
};


export type MutationCreateBookingTagArgs = {
  componentId: Scalars['ID']['input'];
  tag: BookingTagInput;
};


export type MutationCreateBookingsArgs = {
  bookings: Array<InputMaybe<BookingInput>>;
};


export type MutationCreateCalendarArgs = {
  data: CalendarInput;
};


export type MutationCreateCalendarEventsArgs = {
  calendarId: Scalars['ID']['input'];
  data: CalendarEventTemplate;
};


export type MutationCreateCalendarInGroupSpaceArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  restrictWriteAccessToLeader?: InputMaybe<Scalars['Boolean']['input']>;
  spaceId: Scalars['ID']['input'];
};


export type MutationCreateCalendarRegistrationFormArgs = {
  input: CalendarRegistrationFormInput;
};


export type MutationCreateChatChannelArgs = {
  input: ChatChannelInput;
};


export type MutationCreateChatChannelInGroupSpaceArgs = {
  label: Scalars['String']['input'];
  spaceId: Scalars['ID']['input'];
};


export type MutationCreateChatPollArgs = {
  channelId: Scalars['ID']['input'];
  input: ChatPollInput;
};


export type MutationCreateCouponTemplateArgs = {
  spec: CouponTemplate;
};


export type MutationCreateCustomEnumValueArgs = {
  entry: CustomEnumKeyInput;
};


export type MutationCreateEventFeedbackArgs = {
  eventId: Scalars['ID']['input'];
  feedback: CalendarEventFeedbackInput;
};


export type MutationCreateFileRefArgs = {
  input: FileRefInput;
  upload: Scalars['UploadId']['input'];
};


export type MutationCreateFileStoreDirectoryArgs = {
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['FSFileId']['input']>;
  storeId?: InputMaybe<Scalars['FSId']['input']>;
};


export type MutationCreateFileStoreFileArgs = {
  parent?: InputMaybe<Scalars['FSFileId']['input']>;
  request: FsFileUploadRequest;
  storeId?: InputMaybe<Scalars['FSId']['input']>;
};


export type MutationCreateGalleryArgs = {
  input: GalleryInput;
};


export type MutationCreateGalleryAlbumArgs = {
  input: GalleryAlbumDataInput;
};


export type MutationCreateGroupArgs = {
  group: GroupInput;
};


export type MutationCreateLinkInGroupSpaceArgs = {
  label: Scalars['String']['input'];
  linkMode?: InputMaybe<Scalars['String']['input']>;
  linkType: GroupSpaceLinkType;
  spaceId: Scalars['ID']['input'];
  target: Scalars['String']['input'];
};


export type MutationCreateListEntryArgs = {
  componentId: Scalars['ID']['input'];
  input?: InputMaybe<ListEntryInput>;
};


export type MutationCreateLocationArgs = {
  data?: InputMaybe<LocationInput>;
};


export type MutationCreateManualNewsFeedEntryArgs = {
  input: NewsFeedEntryInput;
};


export type MutationCreateMapComponentPoiArgs = {
  input: MapComponentPoiInput;
  mapId: Scalars['ID']['input'];
};


export type MutationCreateMultiUserConversationArgs = {
  info: ChannelInfoInput;
};


export type MutationCreateNewsFeedDatasourceArgs = {
  input: NewsFeedDataSourceInput;
};


export type MutationCreateOrUpdateCalendarEventCategoryArgs = {
  calendarId: Scalars['ID']['input'];
  input: CalendarEventCategoryInput;
};


export type MutationCreatePaymentSessionArgs = {
  context?: InputMaybe<Scalars['JSON']['input']>;
  items?: InputMaybe<Array<InputMaybe<CartLineItem>>>;
  redirectUrl: Scalars['String']['input'];
};


export type MutationCreatePinboardCardArgs = {
  applicationId: Scalars['ID']['input'];
  input?: InputMaybe<PinboardCardInput>;
  pinboardCardCategoryId: Scalars['ID']['input'];
};


export type MutationCreatePinboardCategoryArgs = {
  applicationId: Scalars['ID']['input'];
  input?: InputMaybe<PinboardCardCategoryInput>;
};


export type MutationCreateProductArgs = {
  input: ProductDefinitionInput;
};


export type MutationCreateProjectArgs = {
  id: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateProjectStructureNodesArgs = {
  components: Array<InputMaybe<ProjectStructureNodeCreateInput>>;
  projectId: Scalars['ID']['input'];
};


export type MutationCreatePushChannelArgs = {
  channel: PushChannelInput;
};


export type MutationCreateResourceCategoryArgs = {
  input: ResourceCategoryInput;
};


export type MutationCreateSignedResourceUploadArgs = {
  requests: Array<InputMaybe<ResourceUploadSigningRequest>>;
};


export type MutationCreateSignedResourceUploadCompletedArgs = {
  resourceIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationCreateSocialNetworkConfigurationArgs = {
  name: Scalars['String']['input'];
  type: SocialNetworkConfigurationType;
};


export type MutationCreateStructureNodeCategoryArgs = {
  category: ProjectStructureNodeCategoryInput;
};


export type MutationCreateTextImageComponentArgs = {
  data: TextImageComponentInput;
};


export type MutationCreateTextWidgetArgs = {
  key: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTimeSeriesArgs = {
  input?: InputMaybe<TimeSeriesInput>;
};


export type MutationCreateTrackedItemArgs = {
  component: Scalars['ID']['input'];
  input: TrackedItemInput;
};


export type MutationCreateUserArgs = {
  request: UserInput;
  sendPassword?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateUserProfileArgs = {
  userProfile: UserProfileInput;
};


export type MutationCreateUserProfileActivationCodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateUserProfileFromDeviceArgs = {
  userProfile: UserProfileInput;
};


export type MutationCreateUserProfileRelationArgs = {
  input: UserProfileRelationInput;
};


export type MutationCreateWorksheetArgs = {
  input: WorksheetInput;
  workbookId: Scalars['ID']['input'];
};


export type MutationCreateWorksheetRowArgs = {
  data: Scalars['JSON']['input'];
  worksheetId: Scalars['ID']['input'];
};


export type MutationCreateWorkspaceContentWithTextArgs = {
  fileType: WsFileType;
  filename: Scalars['String']['input'];
  parent: Scalars['WSFileId']['input'];
  text: Scalars['String']['input'];
};


export type MutationCreateWorkspaceFileWithUploadArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['UploadId']['input'];
  parent: Scalars['WSFileId']['input'];
};


export type MutationCreateWorkspaceFolderArgs = {
  filename: Scalars['String']['input'];
  parent: Scalars['WSFileId']['input'];
};


export type MutationCreateWorkspaceLinkArgs = {
  name: Scalars['String']['input'];
  parent: Scalars['WSFileId']['input'];
  url: Scalars['String']['input'];
};


export type MutationDeleteActivatorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBarcodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingBookmarkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCalendarArgs = {
  calendarId: Scalars['ID']['input'];
};


export type MutationDeleteCalendarEventArgs = {
  id: Scalars['ID']['input'];
  scope: ModificationScope;
};


export type MutationDeleteCalendarEventCategoryArgs = {
  calendarId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
};


export type MutationDeleteCalendarRegistrationFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChatMessageArgs = {
  message: Scalars['ID']['input'];
};


export type MutationDeleteCouponsBySpecificationIdArgs = {
  couponSpecificationId: Scalars['ID']['input'];
};


export type MutationDeleteCustomEnumValueArgs = {
  enumId: Scalars['ID']['input'];
  enumKey: Scalars['ID']['input'];
};


export type MutationDeleteEventFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFileRefArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFileStoreFilesArgs = {
  files: Array<InputMaybe<Scalars['FSFileId']['input']>>;
  storeId?: InputMaybe<Scalars['FSId']['input']>;
};


export type MutationDeleteGalleryAlbumArgs = {
  galleryAlbumId: Scalars['ID']['input'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGroupMemberArgs = {
  id: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
};


export type MutationDeleteLinkInGroupSpaceArgs = {
  linkId: Scalars['ID']['input'];
  spaceId: Scalars['ID']['input'];
};


export type MutationDeleteListEntriesArgs = {
  componentId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationDeleteManualNewsFeedEntryArgs = {
  newsFeedEntryId: Scalars['ID']['input'];
};


export type MutationDeleteMapComponentPoisArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mapId: Scalars['ID']['input'];
};


export type MutationDeleteNewsFeedDatasourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectStructureNodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePushChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePushNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResourceCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResourcesArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeleteStructureNodeCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimeSeriesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTrackedItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserProfileImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserProfileRelationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorksheetArgs = {
  workbookId: Scalars['ID']['input'];
  worksheetId: Scalars['ID']['input'];
};


export type MutationDeleteWorksheetRowsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  worksheetId: Scalars['ID']['input'];
};


export type MutationDeleteWorkspaceFileArgs = {
  file: Scalars['WSFileId']['input'];
};


export type MutationDemoteToGroupMemberArgs = {
  id: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
};


export type MutationDequeueCalendarEventRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationDispatchCouponArgs = {
  couponId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  mode: DispatchMode;
  targets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDuplicateWorksheetRowArgs = {
  id: Scalars['ID']['input'];
  worksheetId: Scalars['ID']['input'];
};


export type MutationDuplicateWorkspaceFileArgs = {
  file: Scalars['WSFileId']['input'];
};


export type MutationEndPhoneNumberVerificationArgs = {
  code: Scalars['String']['input'];
};


export type MutationEnforceCalendarEventRegistrationArgs = {
  request?: InputMaybe<CalendarEventRegistrationRequest>;
};


export type MutationEnqueueDataToDeviceArgs = {
  data: Array<InputMaybe<Scalars['Int']['input']>>;
  deviceEui: Scalars['ID']['input'];
  fport?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEnsureDirectCommunicationExistsArgs = {
  targetProfileId: Scalars['ID']['input'];
};


export type MutationExportMapComponentPoisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportUserProfilesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<UserProfileExportFormat>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};


export type MutationExportWorksheetArgs = {
  filter: WorksheetQuery;
};


export type MutationExternalOpenIdConnectAuthenticatedArgs = {
  accessToken: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFileStoreMoveFilesArgs = {
  files: Array<InputMaybe<Scalars['FSFileId']['input']>>;
  newParent?: InputMaybe<Scalars['FSFileId']['input']>;
  storeId?: InputMaybe<Scalars['FSId']['input']>;
};


export type MutationFileStoreUploadCompleteArgs = {
  file: Scalars['FSFileId']['input'];
  storeId?: InputMaybe<Scalars['FSId']['input']>;
};


export type MutationFillLoginSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationImportCalendarExcelFileArgs = {
  calendarId: Scalars['ID']['input'];
  file: Scalars['UploadId']['input'];
};


export type MutationImportFromOldGalleryToAlbumArgs = {
  albumId: Scalars['ID']['input'];
  oldGalleryModuleId: Scalars['String']['input'];
};


export type MutationImportIcsFileArgs = {
  calendarId: Scalars['ID']['input'];
  file: Scalars['UploadId']['input'];
};


export type MutationImportMapComponentPoisArgs = {
  file: Scalars['UploadId']['input'];
  id: Scalars['ID']['input'];
  settings: MapPoiImportSettings;
};


export type MutationImportScheduledPushNotificationsExcelArgs = {
  excelFile: Scalars['UploadId']['input'];
};


export type MutationImportUserProfilesArgs = {
  file: Scalars['UploadId']['input'];
  settings: UserProfileExcelImportSettings;
};


export type MutationImportWorksheetArgs = {
  clear: Scalars['Boolean']['input'];
  file: Scalars['UploadId']['input'];
  worksheetId: Scalars['ID']['input'];
};


export type MutationInitRelationsFromFamilyNumberArgs = {
  clearAllRelations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInviteChatProfileArgs = {
  input: ChatChannelInvitationInput;
};


export type MutationInviteToGroupArgs = {
  request: GroupAccessInvitationRequestInput;
};


export type MutationIssueProductCreditArgs = {
  input: ProductCreditInput;
};


export type MutationIssueSepaMandateArgs = {
  input: SepaMandateInput;
};


export type MutationJoinChatChannelArgs = {
  channelId: Scalars['ID']['input'];
  pin?: InputMaybe<Scalars['String']['input']>;
};


export type MutationKickChatProfileArgs = {
  channelId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
};


export type MutationLeaveChatChannelArgs = {
  channelId: Scalars['ID']['input'];
};


export type MutationLogoutSocialNetworkArgs = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetworkId: Scalars['String']['input'];
};


export type MutationMigrateLegacyCalendarWorkbookArgs = {
  workbookId: Scalars['String']['input'];
};


export type MutationMoveWorkspaceFileArgs = {
  file: Scalars['WSFileId']['input'];
  newParent: Scalars['WSFileId']['input'];
};


export type MutationPopulatePinboardFromWorkbookComponentArgs = {
  applicationId: Scalars['ID']['input'];
  workbookComponentId: Scalars['ID']['input'];
};


export type MutationPromoteToGroupLeaderArgs = {
  id: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
};


export type MutationPublishGameEventArgs = {
  eventInput: MatchEventInput;
};


export type MutationRefreshCalendarFromICalArgs = {
  calendarId: Scalars['ID']['input'];
};


export type MutationRegisterDeviceInfoAdminArgs = {
  appId: Scalars['AppID']['input'];
  deviceId: Scalars['String']['input'];
  deviceSecret?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterWithPaymentProviderArgs = {
  environment: PaymentEnvironment;
  productId: Scalars['ID']['input'];
};


export type MutationRejectEventAttendanceArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationRejectEventPaymentArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationRemoveChatChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenameFileStoreFileArgs = {
  file: Scalars['FSFileId']['input'];
  newName: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['FSId']['input']>;
};


export type MutationRenameLinkInGroupSpaceArgs = {
  newName?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['ID']['input'];
  spaceLinkId: Scalars['ID']['input'];
};


export type MutationRenameWorkspaceFileArgs = {
  file: Scalars['WSFileId']['input'];
  name: Scalars['String']['input'];
};


export type MutationReportChatMessageArgs = {
  message: Scalars['ID']['input'];
  reportReason: Scalars['String']['input'];
};


export type MutationRequestAndroidAppUpdateArgs = {
  comment: Scalars['String']['input'];
};


export type MutationRequestCalendarEventRegistrationArgs = {
  request?: InputMaybe<CalendarEventRegistrationRequest>;
};


export type MutationRequestCaptchaArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRequestGroupAccessArgs = {
  request: GroupAccessRequestInput;
};


export type MutationRequestIosAppUpdateArgs = {
  comment: Scalars['String']['input'];
};


export type MutationRequestPublicCalendarEventRegistrationArgs = {
  captcha: CaptchaSolution;
  request: CalendarEventRegistrationRequest;
};


export type MutationResetAdminUserPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetUserPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResourceUploadCompleteArgs = {
  id: Scalars['ID']['input'];
  input: ResourceUploadCompletedInput;
  resources: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSaveChatPollSignUpArgs = {
  signUp: ChatPollSignupInput;
};


export type MutationSecurity_App_Assign_AdminArgs = {
  appId: Scalars['AppID']['input'];
  deviceId: Scalars['String']['input'];
  deviceSecret?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendChatInvitationResponseArgs = {
  invitationId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  response: ChatChannelInvitationResponse;
};


export type MutationSendChatMessageArgs = {
  channel: Scalars['ID']['input'];
  message: ChatMessageInput;
};


export type MutationSendChatMessageReactionArgs = {
  message: Scalars['ID']['input'];
  reaction: ChatMessageReactionEnum;
};


export type MutationSendLoginNotificationToDevicesArgs = {
  appId: Scalars['AppID']['input'];
  notification?: InputMaybe<LoginPushNotificationInput>;
  targets?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSendMailArgs = {
  captcha?: InputMaybe<CaptchaSolution>;
  fileAttachments?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<InlineImage>>>;
  subject: Scalars['String']['input'];
  templateKey: Scalars['String']['input'];
  textAttachment?: InputMaybe<TextAttachment>;
  to: Array<InputMaybe<Scalars['String']['input']>>;
  variables: Scalars['JSON']['input'];
};


export type MutationSendNewsFeedReactionArgs = {
  news: Scalars['ID']['input'];
  reaction: NewsFeedReactionEnum;
};


export type MutationSendPushNotificationToDevicesArgs = {
  notification?: InputMaybe<PushNotificationInput>;
  targets?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSendPushNotificationToDevicesAdminArgs = {
  appId: Scalars['AppID']['input'];
  notification?: InputMaybe<PushNotificationInput>;
  targets?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSendPushNotificationToEventAttendeesArgs = {
  eventId: Scalars['ID']['input'];
  notification?: InputMaybe<PushNotificationInput>;
  profileIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSendPushNotificationToProfileArgs = {
  notification?: InputMaybe<PushNotificationInput>;
  profileId: Scalars['String']['input'];
};


export type MutationSetPersonalThresholdArgs = {
  input?: InputMaybe<ThresholdInput>;
};


export type MutationSetTimeSeriesVisibilityArgs = {
  roleVisibility?: InputMaybe<Array<InputMaybe<Scalars['RoleRef']['input']>>>;
  seriesId: Scalars['ID']['input'];
  visibility: Scalars['Boolean']['input'];
};


export type MutationSortLinksInGroupSpaceArgs = {
  spaceId: Scalars['ID']['input'];
  spaceLinkIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationStartPhoneNumberVerificationArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubscribePushChannelArgs = {
  pushChannelId: Scalars['ID']['input'];
};


export type MutationSyncSocialNetworkToGalleryArgs = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  galleryId: Scalars['ID']['input'];
  socialNetworkId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerLoginByMailArgs = {
  mailTemplateKey?: InputMaybe<Scalars['String']['input']>;
  receiverMail: Scalars['String']['input'];
};


export type MutationTriggerNewsFeedDatasourceUpdateArgs = {
  datasourceId: Scalars['ID']['input'];
};


export type MutationTriggerTimeSeriesChangedListenerArgs = {
  seriesId: Scalars['ID']['input'];
};


export type MutationUnlinkDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationUnlinkUserDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationUnsubscribePushChannelArgs = {
  pushChannelId: Scalars['ID']['input'];
};


export type MutationUpdateActivatorArgs = {
  id: Scalars['ID']['input'];
  update: ComponentActivatorInput;
};


export type MutationUpdateAdminUserArgs = {
  id: Scalars['ID']['input'];
  request?: InputMaybe<AdminUserInput>;
};


export type MutationUpdateAdvertiseGraphicArgs = {
  file: Scalars['UploadId']['input'];
};


export type MutationUpdateAndroidAppSettingsArgs = {
  settings: AndroidAppSettingsInput;
};


export type MutationUpdateAndroidAppStoreResourceArgs = {
  file: Scalars['UploadId']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationUpdateAndroidAppStoreSettingsArgs = {
  settings: AndroidAppStoreSettingsInput;
};


export type MutationUpdateAppConfigurationArgs = {
  configuration: AppConfigurationInput;
};


export type MutationUpdateApplicationComponentArgs = {
  id: Scalars['ID']['input'];
  update: ApplicationComponentUpdate;
};


export type MutationUpdateBarcodeArgs = {
  id: Scalars['ID']['input'];
  update: BarcodeUpdate;
};


export type MutationUpdateBase64ImageInWorksheetCellArgs = {
  autoId: Scalars['Int']['input'];
  base64: Scalars['String']['input'];
  imageProperty: Scalars['String']['input'];
  worksheetId: Scalars['ID']['input'];
};


export type MutationUpdateBonusBookletArgs = {
  id: Scalars['ID']['input'];
  input: BonusBookletInput;
};


export type MutationUpdateBookingResourceArgs = {
  id: Scalars['ID']['input'];
  resource: BookingResourceInput;
};


export type MutationUpdateBookingRuleArgs = {
  id: Scalars['ID']['input'];
  rule: BookingRuleInput;
};


export type MutationUpdateBookingScheduleArgs = {
  id: Scalars['ID']['input'];
  schedule: BookingScheduleInput;
};


export type MutationUpdateBookingTagArgs = {
  id: Scalars['ID']['input'];
  tag: BookingTagInput;
};


export type MutationUpdateBookmarksArgs = {
  input: UserBookmarksInput;
};


export type MutationUpdateCmsSettingsArgs = {
  settings: CmsSettingsInput;
};


export type MutationUpdateCalendarArgs = {
  calendarId: Scalars['ID']['input'];
  data: CalendarInput;
};


export type MutationUpdateCalendarApplicationComponentArgs = {
  id: Scalars['ID']['input'];
  update: CalendarApplicationComponentUpdate;
};


export type MutationUpdateCalendarEmbedUrlArgs = {
  componentId: Scalars['ID']['input'];
};


export type MutationUpdateCalendarEventsArgs = {
  data: CalendarEventTemplate;
  eventId: Scalars['ID']['input'];
  scope: ModificationScope;
  seriesId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateCalendarRegistrationFormArgs = {
  id: Scalars['ID']['input'];
  input: CalendarRegistrationFormInput;
};


export type MutationUpdateChatApplicationComponentArgs = {
  id: Scalars['ID']['input'];
  update: ChatApplicationComponentInput;
};


export type MutationUpdateChatChannelArgs = {
  id: Scalars['ID']['input'];
  input: ChatChannelInput;
};


export type MutationUpdateChatChannelInfoArgs = {
  channelId: Scalars['ID']['input'];
  info: ChannelInfoInput;
};


export type MutationUpdateChatChannelNotificationArgs = {
  channelId: Scalars['ID']['input'];
  notify: Scalars['Boolean']['input'];
};


export type MutationUpdateChatComponentArgs = {
  id: Scalars['ID']['input'];
  input: ChatComponentInput;
};


export type MutationUpdateChatMessageArgs = {
  id: Scalars['ID']['input'];
  update: ChatMessageUpdateInput;
};


export type MutationUpdateChatPollArgs = {
  chatPollId: Scalars['ID']['input'];
  input: ChatPollInput;
};


export type MutationUpdateChatProfileSettingsArgs = {
  update: ChatProfileSettingsInput;
};


export type MutationUpdateConsentSettingsArgs = {
  settings: DataConsentInput;
};


export type MutationUpdateCurrentAppArgs = {
  appId: Scalars['String']['input'];
};


export type MutationUpdateCustomEnumValueArgs = {
  entry: CustomEnumKeyInput;
  enumId: Scalars['ID']['input'];
};


export type MutationUpdateFamilyMemberArgs = {
  id: Scalars['ID']['input'];
  userProfile: FamilyMemberInput;
};


export type MutationUpdateFileRefArgs = {
  update: FileRefUpdate;
};


export type MutationUpdateFileShareComponentSettingsArgs = {
  id: Scalars['ID']['input'];
  input: FileShareComponentSettings;
};


export type MutationUpdateFileStoreApplicationComponentArgs = {
  id: Scalars['ID']['input'];
  update: FileStoreApplicationComponentUpdate;
};


export type MutationUpdateFileStoreFileArgs = {
  file: Scalars['FSFileId']['input'];
  storeId: Scalars['FSFileId']['input'];
  update: FsFileUpdateInput;
};


export type MutationUpdateGalleryArgs = {
  id: Scalars['ID']['input'];
  input: GalleryInput;
};


export type MutationUpdateGalleryAlbumArgs = {
  galleryAlbumId: Scalars['ID']['input'];
  input: GalleryAlbumDataInput;
};


export type MutationUpdateGalleryApplicationComponentArgs = {
  id: Scalars['ID']['input'];
  update: GalleryApplicationComponentUpdate;
};


export type MutationUpdateGroupArgs = {
  group: GroupInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateGroupSpaceArgs = {
  id: Scalars['ID']['input'];
  update: GroupSpaceUpdate;
};


export type MutationUpdateIosAppSettingsArgs = {
  settings: IosAppSettingsInput;
};


export type MutationUpdateIosAppStoreResourceArgs = {
  file: Scalars['UploadId']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationUpdateIosAppStoreSettingsArgs = {
  settings: IosAppStoreSettingsInput;
};


export type MutationUpdateItemTrackerArgs = {
  id: Scalars['ID']['input'];
  update: ItemTrackerComponentInput;
};


export type MutationUpdateListComponentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ListComponentInput>;
};


export type MutationUpdateListEntryArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ListEntryInput>;
};


export type MutationUpdateListOrderArgs = {
  id: Scalars['ID']['input'];
  sourceIndex: Scalars['Int']['input'];
  targetIndex: Scalars['Int']['input'];
};


export type MutationUpdateLocationArgs = {
  location?: InputMaybe<LocationInput>;
  locationId: Scalars['ID']['input'];
};


export type MutationUpdateManualNewsFeedEntryArgs = {
  input: NewsFeedEntryInput;
  newsFeedEntryId: Scalars['ID']['input'];
};


export type MutationUpdateMapComponentArgs = {
  id: Scalars['ID']['input'];
  input: MapComponentInput;
};


export type MutationUpdateMapComponentPoiArgs = {
  id: Scalars['ID']['input'];
  input: MapComponentPoiInput;
  mapId: Scalars['ID']['input'];
};


export type MutationUpdateNewsApplicationComponentArgs = {
  id: Scalars['ID']['input'];
  update: NewsApplicationComponentUpdate;
};


export type MutationUpdateNewsApplicationEmbedUrlArgs = {
  componentId: Scalars['ID']['input'];
};


export type MutationUpdateNewsFeedDatasourceArgs = {
  id: Scalars['ID']['input'];
  input: NewsFeedDataSourceInput;
};


export type MutationUpdateNewsFeedSubscriptionsArgs = {
  active: Scalars['Boolean']['input'];
  applicationId: Scalars['ID']['input'];
  datasourceId: Scalars['ID']['input'];
};


export type MutationUpdatePaymentProviderApiSettingsArgs = {
  settings: PaymentProviderApiSettingsInput;
};


export type MutationUpdatePinboardApplicationComponentArgs = {
  id: Scalars['ID']['input'];
  update: PinboardApplicationComponentUpdate;
};


export type MutationUpdatePinboardCardArgs = {
  cardId: Scalars['ID']['input'];
  update: PinboardCardUpdate;
};


export type MutationUpdatePortalAppIconArgs = {
  file: Scalars['UploadId']['input'];
};


export type MutationUpdateProductArgs = {
  id: Scalars['ID']['input'];
  input: ProductDefinitionInput;
};


export type MutationUpdateProjectStructureNodeArgs = {
  id: Scalars['ID']['input'];
  update: ProjectStructureNodeUpdateInput;
};


export type MutationUpdatePushChannelArgs = {
  channel: PushChannelInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePushConfigurationArgs = {
  input: PushConfigurationInput;
};


export type MutationUpdatePushHistoryComponentArgs = {
  id: Scalars['ID']['input'];
  input: PushHistoryComponentInput;
};


export type MutationUpdatePushNotificationArgs = {
  id: Scalars['ID']['input'];
  pushNotification: PushNotificationInput;
};


export type MutationUpdateResourceArgs = {
  id: Scalars['ID']['input'];
  resource: BasicResourceUpdateInput;
};


export type MutationUpdateResourceCategoryArgs = {
  id: Scalars['ID']['input'];
  input: ResourceCategoryInput;
};


export type MutationUpdateResourceUploadComponentArgs = {
  id: Scalars['ID']['input'];
  input: ResourceUploadComponentInput;
};


export type MutationUpdateSocialNetworkConfigurationArgs = {
  id: Scalars['ID']['input'];
  update: SocialNetworkConfigurationInput;
};


export type MutationUpdateStatusIndicatorArgs = {
  input?: InputMaybe<StatusIndicatorInput>;
};


export type MutationUpdateStructureNodeCategoryArgs = {
  category: ProjectStructureNodeCategoryInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTemplateCouponArgs = {
  couponId: Scalars['ID']['input'];
  update: CouponUpdate;
};


export type MutationUpdateTextImageComponentArgs = {
  data: TextImageComponentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTextWidgetArgs = {
  id: Scalars['ID']['input'];
  update: TextWidgetInput;
};


export type MutationUpdateTimeSeriesDataArgs = {
  data: TimeSeriesDataInput;
  seriesId: Scalars['ID']['input'];
};


export type MutationUpdateTrackedItemArgs = {
  id: Scalars['ID']['input'];
  input: TrackedItemInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  request?: InputMaybe<UserInput>;
};


export type MutationUpdateUserCurrentAppArgs = {
  appId: Scalars['AppID']['input'];
};


export type MutationUpdateUserProfileArgs = {
  id: Scalars['ID']['input'];
  userProfile: UserProfileInput;
};


export type MutationUpdateUserProfileConfigurationArgs = {
  input?: InputMaybe<UserProfileConfigurationInput>;
};


export type MutationUpdateUserProfileFromDeviceArgs = {
  id: Scalars['ID']['input'];
  userProfile?: InputMaybe<UserProfileInput>;
};


export type MutationUpdateUserProfileImageArgs = {
  file: Scalars['UploadId']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserProfileImageFromDeviceArgs = {
  base64Image: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateWidgetSettingsArgs = {
  id: Scalars['ID']['input'];
  settings: WidgetSettingsInput;
};


export type MutationUpdateWorkbookArgs = {
  input: WorkbookInput;
  workbookId: Scalars['ID']['input'];
};


export type MutationUpdateWorksheetArgs = {
  input: WorksheetInput;
  worksheetId: Scalars['ID']['input'];
};


export type MutationUpdateWorksheetRowArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  worksheetId: Scalars['ID']['input'];
};


export type MutationUpdateWorkspaceContentWithTextArgs = {
  file: Scalars['WSFileId']['input'];
  text: Scalars['String']['input'];
};


export type MutationUpdateWorkspaceFileMetaArgs = {
  file: Scalars['WSFileId']['input'];
  meta: WsFileMetaUpdate;
};


export type MutationUpdateWorkspaceLinkArgs = {
  file: Scalars['WSFileId']['input'];
  url: Scalars['String']['input'];
};


export type MutationUploadPushNotificationCertificateArgs = {
  file: Scalars['UploadId']['input'];
  keyId: Scalars['String']['input'];
};


export type MutationVerifyProfileArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationNode = {
  __typename?: 'NavigationNode';
  /** Name des Icons aus dem jeweiligen Pool */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** name für nav Links */
  name?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  /** angezeigter Text im Navigationsmenü */
  title?: Maybe<Scalars['String']['output']>;
};

export type NewsApplicationComponent = ApplicationComponent & {
  __typename?: 'NewsApplicationComponent';
  /** Option um Reaktion auf Manuelle News zu erlauben */
  allowReactions?: Maybe<Scalars['Boolean']['output']>;
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Die Textfarbe des Haupttextes */
  bodyTextColor?: Maybe<Scalars['String']['output']>;
  /** Liste der IDs der verwendeten NewsFeedDatasources */
  datasourcesUsed?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  /** Option um die source tags aus zu blenden */
  hideSourceTag?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Text der über den Newsbeiträgen angezeigt wird */
  informationText?: Maybe<Scalars['String']['output']>;
  /** Option um die Pushnachrichten für dieses Modul zu muten */
  muted?: Maybe<Scalars['Boolean']['output']>;
  /** Option um Links in dem Modul extern zu öffnen */
  openExternally?: Maybe<Scalars['Boolean']['output']>;
  /** Die Textfarbe der Titel */
  titleTextColor?: Maybe<Scalars['String']['output']>;
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
  /** In welcher Form die News angezeigt werden */
  visualizationType?: Maybe<NewsFeedVisualizationType>;
};

export type NewsApplicationComponentUpdate = {
  /** Option um Reaktion auf Manuelle News zu erlauben */
  allowReactions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Die Textfarbe des Haupttextes */
  bodyTextColor?: InputMaybe<Scalars['String']['input']>;
  /** Liste der zu verwendenden Datenquellen */
  datasourcesUsed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Option um die Source tags auszublenden */
  hideSourceTag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Text der über den Newsbeiträgen angezeigt wird */
  informationText?: InputMaybe<Scalars['String']['input']>;
  /** Option um die Pushnachrichten für dieses Modul zu muten */
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Option um Links in dem Modul extern zu öffnen */
  openExternally?: InputMaybe<Scalars['Boolean']['input']>;
  /** Die Textfarbe der Titel */
  titleTextColor?: InputMaybe<Scalars['String']['input']>;
  /** In welcher Form die News angezeigt werden */
  visualizationType?: InputMaybe<NewsFeedVisualizationType>;
};

/**
 * Definition einer externen Datenquelle, welche in einen Newsfeed eingebunden werden kann.
 * Es erfolgt eine periodische Abfrage in der jeweils eingestellten Frequenz
 */
export type NewsFeedDataSource = {
  __typename?: 'NewsFeedDataSource';
  /** nur aktive Datenquellen werden regelmäßig aktualisiert */
  active: Scalars['Boolean']['output'];
  /** zu welcher App gehört die Datenquelle */
  appId: Scalars['AppID']['output'];
  /** Wird automatisch (initial) abonniert */
  autoSubscribe?: Maybe<Scalars['Boolean']['output']>;
  /** Schreibberechtigung */
  canWrite?: Maybe<Scalars['Boolean']['output']>;
  /** Farbe */
  color?: Maybe<Scalars['String']['output']>;
  /** Anzahl aktuell abgerufener Einträge innerhalb des Feeds */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** eventuelle Fehlermeldungen bei der letzten Abfrage */
  hints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** eindeutige Id */
  id: Scalars['ID']['output'];
  /** Handle zu dem Log Output des letzten Updates */
  lastUpdateLogId?: Maybe<Scalars['BatchId']['output']>;
  /** wann wurde die externe Datenquelle zuletzt abgefragt */
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  /** geplanter Zeitpunkt der nächsten Aktualisierung */
  nextUpdate?: Maybe<Scalars['Date']['output']>;
  /** Das Publikationsdatum der zuletzt per Push versendeten Nachricht */
  publishedDateOfLastMessagePushed?: Maybe<Scalars['Date']['output']>;
  /** Aktualisierungsfrequenz in Minuten (nicht kleiner als 5 Minuten) */
  refreshRate: Scalars['Int']['output'];
  socialNetwork?: Maybe<SocialNetworkConfiguration>;
  /**
   * opt. spezifischer Zusatzparameter, um die gewünschten Daten innerhalb des Social-Network-Accounts
   * einzuschränken. z.B die Id des Facebook Albums
   */
  socialNetworkCollectionId?: Maybe<Scalars['String']['output']>;
  /**
   * Bei Instagram oder Facebook Datenquellen benötigen wir die jeweiligen Access Token.
   * Die Logik diese Tokens zu besorgen und aktuell zu halten liegt außerhalb.
   * Siehe dazu die Query "getSocialNetworkConfigurations".
   */
  socialNetworkConfigId?: Maybe<Scalars['ID']['output']>;
  /** Ist dieser Feed abonnierbar */
  subscribable?: Maybe<Scalars['Boolean']['output']>;
  /** Anzahl der App-Installationen, die diesen Kanal abonniert haben. */
  subscriberCount: Scalars['Int']['output'];
  /** Anzeigename */
  title: Scalars['String']['output'];
  /** Art der Datenquelle */
  type: NewsFeedDataSourceType;
  /** die eigentliche externe Quelle */
  url?: Maybe<Scalars['String']['output']>;
  /** Gruppen mit Schreibberechtigung. Aktuell nur für die Datenquelle MANUAL relevant */
  writerGroups?: Maybe<Array<Maybe<Group>>>;
};

/** Eingabe Parameter zum Erstellen einer News Datenquelle */
export type NewsFeedDataSourceInput = {
  /** nur aktive Datenquellen werden regelmäßig aktualisiert */
  active: Scalars['Boolean']['input'];
  /** Wird automatisch (initial) abonniert */
  autoSubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Farbe */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Aktualisierungsfrequenz in Minuten (nicht kleiner als 5 Minuten) */
  refreshRate?: InputMaybe<Scalars['Int']['input']>;
  /** Adressierung innerhalb des Netzwerks */
  socialNetworkCollectionId?: InputMaybe<Scalars['ID']['input']>;
  /** Bei Instagram oder Facebook Datenquellen benötigen wir die jeweiligen Access Token */
  socialNetworkConfigId?: InputMaybe<Scalars['ID']['input']>;
  /** Ist dieser Feed abonnierbar */
  subscribable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Anzeigename */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Art der Datenquelle */
  type: NewsFeedDataSourceType;
  /** die eigentliche externe Quelle */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Gruppen mit Schreibberechtigung. Aktuell nur für die Datenquelle MANUAL relevant */
  writerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum NewsFeedDataSourceType {
  /** manuell eingegebene News Beiträge */
  Manual = 'MANUAL',
  /** Ein RSS-Feed */
  Rss = 'RSS',
  /** Soziale Netwerke wie Instagram oder Facebook */
  SocialNetwork = 'SOCIAL_NETWORK'
}

export type NewsFeedEntry = {
  __typename?: 'NewsFeedEntry';
  /** Ob der Beitrag (für nicht admins) geladen wird */
  active: Scalars['Boolean']['output'];
  /** Zu welcher App gehört der Eintrag */
  appId: Scalars['AppID']['output'];
  /** Author des Beitrags */
  author?: Maybe<Scalars['String']['output']>;
  /** der eigentliche Inhalt */
  body?: Maybe<Scalars['String']['output']>;
  /** welcher Datenquelle ist der Eintrag zugeordnet */
  datasourceId: Scalars['String']['output'];
  /** Beschreibung oder Zusammenfassung des Inhalts */
  description?: Maybe<Scalars['String']['output']>;
  /** ist das expiratonDate erreicht, wird die News nicht mehr geladen */
  expirationDate?: Maybe<Scalars['Date']['output']>;
  /** Die guid, benötigt für die YouTube Video ID */
  guid?: Maybe<Scalars['String']['output']>;
  /** eindeutige ID des Eintrags */
  id: Scalars['ID']['output'];
  /** Link zu einer externen Seite */
  link?: Maybe<Scalars['String']['output']>;
  /** Bilder */
  mediaRefs?: Maybe<Array<Maybe<MediaReference>>>;
  /** Reaktionenanzahl */
  newsReactionCount?: Maybe<Array<Maybe<NewsReactionCount>>>;
  /** Gibt an, ob die News angepinnt wurde */
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** Position bezüglich der Datenquelle (z.B. im RSS-Feed) */
  position?: Maybe<Scalars['Int']['output']>;
  /** nach dem Publikationsdatum wird üblicherweise sortiert */
  publishedDate: Scalars['Date']['output'];
  /** Reaktionen */
  reactions?: Maybe<Array<Maybe<NewsFeedReaction>>>;
  /** die Überschrift */
  title?: Maybe<Scalars['String']['output']>;
  /** Datum der letzen Änderung */
  updatedDate?: Maybe<Scalars['Date']['output']>;
};

/** Eingabedaten für einen manuellen Eintrag in einem Newsfeed. */
export type NewsFeedEntryInput = {
  /** standardmäßig nicht direkt sichtbar */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Author des Beitrags */
  author?: InputMaybe<Scalars['String']['input']>;
  /** der eigentliche Inhalt */
  body: Scalars['String']['input'];
  /** Id der Datenquelle des Typs MANUAL */
  datasourceId: Scalars['String']['input'];
  /** Wann soll der Eintrag ausgeblendet werden */
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Ein Link auf eine externe Seite */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Bilder / Videos aus verschiedenen Quellen */
  mediaRefs?: InputMaybe<Array<InputMaybe<MediaReferenceInput>>>;
  /** standardmäßig nicht angepinnt */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Wann soll der Eintrag publiziert werden */
  publishedDate: Scalars['Date']['input'];
  /** die Überschrift */
  title: Scalars['String']['input'];
};

/** Eine Reaktion auf einem News Eintrag */
export type NewsFeedReaction = {
  __typename?: 'NewsFeedReaction';
  reaction?: Maybe<NewsFeedReactionEnum>;
  senderDeviceId?: Maybe<Scalars['String']['output']>;
  senderProfileId?: Maybe<Scalars['String']['output']>;
};

export enum NewsFeedReactionEnum {
  /**  🙄 U+1F644  */
  SmileyAnnoyed = 'SMILEY_ANNOYED',
  /**  👏 U+1F44F  */
  SmileyClap = 'SMILEY_CLAP',
  /**  💥 U+1F4A5  */
  SmileyCollision = 'SMILEY_COLLISION',
  /**  😎 U+1F60E  */
  SmileyCool = 'SMILEY_COOL',
  /**  🔥 U+1F525  */
  SmileyFire = 'SMILEY_FIRE',
  /**  🙌 U+1F64C  */
  SmileyHands = 'SMILEY_HANDS',
  /**  😊 U+1F60A  */
  SmileyHappy = 'SMILEY_HAPPY',
  /**  ❤️ U+2764  */
  SmileyHeart = 'SMILEY_HEART',
  /**  😂 U+1F602  */
  SmileyLaugh = 'SMILEY_LAUGH',
  /**  🏅 U+1F389  */
  SmileyMedal = 'SMILEY_MEDAL',
  /**  👌 U+1F44C  */
  SmileyOk = 'SMILEY_OK',
  /**  🎉 U+1F389  */
  SmileyPartypopper = 'SMILEY_PARTYPOPPER',
  /**  🌈 U+1F308  */
  SmileyRainbow = 'SMILEY_RAINBOW',
  /**  😢 U+1F622  */
  SmileySad = 'SMILEY_SAD',
  /**  😯 U+1F62F  */
  SmileySurprised = 'SMILEY_SURPRISED',
  /**  👎 U+1F44E  */
  SmileyThumbsdown = 'SMILEY_THUMBSDOWN',
  /**  👍 U+1F44D  */
  SmileyThumbsup = 'SMILEY_THUMBSUP',
  /**  😉 U+1F609  */
  SmileyWink = 'SMILEY_WINK'
}

/** Eine Reaktion auf einen News eintrag */
export type NewsFeedReactionInput = {
  reaction?: InputMaybe<NewsFeedReactionEnum>;
};

export enum NewsFeedVisualizationType {
  /** Bild wird ganz oben auf voller Breite angezeigt */
  ImageAboveTitle = 'IMAGE_ABOVE_TITLE',
  /** Bild ist neben dem Titel */
  ImageNextToTitle = 'IMAGE_NEXT_TO_TITLE'
}

/** Aggregierte Anzahl einer Reaktion */
export type NewsReactionCount = {
  __typename?: 'NewsReactionCount';
  count?: Maybe<Scalars['Int']['output']>;
  reaction?: Maybe<NewsFeedReactionEnum>;
};

export type PageRequest = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort: Sort;
};

/** Bechreibt die Teilnahem eines Teams an einem Turnierkalender */
export type Participation = {
  __typename?: 'Participation';
  /** Name des Tournieres/Liga */
  competitionName: Scalars['String']['output'];
  /** ID des Tournierkalenders/Saison */
  tournamentCalendarId: Scalars['String']['output'];
};

export enum PaymentEnvironment {
  /** Produktivumgebung */
  Prod = 'PROD',
  Test = 'TEST'
}

export type PaymentProviderApiSettingsInput = {
  prodAPIKey?: InputMaybe<Scalars['String']['input']>;
  testAPIKey?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentProviderApiStatus = {
  __typename?: 'PaymentProviderApiStatus';
  prodStatus?: Maybe<PaymentProviderConnectionStatus>;
  ready?: Maybe<Scalars['Boolean']['output']>;
  testStatus?: Maybe<PaymentProviderConnectionStatus>;
};

export type PaymentProviderConnectionStatus = {
  __typename?: 'PaymentProviderConnectionStatus';
  incoming?: Maybe<Scalars['Boolean']['output']>;
  outgoing?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentProviderReference = {
  __typename?: 'PaymentProviderReference';
  /** Umgebung des Zahlungsanbieters */
  environment?: Maybe<PaymentEnvironment>;
  productRefId?: Maybe<Scalars['String']['output']>;
  /** Feld wird gesetzt, sobald das Produkt beim Zahlungsdienstleister registriert wurde */
  refId?: Maybe<Scalars['String']['output']>;
};

export type PaymentSession = {
  __typename?: 'PaymentSession';
  /** Netto */
  amount_tax?: Maybe<Scalars['Long']['output']>;
  /** Brutto */
  amount_total?: Maybe<Scalars['Long']['output']>;
  /** Währung */
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Rechnungsnummer */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoice_pdf_url?: Maybe<Scalars['String']['output']>;
  /** Profil */
  owner?: Maybe<UserProfileBasicData>;
  ownerId?: Maybe<Scalars['String']['output']>;
  /** gezahlt */
  payed?: Maybe<Scalars['Boolean']['output']>;
  /** Gezahlt am */
  payedAt?: Maybe<Scalars['Date']['output']>;
  url: Scalars['String']['output'];
};

export type PaymentSessionPagingResponse = {
  __typename?: 'PaymentSessionPagingResponse';
  content?: Maybe<Array<Maybe<PaymentSession>>>;
  totalcount: Scalars['Int']['output'];
};

export enum Permission {
  ActivateComponent = 'ACTIVATE_COMPONENT',
  AppackInternal = 'APPACK_INTERNAL',
  AppSettingsManager = 'APP_SETTINGS_MANAGER',
  AppUserManager = 'APP_USER_MANAGER',
  BeaconManager = 'BEACON_MANAGER',
  ComponentAdmin = 'COMPONENT_ADMIN',
  CreateApps = 'CREATE_APPS',
  DivisionAdmin = 'DIVISION_ADMIN',
  LivestreamManager = 'LIVESTREAM_MANAGER',
  ManageComponent = 'MANAGE_COMPONENT',
  MemberProfilesManager = 'MEMBER_PROFILES_MANAGER',
  PreviewAppPush = 'PREVIEW_APP_PUSH',
  PushChannelAdmin = 'PUSH_CHANNEL_ADMIN',
  PushManager = 'PUSH_MANAGER',
  QrCodeManager = 'QR_CODE_MANAGER',
  ResourceManager = 'RESOURCE_MANAGER',
  ShowStats = 'SHOW_STATS',
  SyncS3 = 'SYNC_S3',
  UserAdmin = 'USER_ADMIN'
}

/** Mitglied eines Teams in der Rolle eines Spielers, Trainiers etc. */
export type Person = {
  __typename?: 'Person';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  matchName: Scalars['String']['output'];
  personId: Scalars['ID']['output'];
  placeOfBith?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum PhoneNumberVerificationStatus {
  /** Standard bei allen Profilen, die kein Verify Service benutzen */
  NotVerified = 'NOT_VERIFIED',
  /** ein Code wurde gesendet, der User muss diesen noch eingeben */
  Pending = 'PENDING',
  /** Der Nutzer muss seine Telefonnummer noch eingeben, um die Verifikation zu starten */
  Required = 'REQUIRED',
  /** Nummer wurde verifiziert */
  Verified = 'VERIFIED'
}

/**
 * Eine Pinnwand Applikation ist ein Modul innerhalb einer App oder auch eine eigene Browser App.
 * Konzeptionell ist es ähnlich zu einem Trello Board, das mehre Listen enthalten kann, die in
 * vertikalen Reihen angeornet sind und selbst einzelne Karten enthalten.
 */
export type PinboardApplicationComponent = ApplicationComponent & {
  __typename?: 'PinboardApplicationComponent';
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hat der Nutzer Schreibberechtigung */
  canRead?: Maybe<Scalars['Boolean']['output']>;
  /** Hat der Nutzer Leseberechtigung */
  canWrite?: Maybe<Scalars['Boolean']['output']>;
  /** welche Kategorien sind enthalten. Daraus ergeben sich die Spalten */
  cardCategories?: Maybe<Array<Maybe<PinboardCardCategory>>>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  /** eindeutige Id */
  id: Scalars['ID']['output'];
  /** Leseberechtigte Gruppen */
  readerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
  visualizationType?: Maybe<PinboardVisualizationType>;
  /** Schreibberechtigte Gruppen */
  writerGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PinboardApplicationComponentUpdate = {
  /** Reihenfolge der Kategorien */
  cardCategories?: InputMaybe<Array<InputMaybe<PinboardCardCategoryInput>>>;
  /** Leseberechtigte Gruppen */
  readerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Darstellungsart des Pinboards */
  visualizationType?: InputMaybe<PinboardVisualizationType>;
  /** Schreibberechtigte Gruppen */
  writerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Eine einzelne Karte/PostIT an der Pinnwand */
export type PinboardCard = {
  __typename?: 'PinboardCard';
  /** Nur aktive Karten werden öffentlich angezeigt. Inaltive sehen nur die Ersteller der Karte */
  active: Scalars['Boolean']['output'];
  /** Zu welcher App gehört die Karte */
  appId: Scalars['AppID']['output'];
  /** E-Mail des Autors */
  authorEmail?: Maybe<Scalars['String']['output']>;
  /** Name des Autors */
  authorName?: Maybe<Scalars['String']['output']>;
  /** Id des App Nutzer Profils im Falle eines registrierten Autors */
  authorProfileId?: Maybe<Scalars['String']['output']>;
  /** der eigentliche Inhalt. Kann HTML Formatierungen enthalten */
  body?: Maybe<Scalars['String']['output']>;
  /** eindeutige Id der Karte */
  cardId: Scalars['ID']['output'];
  /** welcher Kategorie innerhalb des Boards ist die Karte zugeordnet */
  categoryId: Scalars['ID']['output'];
  /** Datum an dem die Karte erstellt wurde */
  creationDate: Scalars['Date']['output'];
  /** ist das expiratonDate erreicht, wird die Karte nicht mehr geladen */
  expirationDate?: Maybe<Scalars['Date']['output']>;
  /** Bilder */
  mediaRefs?: Maybe<Array<Maybe<MediaReference>>>;
  /** nach dem Publikationsdatum wird üblicherweise sortiert, sofern vorhanden */
  publishedDate?: Maybe<Scalars['Date']['output']>;
  /** die Unterüberschrift */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** die Überschrift */
  title?: Maybe<Scalars['String']['output']>;
  /** Datum der letzen Änderung */
  updatedDate?: Maybe<Scalars['Date']['output']>;
};

/** Eine Spalte/Liste logische Reihe innerhalb einer Pinnwand. */
export type PinboardCardCategory = {
  __typename?: 'PinboardCardCategory';
  cards?: Maybe<Array<Maybe<PinboardCard>>>;
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** Input der Pinnboard Kategorie */
export type PinboardCardCategoryInput = {
  /** Farbe der Kategorie */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Die Id der Kategorie zum prüfen, ob diese existiert */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Titel der Kategorie */
  title: Scalars['String']['input'];
};

/** Input der Pinnboard Karte */
export type PinboardCardInput = {
  /** der eigentliche Inhalt. Kann HTML Formatierungen enthalten */
  body?: InputMaybe<Scalars['String']['input']>;
  /** ist das expiratonDate erreicht, wird die Karte nicht mehr geladen */
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Bilder */
  mediaRefs?: InputMaybe<Array<InputMaybe<MediaReferenceInput>>>;
  /** welcher Kategorie innerhalb des Boards ist die Karte zugeordnet */
  pinboardCardCategoryId: Scalars['ID']['input'];
  /** nach dem Publikationsdatum wird üblicherweise sortiert, sofern vorhanden */
  publishedDate?: InputMaybe<Scalars['Date']['input']>;
  /** die Unterüberschrift */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** die Überschrift */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Felder, die bei einer exitierenden Karte aktualisiert werden können */
export type PinboardCardUpdate = {
  /** Nur aktive Karten werden öffentlich angezeigt. Inaltive sehen nur die Ersteller der Karte */
  active: Scalars['Boolean']['input'];
};

export enum PinboardVisualizationType {
  /** Alle Kategorien werden geladen und man kann von horizontal scrollen */
  PinboardScrollOverview = 'PINBOARD_SCROLL_OVERVIEW',
  /** Nur eine Kategorie wird geladen, die Kategorien rechts und links werden nur angedeutet. */
  PinboardSliderOverview = 'PINBOARD_SLIDER_OVERVIEW'
}

export type Price = {
  __typename?: 'Price';
  /** Betrag in Euro-Cent bzw. der kleinsten Einheit der Währung */
  amount: Scalars['Int']['output'];
  /**
   * Three-letter <a href="https://www.iso.org/iso-4217-currency-codes.html">ISO currency code</a>
   * for now only 'eur' is supported.
   */
  currency: Scalars['String']['output'];
  /** Id sofern mit Zahlungsanbieter registriert */
  id?: Maybe<Scalars['ID']['output']>;
};

export type PriceInput = {
  /** Betrag in Euro-Cent bzw. der kleinsten Einheit der Währung */
  amount: Scalars['Int']['input'];
  /**
   * Three-letter <a href="https://www.iso.org/iso-4217-currency-codes.html">ISO currency code</a>
   * for now only 'eur' is supported.
   */
  currency: Scalars['String']['input'];
};

export type ProductCreditInput = {
  product: Scalars['ID']['input'];
  profile: Scalars['ID']['input'];
  units: Scalars['Int']['input'];
};

export type ProductDefinition = {
  __typename?: 'ProductDefinition';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Resource>;
  /** verweis auf das Produkt-Bild in der Mediathek */
  imageId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  /** Feld wird gesetzt, sobald das Produkt beim Zahlungsdienstleister registriert wurde */
  paymentProviderReference?: Maybe<PaymentProviderReference>;
  /** verhindern, dass das Produkt im Vorrat gekauft werden kann. */
  preventStockpile?: Maybe<Scalars['Boolean']['output']>;
  /** Standard Preis */
  price: Price;
  /** Zeigt an, wie oft das Produkt gekauft wurde. Benötigt spezielle Berechtigung */
  sellCount?: Maybe<Scalars['Int']['output']>;
  /** Steuer */
  tax?: Maybe<Tax>;
  type?: Maybe<ProductType>;
  /** Anzahl der Einheiten. Wird beim Multi-Ticket verwendet */
  unitCount?: Maybe<Scalars['Int']['output']>;
  /** Anzahl der gültigen Monate, Zeitticket */
  validMonths?: Maybe<Scalars['Int']['output']>;
};

export type ProductDefinitionInput = {
  /** aktiviert oder deaktiviert das Produkt */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID des Produktbildes aus der Mediathek */
  imageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** verhindern, dass das Produkt im Vorrat gekauft werden kann. */
  preventStockpile?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<PriceInput>;
  /** Steuersatz */
  tax?: InputMaybe<TaxInput>;
  type?: InputMaybe<ProductType>;
  /** Anzahl der Einheiten. Wird beim Multi-Ticket verwendet */
  unitCount?: InputMaybe<Scalars['Int']['input']>;
  /** Anzahl der gültigen Monate, Zeitticket */
  validMonths?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProductType {
  /** Mehrfachkarte */
  MultiTicket = 'MULTI_TICKET',
  /** Ticket kann in einem Zeitraum beliebig verwendet werden */
  SeasonTicket = 'SEASON_TICKET',
  /** Ticket kann einmal verwendet werden bevor es ungültig wird */
  SingleTicket = 'SINGLE_TICKET'
}

/** Die Einstellungen zu einem verwendeten Feld des Benutzerprofils */
export type ProfileFieldInput = {
  /** Ob es sich um ein Pflichtfeld handelt oder nicht */
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Ob das Feld nur gelesen werden kann, also vom User nicht selbst geändert */
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileValidationStatus = {
  __typename?: 'ProfileValidationStatus';
  emailVerificationPending?: Maybe<Scalars['Boolean']['output']>;
  phoneVerificationPending?: Maybe<Scalars['Boolean']['output']>;
  roleVerificationPending?: Maybe<Scalars['Boolean']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type ProjectContentQuery = {
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<ProjectContentType>>>;
};

export type ProjectContentQueryResult = {
  __typename?: 'ProjectContentQueryResult';
  items?: Maybe<Array<Maybe<ProjectContentQueryResultItem>>>;
};

export type ProjectContentQueryResultItem = {
  __typename?: 'ProjectContentQueryResultItem';
  categories?: Maybe<Array<Maybe<ProjectStructureNodeCategory>>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProjectContentType>;
};

export enum ProjectContentType {
  ComponentReference = 'COMPONENT_REFERENCE',
  DynamicPage = 'DYNAMIC_PAGE',
  Page = 'PAGE'
}

/** Vertagsinformationen zu dem Projekt */
export type ProjectContractInfo = {
  __typename?: 'ProjectContractInfo';
  contracts?: Maybe<Array<Maybe<ContractInfo>>>;
  id: Scalars['ID']['output'];
};

export type ProjectIconSet = {
  __typename?: 'ProjectIconSet';
  icons?: Maybe<Array<Maybe<ModuleIcon>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProjectMetadata = {
  __typename?: 'ProjectMetadata';
  /** Werbegrafik für den App-Banner */
  advertisingGraphic_url?: Maybe<Scalars['String']['output']>;
  aos_advert_icon_url?: Maybe<Scalars['String']['output']>;
  /**  ## Berbetext  */
  aos_adverttext?: Maybe<Scalars['String']['output']>;
  /**  ## AppIcon Android  */
  aos_appicon_url?: Maybe<Scalars['String']['output']>;
  /**  ## Name der App Android  */
  aos_appname?: Maybe<Scalars['String']['output']>;
  /**  ## Link im Appstore  */
  aos_appstore_link?: Maybe<Scalars['String']['output']>;
  /**   ## Update angefordert?  */
  aos_askForUpdate?: Maybe<Scalars['Boolean']['output']>;
  /**  ## Kategorie  */
  aos_category?: Maybe<Scalars['String']['output']>;
  /**  ## Beschreibung  */
  aos_description?: Maybe<Scalars['String']['output']>;
  /**  ## Kommentar an die Entwickler  */
  aos_dev_comment?: Maybe<Scalars['String']['output']>;
  /**  ## Developer Account  */
  aos_developer_account?: Maybe<Scalars['String']['output']>;
  /**  ## Google Push Key  */
  aos_fcm_server_key?: Maybe<Scalars['String']['output']>;
  /**   ## Firebase Project ID  */
  aos_firebase_project_id?: Maybe<Scalars['String']['output']>;
  aos_function_icon_url?: Maybe<Scalars['String']['output']>;
  /**  ## Going live datum  */
  aos_goinglive?: Maybe<Scalars['Date']['output']>;
  /**  ## High resolution icon  */
  aos_high_resolution_icon_url?: Maybe<Scalars['String']['output']>;
  /**  ## Letztes Update  */
  aos_lastUpdate?: Maybe<Scalars['Date']['output']>;
  /**  ## Version der Library  */
  aos_libVersion?: Maybe<Scalars['Int']['output']>;
  /**   ## Kurzbeschreibung  */
  aos_short_description?: Maybe<Scalars['String']['output']>;
  /**  ## AppIcon Android  */
  aos_splasscreenicon_url?: Maybe<Scalars['String']['output']>;
  /**  ## Website  */
  aos_website?: Maybe<Scalars['String']['output']>;
  /**  ## Vertragsgruppe  */
  contractGroup?: Maybe<Scalars['String']['output']>;
  /**  ## Facebook-Seite  */
  facebookPage?: Maybe<Scalars['String']['output']>;
  /**  ## Kurzname auf dem Display  */
  ios_app_short_name?: Maybe<Scalars['String']['output']>;
  /**  ## AppIcon-URL für IOS  */
  ios_appicon_76x76_url?: Maybe<Scalars['String']['output']>;
  /**   ## AppIcon-URL für IOS  */
  ios_appicon_152x152_url?: Maybe<Scalars['String']['output']>;
  /**  ## AppIcon-URL für IOS  */
  ios_appicon_167x167_url?: Maybe<Scalars['String']['output']>;
  /**   ## AppIcon-URL für IOS  */
  ios_appicon_180x180_url?: Maybe<Scalars['String']['output']>;
  /**  ## AppIcon-URL für IOS alias 120x120  */
  ios_appicon_big_url?: Maybe<Scalars['String']['output']>;
  /**   ## IOS Apple-Account  */
  ios_apple_Account?: Maybe<Scalars['String']['output']>;
  /**  ## Name der IOS App */
  ios_appname?: Maybe<Scalars['String']['output']>;
  /**   ## AppStore Link IOS  */
  ios_appstore_link?: Maybe<Scalars['String']['output']>;
  /**  ## Update-Request gesetzt  */
  ios_askForUpdate?: Maybe<Scalars['Boolean']['output']>;
  /**  ## IOS Bundle id of app */
  ios_bundle_id?: Maybe<Scalars['String']['output']>;
  /**  ## Katgorie a  */
  ios_category_a?: Maybe<Scalars['String']['output']>;
  /**  ## Kategorie b  */
  ios_category_b?: Maybe<Scalars['String']['output']>;
  /**   ## Copyright  */
  ios_copyright?: Maybe<Scalars['String']['output']>;
  /**  ## Beschreibung im Appstore  */
  ios_description?: Maybe<Scalars['String']['output']>;
  /**  ## Kommentar für die Entwickler  */
  ios_dev_comment?: Maybe<Scalars['String']['output']>;
  /**   ## Developer Account IOS  */
  ios_developer_Account?: Maybe<Scalars['String']['output']>;
  /**   ## Datum des Going-Live IOS  */
  ios_goinglive?: Maybe<Scalars['Date']['output']>;
  /**   ## IOS High Resolution-Icon  */
  ios_high_resolution_icon_url?: Maybe<Scalars['String']['output']>;
  /**   ## IOS version  */
  ios_iosVersion?: Maybe<Scalars['String']['output']>;
  /**  ## Keywords  */
  ios_keywords?: Maybe<Scalars['String']['output']>;
  /**  ## Letztes Updatedatum IOS  */
  ios_lastUpdate?: Maybe<Scalars['Date']['output']>;
  /**  ## Library Version IOS  */
  ios_libVersion?: Maybe<Scalars['Int']['output']>;
  /**  ## Marketing URL  */
  ios_marketing_url?: Maybe<Scalars['String']['output']>;
  /**  ## Notiz für IOS  */
  ios_note?: Maybe<Scalars['String']['output']>;
  /**  ## Promotext IOS  */
  ios_promotext?: Maybe<Scalars['String']['output']>;
  /**  ## AppIcon-URL für IOS  */
  ios_splasscreen_1242x2208_url?: Maybe<Scalars['String']['output']>;
  /**  ## Untertitel der IOS App  */
  ios_subname?: Maybe<Scalars['String']['output']>;
  /**  ## SupportURL  */
  ios_support_url?: Maybe<Scalars['String']['output']>;
  /**  ## IOS Bundle id of app */
  ios_team_id?: Maybe<Scalars['String']['output']>;
  /**  ## Icon  */
  portalAppIconUrl?: Maybe<Scalars['String']['output']>;
  /**  ## Name der App im CMS  */
  portalAppName?: Maybe<Scalars['String']['output']>;
  /**  ## Beschreibung zum Projekt  */
  projectDescription?: Maybe<Scalars['String']['output']>;
  /**  ## Google Push Key  */
  projectType?: Maybe<Scalars['String']['output']>;
  /**  ## Verfügbarer Videospeicher  */
  videoQuotaMB?: Maybe<Scalars['String']['output']>;
};

export type ProjectMetrics = {
  __typename?: 'ProjectMetrics';
  /** Anzahl der Android Geräte */
  androidDeviceCount?: Maybe<Scalars['Int']['output']>;
  /** Dateum des letzten Updates */
  androidLastUpdate?: Maybe<Scalars['Date']['output']>;
  /** Datum der Veröffentlichung bei Google Play */
  androidPublicationDate?: Maybe<Scalars['Date']['output']>;
  /** Das App Icon ist für beide Betriebssysteme hinterlegt */
  appIconSet: Scalars['Boolean']['output'];
  /** Anzahl der gepflegten Termine in allen Kalendern in den nächsten 100 Tagen */
  calendarEventsInNext100days?: Maybe<Scalars['Int']['output']>;
  /** Liefert die Information, ob ein Kalendermodul verbaut ist */
  calendarModuleExists?: Maybe<Scalars['Boolean']['output']>;
  /** Anzahl der User Accounts im CMS, die dieser App zugeordnet sind */
  cmsUserCount?: Maybe<Scalars['Int']['output']>;
  /** App Store Beschreibungstext aus der App, die gerade angezeigt wird */
  description?: Maybe<Scalars['String']['output']>;
  /** zu welcher App Gruppe */
  groupId: Scalars['AppID']['output'];
  /** Anzahl der Gruppen mit aktiviertem Dashboard */
  groupSpacesCount: Scalars['Int']['output'];
  /** Anzahl der Apple Geräte */
  iosDeviceCount?: Maybe<Scalars['Int']['output']>;
  /** Dateum des letzten Updates */
  iosLastUpdate?: Maybe<Scalars['Date']['output']>;
  /** Datum der Veröffentlichung im App Store */
  iosPublicationDate?: Maybe<Scalars['Date']['output']>;
  /** Zeitpunkt des letzten CMS Logins */
  lastCmsLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Name des zuletzt eingeloggten Users */
  lastLoginBy?: Maybe<Scalars['String']['output']>;
  /** wann wurde zuletzt eine Push Nachricht gesendet */
  lastPushNotificationSent?: Maybe<Scalars['Date']['output']>;
  /** Name der App, die gerade angezeigt wird */
  name?: Maybe<Scalars['String']['output']>;
  /** Projektphase */
  phase?: Maybe<Scalars['Int']['output']>;
  /** Es wurde eine Datenschutz URL hinterlegt */
  privacyPolicySet: Scalars['Boolean']['output'];
  /** Ist es ein Stifterhelfen, DOSB oder Spezuialentwicklungsprojekt. Dies wird aus der welcomepage und dem contractGroup abgeleitet */
  projectType?: Maybe<ProjectType>;
  /** Ablaufdatum des Push Zertifikats für iOS */
  pushCertificateExpirationDate?: Maybe<Scalars['Date']['output']>;
  /** Zahl der jemals gesendeten Push Nachrichten */
  pushNotificationCount: Scalars['Int']['output'];
  /** Service-Level */
  serviceLevel?: Maybe<ProjectServiceLevel>;
  /** Der Start Screen ist für beide Betriebssysteme hinterlegt */
  splashScreenSet: Scalars['Boolean']['output'];
  /** Summe der Geräte */
  totalDeviceCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProjectServiceLevel {
  /** Advanced Paket */
  Advanced = 'ADVANCED',
  /** individuelle Absprachen, siehe Vertrag */
  Individual = 'INDIVIDUAL',
  /** kein SLA */
  None = 'NONE',
  /** gemäß PLUS Paket */
  Plus = 'PLUS'
}

export type ProjectSpecification = {
  __typename?: 'ProjectSpecification';
  /** Liste der Komponenten Referenzen */
  components?: Maybe<Array<Maybe<ComponentReference>>>;
  /** Group id of the app */
  groupId: Scalars['String']['output'];
  /** navigation types */
  iosNavigationType?: Maybe<Scalars['String']['output']>;
  /** Schlagworte für die Suche im CMS */
  keywords?: Maybe<Scalars['String']['output']>;
  /** Language of the app (de,en,it,fr etc.) */
  locale?: Maybe<Scalars['String']['output']>;
  /** technischer Name */
  name: Scalars['String']['output'];
  /** Anzeigename im Portal */
  portalAppName?: Maybe<Scalars['String']['output']>;
};

export type ProjectStructureNode = {
  __typename?: 'ProjectStructureNode';
  /** Kategorien des Knotens */
  categories?: Maybe<Array<Maybe<ProjectStructureNodeCategory>>>;
  /** momentan nur beim root node gesetzt. Enthält die Elemente des App Menüs in der definierten Reihenfolge */
  children?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  component?: Maybe<ComponentReference>;
  id: Scalars['ID']['output'];
  /** Beschriftung des Knotens */
  label?: Maybe<Scalars['String']['output']>;
  /** Id des übergeordneten Nodes, außer beim Root */
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type ProjectStructureNodeCategory = ICategory & {
  __typename?: 'ProjectStructureNodeCategory';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
};

export type ProjectStructureNodeCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Input Daten, um ein neues Modul zu einer App hinzuzufügen. */
export type ProjectStructureNodeCreateInput = {
  /** Typ abhängige Zusatzinformationen, wie z.B die Vorlage */
  extraData?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: ComponentReferenceType;
};

/** Eigenschaften, die an einem Strukturknoten geändert werden können */
export type ProjectStructureNodeUpdateInput = {
  badgeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconSet?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ComponentState>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibleByProfileGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibleByProfileRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ProjectType {
  Dosb = 'DOSB',
  Pwv = 'PWV',
  Sh = 'SH',
  Standard = 'STANDARD'
}

export type PushCertificateInfo = {
  __typename?: 'PushCertificateInfo';
  expireDate?: Maybe<Scalars['Date']['output']>;
  expiresInDays?: Maybe<Scalars['Int']['output']>;
};

export type PushChannel = {
  __typename?: 'PushChannel';
  active?: Maybe<Scalars['Boolean']['output']>;
  allowedGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  allowedGroups?: Maybe<Array<Maybe<Group>>>;
  appId: Scalars['AppID']['output'];
  autoSubscribe?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageResource?: Maybe<Resource>;
  imageResourceId?: Maybe<Scalars['String']['output']>;
  initialSubscribe?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  soundId?: Maybe<Scalars['String']['output']>;
  /** true, Wenn das aktuelle Gerät am Kanal abonniert ist */
  subscribed?: Maybe<Scalars['Boolean']['output']>;
  subscriptionCount?: Maybe<Scalars['Int']['output']>;
};

export type PushChannelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowedGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  autoSubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageResourceId?: InputMaybe<Scalars['String']['input']>;
  initialSubscribe?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['Int']['input'];
  soundId?: InputMaybe<Scalars['String']['input']>;
};

export type PushConfiguration = {
  __typename?: 'PushConfiguration';
  /** Erzwingt das Verschicken über einen Push-Kanal */
  forceSendOverPushChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Voreinstellung des Push-Nachrichten-Versands */
  preset?: Maybe<PushConfigurationPreset>;
};

export type PushConfigurationInput = {
  /** Erzwingt das Verschicken über einen Push-Kanal */
  forceSendOverPushChannel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Voreinstellung des Push-Nachrichten-Versands */
  preset?: InputMaybe<PushConfigurationPresetInput>;
};

export type PushConfigurationPreset = {
  __typename?: 'PushConfigurationPreset';
  channelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  departmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PushConfigurationPresetInput = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PushHistoryComponent = {
  __typename?: 'PushHistoryComponent';
  /** Hintergrundfarbe (gerade) */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Hintergrundfarbe (ungerade) */
  backgroundColor2?: Maybe<Scalars['String']['output']>;
  /** Farbe Text-Datum */
  dateTextColor?: Maybe<Scalars['String']['output']>;
  /** Tage-Limit */
  dayLimit?: Maybe<Scalars['Int']['output']>;
  headerImage?: Maybe<Resource>;
  headerImageId?: Maybe<Scalars['ID']['output']>;
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Nachrichtenlimit */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Farbe Text */
  messageTextColor?: Maybe<Scalars['String']['output']>;
};

export type PushHistoryComponentInput = {
  /** Hintergrundfarbe (gerade) */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Hintergrundfarbe (ungerade) */
  backgroundColor2?: InputMaybe<Scalars['String']['input']>;
  /** Farbe Text-Datum */
  dateTextColor?: InputMaybe<Scalars['String']['input']>;
  /** Tage-Limit */
  dayLimit?: InputMaybe<Scalars['Int']['input']>;
  headerImageId?: InputMaybe<Scalars['ID']['input']>;
  /** Nachrichtenlimit */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Farbe Text */
  messageTextColor?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotification = {
  __typename?: 'PushNotification';
  androidUsers?: Maybe<Scalars['Int']['output']>;
  androidUsersMax?: Maybe<Scalars['Int']['output']>;
  appId?: Maybe<Scalars['String']['output']>;
  badge?: Maybe<Scalars['Int']['output']>;
  channelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** join zu den Push Channels für die Anzeige */
  channels?: Maybe<Array<Maybe<PushChannel>>>;
  componentId?: Maybe<Scalars['String']['output']>;
  /** Die Referenz zum optionalen Nachladen der Props (titel, icon...) */
  componentReference?: Maybe<ComponentReference>;
  /** Kritische Push-Nachricht */
  critical?: Maybe<Scalars['Boolean']['output']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dispatchDate?: Maybe<Scalars['Date']['output']>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  iphoneUsers?: Maybe<Scalars['Int']['output']>;
  iphoneUsersMax?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<PushNotificationMode>;
  /** Wenn durch News-Modul versendet steht hier die Data-Source Id */
  newsFeedDataSource?: Maybe<NewsFeedDataSource>;
  /**  Anzahl der aussteneden Sendevorgänge */
  pending?: Maybe<Scalars['Int']['output']>;
  /** Überprüft, ob es eine persönliche Nachricht ist */
  personalNotification?: Maybe<Scalars['Boolean']['output']>;
  publicPushNotification?: Maybe<Scalars['Boolean']['output']>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sheduleDate?: Maybe<Scalars['Date']['output']>;
  sound?: Maybe<Scalars['Boolean']['output']>;
  soundId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PushNotificationStatus>;
  /** Optionaler Titel */
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationInput = {
  /** Filter auf Push-Kanäle */
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Chat channel */
  chatChannelId?: InputMaybe<Scalars['String']['input']>;
  /** Komponente in welche eingesprungen werden soll */
  componentId?: InputMaybe<Scalars['String']['input']>;
  /** Kritische Push-Nachricht */
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter auf Abteilunen */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter auf Gruppen */
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Bild, welches mit der Push-Nachricht verschickt werden soll */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** der eigentliche Nachrichten Inhalt (Text, Bild, Badge, Sound...) */
  message: Scalars['String']['input'];
  mode?: InputMaybe<PushNotificationMode>;
  /** Filter auf App-Nutzer-Rollen */
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Date to dispatch message */
  sheduleDate?: InputMaybe<Scalars['Date']['input']>;
  /** Soll ein akkustisches Signal auf dem Gerät ertönen */
  sound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id der Sound Datei, die in der App vorhanden sein muss */
  soundId?: InputMaybe<Scalars['String']['input']>;
  /** Optionaler Titel */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Optinale externe URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Mode einer Push Benachrichtigung */
export enum PushNotificationMode {
  Normal = 'NORMAL',
  Test = 'TEST'
}

export type PushNotificationReceiverStats = {
  __typename?: 'PushNotificationReceiverStats';
  androidUsers?: Maybe<Scalars['Int']['output']>;
  iphoneUsers?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PushNotificationSendApplicationComponent = ApplicationComponent & {
  __typename?: 'PushNotificationSendApplicationComponent';
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
};

/** Status einer Push Benachrichtigung */
export enum PushNotificationStatus {
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export type Query = {
  __typename?: 'Query';
  /** analysiert alle Referenzen innerhalb einer Seite */
  analyseDependencies: WsDependencyAnalysis;
  applicationChatComponent?: Maybe<ChatApplicationComponent>;
  applicationComponent?: Maybe<ApplicationComponent>;
  /**
   * Berechnet die Anzahl der maximal möglichen Empfänger welche die gegebene Nachricht unter Verwendung der Filter erreichen könnte.
   * deprecated see AppBagroundJob
   */
  calculatePushNotificationMaxReceivers?: Maybe<PushNotificationReceiverStats>;
  /** Lesen einer Chat-Komponente */
  chatComponent?: Maybe<ChatComponent>;
  /**
   * Wird verwendet, um den Status von Registrierungen abzufragen. Wenn beispielsweise bei
   * öffentlichen Registrierungen Ids im local storage sind.
   */
  checkCalendarEventRegistrationStatus?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** lädt die N aktuellsten Events des Devices */
  chirpstackEventsByDevice?: Maybe<Array<Maybe<ChirpStackEvent>>>;
  /** Zählt die Specs, auf welche der Nutzer Zugriff hat */
  countProjectSpecifications: Scalars['Int']['output'];
  /** Liefert einen Statistik-Eintrag pro Gutschein-Vorlage */
  couponStatistics?: Maybe<Array<Maybe<CouponStatistic>>>;
  /**
   * liefert eine historische Statistik über die Installationszahlen
   * zum Jahresende der vergangenen Jahre seit going live der App.
   */
  downloadHistory?: Maybe<DownloadHistory>;
  /** Exportiert die Buchungshistorie nach Excel */
  exportBookingHistory?: Maybe<Scalars['Boolean']['output']>;
  /** lifert den FileStore mit der gegebenen Id, sofern die notwendigen Rechte vorliegen */
  fileStore?: Maybe<FileStore>;
  /** Prüft, ob die Datei schon existiert */
  fileStoreFileExists?: Maybe<Scalars['Boolean']['output']>;
  /** Ruft die Logs zum Store ab */
  fileStoreOperationLogs?: Maybe<Array<Maybe<FileStoreOperationLog>>>;
  /** lädt die CMS Konponente */
  fileshareComponent?: Maybe<FileShareComponent>;
  findAdminUsers?: Maybe<UserPagingResponse>;
  /** Lädt die Bookmarks */
  findBookingBookmarks?: Maybe<Array<Maybe<BookingBookmark>>>;
  /** Lädt den Buchungskalender für eine Resource */
  findBookingCalendar?: Maybe<BookingCalendarSimple>;
  /** Lädt Buchungen */
  findBookingHistory?: Maybe<BookingPagingResponse>;
  /** Lädt eine Resource */
  findBookingResourceById?: Maybe<BookingResource>;
  /** Lädt alle Resources */
  findBookingResources?: Maybe<Array<Maybe<BookingResource>>>;
  /** Lädt nach Filter */
  findBookingResourcesFiltered?: Maybe<Array<Maybe<BookingResource>>>;
  /** Lädt eine Buchungsregel */
  findBookingRuleById?: Maybe<BookingRule>;
  /** Lädt alle Buchungsregeln */
  findBookingRules?: Maybe<Array<Maybe<BookingRule>>>;
  findBookingScheduleById?: Maybe<BookingSchedule>;
  /** Lädt alle Schedules */
  findBookingSchedules?: Maybe<Array<Maybe<BookingSchedule>>>;
  /** Lädt ein Tag */
  findBookingTagById?: Maybe<BookingTag>;
  /** Lädt alle Tags */
  findBookingTags?: Maybe<Array<Maybe<BookingTag>>>;
  /** Lädt Buchungen */
  findBookings?: Maybe<Array<Maybe<Booking>>>;
  /**
   * listet alle Ereignisse die mit dem gegebenen Kalender verbunden sind.
   * Der Kalender selbst muss sich im gleichen App Kontext befinden wie der anfragende User.
   * Optional kann der Zeitraum noch eingegrenzt werden, was die Performance beim Paging verbessert
   * Optional eine Freitext, der innerhalb der Titel, Untertitel und Kategorien sucht
   * Optional kann die Suche auf bestimmte Locations eingeschränkt werden
   */
  findCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  /** Sucht Chat-Nachrichten in einem Kanal */
  findChatMessages?: Maybe<Array<Maybe<ChatMessage>>>;
  /** Lädt ein Group Space */
  findGroupSpace?: Maybe<GroupSpace>;
  /** Lädt einen App-Nutzer */
  findOneUserProfile?: Maybe<UserProfile>;
  /** Suche nach einer app */
  findProjectSpecificationByNameLike?: Maybe<Array<Maybe<ProjectSpecification>>>;
  /**  Listet alle Push Nachrichten zu einer App und mit bestimmtem Status */
  findPushNotifications?: Maybe<Array<Maybe<PushNotification>>>;
  findResourceByFilename?: Maybe<Resource>;
  findResourceByTitle?: Maybe<Resource>;
  findResourceCategories?: Maybe<Array<Maybe<ResourceCategory>>>;
  /** Lädt die verfügbaren Slots */
  findResourcePlans?: Maybe<Array<Maybe<BookingResourcePlan>>>;
  findResources?: Maybe<ResourcePagingResponse>;
  findResourcesByIds?: Maybe<Array<Maybe<Resource>>>;
  findResourcesByMimeType?: Maybe<Array<Maybe<Resource>>>;
  /** Lädt das Profil zu der Resource */
  findResponsibleProfileByBookingId?: Maybe<UserProfile>;
  /** Lädt das Profil zu der Resource */
  findResponsibleProfileByResourceId?: Maybe<UserProfile>;
  /** lädt die Timeseries Information zur gegebenen Id, jedoch nicht die Datenpunkte */
  findTimeSeriesById?: Maybe<TimeSeries>;
  /** Listet alle registrierten App-Nutzer zu einer AppId und dem optional gegebenen Suchfilter. */
  findUserProfile?: Maybe<UserProfilePagingResponse>;
  /** Findet alle Beziehungen zu dem angebeben Profil */
  findUserProfileRelations?: Maybe<Array<Maybe<UserProfileRelation>>>;
  /** Listet alle Benutzerprofile, die seit dem genannten Datum geändert wurden */
  findUserProfilesModifiedSince?: Maybe<Array<Maybe<UserProfile>>>;
  findUsers?: Maybe<UserPagingResponse>;
  /** Gibt die IOS-Einstellungen der App zurück */
  getAndroidAppSettings?: Maybe<AndroidAppSettings>;
  /** # Ruft die Einstellungen für den IOS Store ab */
  getAndroidAppStoreSettings?: Maybe<ProjectMetadata>;
  /** App-Admin-QR-Code erzeugen */
  getAppAdminQRCode?: Maybe<Scalars['String']['output']>;
  /** App-Konfiguration */
  getAppConfiguration?: Maybe<AppConfiguration>;
  /** Liefert den umschließenden Projekt-Container mit allen vorhandenen Versionen. */
  getAppackProject?: Maybe<AppackProject>;
  /** Liefert gezielt eine Projekt-Sprachversion. */
  getAppackProjectVersionForLanguage?: Maybe<AppackProjectVersion>;
  /** Gibt die Komponenten mit einem Badge-Icon zurück */
  getBadges?: Maybe<Array<Maybe<BadgeResult>>>;
  /** Ruft ein Bonusheft ab */
  getBonusBooklet?: Maybe<BonusBooklet>;
  /** Lade die Lesezeichen die vom Nutzer in der App gespeichert wurden */
  getBookmarks?: Maybe<UserBookmarks>;
  /** Gibt die CMS-Einstellungen zurück */
  getCMSSettings?: Maybe<CmsSettings>;
  /** Liefert eine verkürzte URL zu einem ICal-Feed, der alle Termine aller öffentlichen Kalender enthält. */
  getCalendarComponentICalFeedURL?: Maybe<Scalars['Url']['output']>;
  /** Liefert eine verkürzte URL, welche es ermöglicht alle öffentlichen Kalender der Komponente in der Hompage einzubetten. */
  getCalendarEmbedUrl?: Maybe<Scalars['Url']['output']>;
  /** Zugriff auf einen einzelnen Event */
  getCalendarEventById?: Maybe<CalendarEvent>;
  /**
   * Liefert eine verkürzte URL, welche von externen Diensten (z.B Google Kalender) benutzt werden kann,
   * um einen Kalender zu abonnieren, sofern der Kalender dafür freigeschaltet wurde.
   */
  getCalendarICalFeedUrl?: Maybe<Scalars['Url']['output']>;
  /** Liefert das Registrierungsformular */
  getCalendarRegistrationForm?: Maybe<CalendarRegistrationForm>;
  /** Liefert alle Registrierungsformulare der App */
  getCalendarRegistrationForms?: Maybe<Array<Maybe<CalendarRegistrationForm>>>;
  /** Gibt den angeforderten Kalender zurück */
  getCalender?: Maybe<Calendar>;
  /** reloads the chat channel */
  getChatChannel?: Maybe<ChatChannel>;
  /** Gibt alle im CMS angelegten Kanäle zurück. Diese Api gibt keine von Profilen erzeugten Kanäle zurück. */
  getChatChannels?: Maybe<Array<Maybe<ChatChannel>>>;
  /**
   * Liefert die offenen Einladungen für einen Kanal.
   * Wenn kein Kanal übergeben wird, werden die die offenen Einladungen für das aktuelle Profil zurückgegeben.
   */
  getChatInvitations?: Maybe<Array<Maybe<ChatChannelInvitation>>>;
  /** Ruft eine Chat-Nachricht ab */
  getChatMessage?: Maybe<ChatMessage>;
  /** Gibt die Chat-Nachrichten für den Kanal zurück. Es könnne die neusten oder die ältestens Nachrichten geladen werden. Diese werden immer Chronologisch sortiert. */
  getChatMessages?: Maybe<Array<Maybe<ChatMessage>>>;
  /** loads users currently online in channel */
  getChatOnlineProfiles?: Maybe<Array<Maybe<ChatUserProfile>>>;
  /** Liefert die UserProfile die zugestimmt haben im Verezeichnis angezeigt zu werden */
  getChatProfileDictionary?: Maybe<Array<Maybe<ChatUserProfile>>>;
  /** Liefert die Chat-Einstellungen für das aktuelle Profil */
  getChatProfileSettings?: Maybe<ChatProfileSettings>;
  /** lädt nur die untergeordnete Ebene des gegebenen Nodes. */
  getChildrenOfProjectStructureNode?: Maybe<Array<Maybe<ProjectStructureNode>>>;
  /** Gibt die Datenschutz-Einstellungen / Nutzungsbedinungen der App zurück */
  getDataConsentSettings?: Maybe<DataContent>;
  /** Liefert die Push-Nachrichten für das aktuelle Device. Optional kann eine ModulId mitgegeben werden. Dann werden nur die Push-Nachrichtne zurückgegeben die als Target das Modul haben. */
  getDevicePushNotifications?: Maybe<Array<Maybe<PushNotification>>>;
  /** Prüft, ob es einen Direktkanal zu dem Teilnehmer gibt und gibt diesen zurück */
  getDirectChannelToProfile?: Maybe<ChatChannel>;
  getDivisions?: Maybe<Array<Maybe<Division>>>;
  /** Liefert ein anonymen Token um z.B. Komponenten in die Website einbzubinden. */
  getEmbedToken?: Maybe<Scalars['String']['output']>;
  /** Ein einzelnes Album zum Laden in dynamischen Seiten. */
  getGalleryAlbumById?: Maybe<GalleryAlbum>;
  getGalleryById?: Maybe<Gallery>;
  /** liefert die Gruppe bei bekannter Id */
  getGroup?: Maybe<Group>;
  /** Gibt die IOS-Einstellungen der App zurück */
  getIOSAppSettings?: Maybe<IosAppSettings>;
  /** # Ruft die Einstellungen für den IOS Store ab */
  getIOSAppStoreSettings?: Maybe<ProjectMetadata>;
  /** Informationen zu einem gegebenen Match */
  getMatch?: Maybe<Match>;
  /** Gibt die Api Keys für den Zahlungsanbieter zurück */
  getPaymentProviderApiStatus?: Maybe<PaymentProviderApiStatus>;
  /** lädt die Grenzwerteinstellungen des aktuellen Users zu der gegebenen TimeSeries */
  getPersonalThreshold?: Maybe<Threshold>;
  /**
   * überprüft, ob zu der aktuellen DeviceId ein Profil im Status 'in Prüfung' gibt.
   * Entweder weil die Mailadresse oder eine genehmigungspflichtige Rolle noch bestätigt werden muss.
   */
  getProfileValidationStatus?: Maybe<ProfileValidationStatus>;
  /** Lädt die Spec des angegebenen Projekts */
  getProjectSpecification?: Maybe<ProjectSpecification>;
  /** Gibt die Push-Konfiguration zurück */
  getPushConfiguration?: Maybe<PushConfiguration>;
  /**
   * Liefert die Push-Nachrichten für das aktuelle Device. Wenn keine componentId übergeben wird, wird die
   * erste Push-History-Komponente zur Auswertung herangezogen.
   */
  getPushHistoryNotifications?: Maybe<Array<Maybe<PushNotification>>>;
  getPushNotificationCertificateInfo?: Maybe<PushCertificateInfo>;
  /** Wie ist der aktuelle Status des SEPA Mandats? */
  getSEPAMandateStatus: SepaMandateStatus;
  /** Ruft die soziale Netwerke-Einstellungen der App ab */
  getSocialNetworkConfiguration?: Maybe<SocialNetworkConfiguration>;
  /** Gibt die Social Network-Konfigurationen zurück */
  getSocialNetworkConfigurations?: Maybe<Array<Maybe<SocialNetworkConfiguration>>>;
  getSystemConfig?: Maybe<SystemConfig>;
  /** Liefert ein Team zu einer gegebenen Id */
  getTeam?: Maybe<Team>;
  /**
   * liefert einen JWT token, welcher für nachfolgende API Aufrufe verwendet werden kann.
   * Der Token hat eine Gültigkeit von 1 Stunde und hat die Berechtigungen (claims) welche bei dem API Key
   * konfiguriert sind.
   */
  getToken?: Maybe<Scalars['String']['output']>;
  /** Liefert einen Token mit den Rechten des zu der Mail gehörenden Benutzerprofils */
  getTokenByMailAndPin?: Maybe<Scalars['String']['output']>;
  /** Liefert die Tabelle bezüglich eines Turnierkalenders */
  getTournamentRanking?: Maybe<Ranking>;
  /**
   * Liefert alle Spiele innerhalb der gegebenen Tournier Kalender.
   * Optional werden die Spiele nach den teilenhmenden Teams gefiltert.
   * Wenn eine Mannschaft z.B in der Bundesliga und in einem Pokal spielt, müssen die Ids der Bundesliga-Saison und
   * der Pokal Saison mitgegeben werden, um alle Spiele der Mannschaft zu bekommen.
   */
  getTournamentSchedule?: Maybe<Array<Maybe<Match>>>;
  /** Liefert alle devices, welche mit dem aktuellen CMS-Benutzer ( für die aktuelle App) verbunden sind */
  getUserDevices?: Maybe<Array<Maybe<DeviceSummary>>>;
  /** Liefert die Einstellungen der Benutzer Profil Komponente */
  getUserProfileConfiguration: UserProfileConfiguration;
  /** Liefert den Dokumenten-Container zu einem Gruppen-Space */
  groupSpaceDocuments?: Maybe<FileStore>;
  /** Prüft, ob die Ap live ist */
  isAppLive?: Maybe<Scalars['Boolean']['output']>;
  /** Überprüft, ob die aktuelle DeviceId einem Profil zugewiesen ist - unabhängig von dem Token */
  isMyDeviceConnectedToProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Liefert die Komponente */
  itemTracker?: Maybe<ItemTrackerComponent>;
  /** Fordert die Informationen zu einer bestehenden Konferenz an */
  joinConference?: Maybe<Conference>;
  /** Listet alle Aktivierungen, die innerhalb der App angelegt wurden */
  listActivators?: Maybe<Array<Maybe<ComponentActivator>>>;
  /** listet nur Aktivierungen, die die gegebene Komponente betreffen, also diese aktivieren */
  listActivatorsForComponentId?: Maybe<Array<Maybe<ComponentActivator>>>;
  /** welche Datenquellen hat das aktuelle Gerät innerhalb der News Application abonniert */
  listActiveDatasourceSubscriptions?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Liefert die Aktiven Items der letzten 24 Stunden */
  listActiveTrackedItems?: Maybe<Array<Maybe<TrackedItem>>>;
  /** Lädt alle Alben der App */
  listAllGalleryAlbums?: Maybe<Array<Maybe<GalleryAlbum>>>;
  /** Gibt alle Projekte zurück. */
  listAllProjectSpecifications?: Maybe<Array<Maybe<ProjectSpecification>>>;
  /** Listet alles Barcodes/QRCodes, die für eine Komponente angelegt wurden */
  listBarcodesByComponentId?: Maybe<Array<Maybe<Barcode>>>;
  /** listet alle Kalender innerhalb einer Komponente */
  listCalendarByComponentId?: Maybe<Array<Maybe<Calendar>>>;
  /**
   * listet alle Registrierungen zu einer gegebenen Veranstaltung auf. Dieses ist
   * nur durch den Eigentümer der Veranstaltung möglich.
   */
  listCalendarEventRegistrations?: Maybe<Array<Maybe<CalendarEventRegistration>>>;
  /**
   * listet alle Registrierungen auf, die innerhalb eines bestimmten Zeitraumes und optional
   * bezüglich eines Kalenders erfolgt sind.
   */
  listCalendarEventRegistrationsInPeriod?: Maybe<Array<Maybe<CalendarEventRegistration>>>;
  /**
   * listet alle Kalender, die im aktuellen App Kontext vorhanden sind.
   * (nur für CMS admins)
   */
  listCalendars?: Maybe<Array<Maybe<Calendar>>>;
  /**
   * Diese Abfrage ist zur Verwendung im CMS Kontext gedacht, um alle Konfigurationseinstellungen
   * der Liste und alle Elemente zu laden. Die Sortierung und Filterung der Elemente erfolgt
   * client seitig.
   */
  listComponent?: Maybe<ListComponent>;
  /** Listet die referenzierten Komponenten/Module innerhalb der aktuellen App */
  listComponentReferences?: Maybe<Array<Maybe<ComponentReference>>>;
  /**
   * Hier werden nur aktiven Elemente der Liste geraden, die das anfragende Device sehen darf
   * (Filterung nach Rolle, Publikationsdatum). Die Sortierung erfolgt implizit wie in den
   * Meta Daten eingestellt.
   */
  listComponentWithFilteredEntries?: Maybe<ListComponent>;
  listEnumValues?: Maybe<Array<Maybe<CustomEnum>>>;
  /** Liefert das Feedback zu einem Event */
  listEventFeedback?: Maybe<Array<Maybe<CalendarEventFeedback>>>;
  /** Listet die Files unterhalb des gegebenen Folders */
  listFilesByParent?: Maybe<Array<Maybe<IwsFile>>>;
  /**
   * Listet alle für mich relevanten Mitgliedschaftsanfragen auf.
   *     Eingehende Request: Die das aktuelle Profil bestätigen kann
   *     Ausgehende Requests: Die das Profil selbst angefragt hat
   *     Die lässt sich anhand der inquirerId prüfen
   */
  listGroupRequests?: Maybe<Array<Maybe<GroupAccessRequest>>>;
  /** Listed alle Gruppen-Spaces in welchen der aktuelle User ist */
  listGroupSpaces?: Maybe<Array<Maybe<GroupSpace>>>;
  /** Listet alle Gruppen, die in der App existieren */
  listGroups?: Maybe<Array<Maybe<Group>>>;
  /** Gibt alle verfügbaren Icons für das aktuelle Projekt zurück */
  listIconSets?: Maybe<Array<Maybe<ProjectIconSet>>>;
  /** Rechnungen, die der aktuelle CMS Benutzer einsehen kann */
  listInvoices?: Maybe<Array<Maybe<Invoice>>>;
  /** listet alle Locations, die im aktuellen App Kontext vorhanden sind. */
  listLocations?: Maybe<Array<Maybe<Location>>>;
  /**
   * Listet alle Registrierungen des aktuellen Benutzers zu Terminen in den gegebenen Kalendern
   * im Zeitraum
   */
  listOwnCalendarEventRegistrations?: Maybe<Array<Maybe<CalendarEventRegistration>>>;
  /** Liest alle abgeschlossenen Payment-Sessions */
  listPaymentSessions?: Maybe<PaymentSessionPagingResponse>;
  listPermissions?: Maybe<Array<Maybe<Permission>>>;
  /** listet alle Grenzwert Einstellungen des aktuellen Benutzers */
  listPersonalThresholds?: Maybe<Array<Maybe<Threshold>>>;
  /** Listet alle Produkte des Produktkatalogs der App. */
  listProducts?: Maybe<Array<Maybe<ProductDefinition>>>;
  /** Listet die Produkte mit den gegebenen Ids */
  listProductsByIds?: Maybe<Array<Maybe<ProductDefinition>>>;
  /** listet alle Produkte der genannten Kategorien */
  listProductsByTypes?: Maybe<Array<Maybe<ProductDefinition>>>;
  /** Gibt alle Specs, auf die der Benutzer Zugriff hat zurück */
  listProjectSpecifications?: Maybe<Array<Maybe<ProjectSpecification>>>;
  /** Listet alle in der App vorhandenen Push Kanäle */
  listPushChannels?: Maybe<Array<Maybe<PushChannel>>>;
  /** Listet alle PushNachrichten, die gerade noch aktiv sind. */
  listPushNotificationsCurrentlyProcessed?: Maybe<Array<Maybe<PushNotification>>>;
  listResources?: Maybe<Array<Maybe<Resource>>>;
  /** lädt die Alben über die AlbenIds */
  listSelectedGalleryAlbums?: Maybe<Array<Maybe<GalleryAlbum>>>;
  listSharedResources?: Maybe<Array<Maybe<SharedResource>>>;
  listStatusIndicators?: Maybe<Array<Maybe<StatusIndicator>>>;
  /** Liefert alle Kategorien */
  listStructureNodeCategories?: Maybe<Array<Maybe<ProjectStructureNodeCategory>>>;
  /** Listet alle Gutschein Vorlagen im aktuellen App Kontext */
  listTemplateCoupons?: Maybe<Array<Maybe<Coupon>>>;
  /** listet die im aktuellen App Kontext vorhandenen TimeSeries auf. Per Default werden nur die sichtbar geschalteten Serien geliefert */
  listTimeSeries?: Maybe<Array<Maybe<TimeSeries>>>;
  /** Liefert eine Liste von Tracked Items */
  listTrackedItems?: Maybe<Array<Maybe<TrackedItem>>>;
  /**
   * Lädt die bevorstehenden n Termine entwerder aus allen für den aktuellen User sichtbaren Kalendern
   * innerhalb der gegebenen Komponente (componentId = Id eines Kalendermoduls) oder innerhalb des
   * einzelnen Kalenders (componentId = Id eines Kalenders)
   */
  listUpcomingCalendarEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  /** liefert die Verwendungsstellen eines Files */
  listWorkspaceFileUsages?: Maybe<Array<Maybe<ComponentReference>>>;
  /** Listet alle Files innerhalb des Workspace Folders */
  listWorkspaceFiles?: Maybe<Array<Maybe<IwsFile>>>;
  /**
   * liefert den Verlauf der Installationen zu der gegebenen AppId
   * in den letzten 30 Tagen (default)
   */
  loadDownloadStatsTimeSeries?: Maybe<Array<Maybe<DownloadStatsData>>>;
  /** Lädt eine Datei */
  loadFileStoreFile?: Maybe<FsFile>;
  /**
   * lädt den Strukturbaum des Projekts als Liste.
   * Die Hierarchie wird client-seitig erstellt.
   */
  loadProjectStructure?: Maybe<Array<Maybe<ProjectStructureNode>>>;
  /** Liefert die aktuellen Werte zu einer SerienId und Periode. */
  loadTimeSeriesData?: Maybe<Array<Maybe<TimeSeriesData>>>;
  /** lädt ein Workbook der aktuellen App */
  loadWorkbookComponent?: Maybe<WorkbookComponent>;
  /** Lädt alle Workbook-Vorlagen */
  loadWorkbookTemplates?: Maybe<Array<Maybe<WorkbookTemplate>>>;
  /** lädt die Meta Daten zu einem Arbeitsblatt */
  loadWorksheet?: Maybe<Worksheet>;
  /** Lädt die Daten eines Worksheets */
  loadWorksheetData?: Maybe<WorksheetPagingResponse>;
  /** Abrufen der Komponente */
  mapComponent?: Maybe<MapComponent>;
  /** Liefert alle mit dem Profil verbundenen Devices */
  myDevices?: Maybe<Array<Maybe<DeviceSummary>>>;
  /** Lädt ein einzigen Eintrag */
  newsEntry?: Maybe<NewsFeedEntry>;
  /** Liefert die Teilen-URL */
  newsEntryShareUrl?: Maybe<Scalars['Url']['output']>;
  /** Erzeugt einen chronologisch sortierten Newsfeed aus den gegebenen Datenquellen */
  newsFeed?: Maybe<Array<Maybe<NewsFeedEntry>>>;
  /** Lädt eine Datenquelle */
  newsFeedDatasource?: Maybe<NewsFeedDataSource>;
  /** Listet die im Kontext der App verfügbaren News Quellen */
  newsFeedDatasources?: Maybe<Array<Maybe<NewsFeedDataSource>>>;
  /**
   * Sofern die App einen nuLiga Account und damit auch eine ClubNr hinterlegt hat, werden alle Teams
   * dieses Clubs gelistet. Dies ist der Einstiegspunkt, um auf weitere Tabellen und Spielpläne
   * zu verweisen.
   */
  nuLigaListTeams?: Maybe<Array<Maybe<TeamAbbrDto>>>;
  /**
   * Liefert den Spielplan der nächsten Spiele (default)
   * oder auch die historischen
   */
  nuLigaTeamMeetings?: Maybe<Array<Maybe<MeetingAbbrDto>>>;
  /** Die Tabelle zu einem Team */
  nuLigaTeamTable?: Maybe<GroupTableDto>;
  /** liefert die Mannschaft zu der aktuellen App */
  ownTeam?: Maybe<Team>;
  /** Läst die Pinboard Application mit der gegebenen Id, sofern diese der aktuellen App zugeordnet ist */
  pinboardApplication?: Maybe<PinboardApplicationComponent>;
  /** Ruft alle angehefteten Nachrichten ab */
  pinnedChatMessages?: Maybe<Array<Maybe<ChatMessage>>>;
  /** liefert die Id der Profil-Komponente innerhalb der App */
  profileComponentId?: Maybe<Scalars['String']['output']>;
  /**
   * Liefert die wesentlichen Vertragsinformationen aus dem CRM System, sofern es zu dem
   * Projekt eine Vertragsbeziehung mizt einem Kunden gibt oder gegeben hat.
   * Verschiedenn Sprachversionen einer App, liefern die gleiche Information (id = groupId).
   */
  projectContractInfo?: Maybe<ProjectContractInfo>;
  /**
   * liefert verschiedene Meta Daten zum Stand des Projekts auf dessen
   * Basis bestimmte Widgets auf dem Dashboard angezeigt werden
   */
  projectMetrics?: Maybe<ProjectMetrics>;
  /**
   * Lädt die Spec des angegebenen Projekts
   * @deprecated use getProjectSpecification
   */
  projectSpec_projectSpecification?: Maybe<ProjectSpecification>;
  /** Gibt die Komponente zurück */
  pushHistoryComponent?: Maybe<PushHistoryComponent>;
  /** Durchsucht das Projekt */
  queryProjectContent?: Maybe<ProjectContentQueryResult>;
  /** Liefert den Pfad bis zum obersten Knoten */
  resolveFileHierarchy?: Maybe<Array<Maybe<FsFile>>>;
  /** Abrufen der Komponente */
  resourceUploadComponent?: Maybe<ResourceUploadComponent>;
  /** Gibt eine Liste von Kanälen zurück */
  subscribedChatChannels?: Maybe<Array<Maybe<ChatChannel>>>;
  /**
   * Liefert den Log Output zu dem Hintergrundprozess ab der gegebenen Position
   * bis zum aktuellen Ende oder Null, wenn der Log Output inzwischen gelöscht wurde
   */
  tailBatchProcessLog: LogTail;
  textImageComponent?: Maybe<TextImageComponent>;
  /** lädt das TextWidget mit bekannter Id */
  textWidget?: Maybe<TextWidget>;
  /** Lädt alle Text-Widgets in der aktuelle Sprache */
  textWidgets?: Maybe<Array<Maybe<TextWidget>>>;
  /** Gibt Kanäle zurück für die keine Subscription besteht */
  unsubscribedChatChannels?: Maybe<Array<Maybe<ChatChannel>>>;
  /**
   * liefert die geplanten bzw. laufendenen Spiele mit Beteiligung von Mannschaften, die der aktuellen App zugeordnet sind
   * in chronologischer Reihenfolge.
   */
  upcomingMatches?: Maybe<Array<Maybe<Match>>>;
  /** Information zu belegtem Speicherplatz nach Dateityp. */
  usageStatistics?: Maybe<UsageStatistics>;
  /** @deprecated use whoami */
  user_whoami?: Maybe<User>;
  /** prüft, ob es sich um eine gültige IBAN handelt. Wird innerhalb des SEPA Formulars verwendet. */
  validateIBAN?: Maybe<IbanValidationResult>;
  /** Listet alle Elemente im Wallet des Users bezüglich der aktuellen App */
  wallet?: Maybe<Array<Maybe<Ticket>>>;
  whoami?: Maybe<WhoamiResponse>;
  workbook_exportSheetData?: Maybe<Array<Maybe<GenericRow>>>;
  /** Deprecated use loadWorksheetData() */
  workbook_getSheetData?: Maybe<Array<Maybe<GenericRow>>>;
  /** Liefert das Workspace Basisverzeichnis der App */
  workspaceRoot?: Maybe<WsRoot>;
};


export type QueryAnalyseDependenciesArgs = {
  pageId: Scalars['WSFileId']['input'];
};


export type QueryApplicationComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalculatePushNotificationMaxReceiversArgs = {
  notification: PushNotificationInput;
};


export type QueryChatComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCheckCalendarEventRegistrationStatusArgs = {
  registrationIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryChirpstackEventsByDeviceArgs = {
  deviceID: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExportBookingHistoryArgs = {
  componentId: Scalars['ID']['input'];
  request: BookingSearchPageRequestInput;
};


export type QueryFileStoreArgs = {
  loadFiles: Scalars['Boolean']['input'];
  owner: Scalars['ID']['input'];
};


export type QueryFileStoreFileExistsArgs = {
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['FSFileId']['input']>;
  storeId: Scalars['FSFileId']['input'];
};


export type QueryFileStoreOperationLogsArgs = {
  storeId: Scalars['FSFileId']['input'];
};


export type QueryFileshareComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindAdminUsersArgs = {
  filterTechnicalUser?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageRequest>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindBookingBookmarksArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryFindBookingCalendarArgs = {
  end: Scalars['Date']['input'];
  resourceId: Scalars['ID']['input'];
  start: Scalars['Date']['input'];
};


export type QueryFindBookingHistoryArgs = {
  componentId: Scalars['ID']['input'];
  request: BookingSearchPageRequestInput;
};


export type QueryFindBookingResourceByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBookingResourcesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  componentId: Scalars['String']['input'];
};


export type QueryFindBookingResourcesFilteredArgs = {
  componentId: Scalars['String']['input'];
  filter?: InputMaybe<BookingResourceFilter>;
};


export type QueryFindBookingRuleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBookingRulesArgs = {
  componentId: Scalars['String']['input'];
};


export type QueryFindBookingScheduleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBookingSchedulesArgs = {
  componentId: Scalars['String']['input'];
};


export type QueryFindBookingTagByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindBookingTagsArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryFindBookingsArgs = {
  componentId: Scalars['ID']['input'];
  onlyMyBookings?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindCalendarEventsArgs = {
  calendarIds: Array<InputMaybe<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  range?: InputMaybe<DateRange>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindChatMessagesArgs = {
  channel: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type QueryFindGroupSpaceArgs = {
  spaceId: Scalars['ID']['input'];
};


export type QueryFindOneUserProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryFindProjectSpecificationByNameLikeArgs = {
  name: Scalars['String']['input'];
};


export type QueryFindPushNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  status: PushNotificationStatus;
};


export type QueryFindResourceByFilenameArgs = {
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};


export type QueryFindResourceByTitleArgs = {
  title: Scalars['String']['input'];
};


export type QueryFindResourceCategoriesArgs = {
  scope: Scalars['String']['input'];
};


export type QueryFindResourcePlansArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
  includeBooked?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId: Scalars['ID']['input'];
};


export type QueryFindResourcesArgs = {
  page?: InputMaybe<PageRequest>;
  search: ResourceSearchCriteria;
};


export type QueryFindResourcesByIdsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryFindResourcesByMimeTypeArgs = {
  mimeType: Scalars['String']['input'];
};


export type QueryFindResponsibleProfileByBookingIdArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryFindResponsibleProfileByResourceIdArgs = {
  resourceId: Scalars['ID']['input'];
};


export type QueryFindTimeSeriesByIdArgs = {
  timeSeriesId: Scalars['ID']['input'];
};


export type QueryFindUserProfileArgs = {
  page?: InputMaybe<PageRequest>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindUserProfileRelationsArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryFindUserProfilesModifiedSinceArgs = {
  since?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryFindUsersArgs = {
  page?: InputMaybe<PageRequest>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppAdminQrCodeArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAppackProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAppackProjectVersionForLanguageArgs = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['Locale']['input']>;
};


export type QueryGetBonusBookletArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCalendarComponentICalFeedUrlArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryGetCalendarEmbedUrlArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryGetCalendarEventByIdArgs = {
  calendarEventId: Scalars['ID']['input'];
};


export type QueryGetCalendarICalFeedUrlArgs = {
  calendarId: Scalars['ID']['input'];
};


export type QueryGetCalendarRegistrationFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCalenderArgs = {
  calendarId: Scalars['ID']['input'];
};


export type QueryGetChatChannelArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryGetChatInvitationsArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetChatMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetChatMessagesArgs = {
  channel: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order: ChatMessageOrder;
};


export type QueryGetChatOnlineProfilesArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryGetChildrenOfProjectStructureNodeArgs = {
  parentId: Scalars['ID']['input'];
};


export type QueryGetDevicePushNotificationsArgs = {
  componentId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryGetDirectChannelToProfileArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryGetGalleryAlbumByIdArgs = {
  galleryAlbumId: Scalars['ID']['input'];
};


export type QueryGetGalleryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type QueryGetPersonalThresholdArgs = {
  timeSeriesId: Scalars['ID']['input'];
};


export type QueryGetPushHistoryNotificationsArgs = {
  componentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSocialNetworkConfigurationArgs = {
  socialNetworkId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetTokenByMailAndPinArgs = {
  email: Scalars['String']['input'];
  pin: Scalars['Int']['input'];
};


export type QueryGetTournamentRankingArgs = {
  tournamentCalendarId?: Scalars['String']['input'];
  type?: Scalars['String']['input'];
};


export type QueryGetTournamentScheduleArgs = {
  filterTeams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tournamentCalendarIds: Array<Scalars['ID']['input']>;
};


export type QueryGroupSpaceDocumentsArgs = {
  spaceId: Scalars['ID']['input'];
};


export type QueryItemTrackerArgs = {
  component: Scalars['ID']['input'];
};


export type QueryJoinConferenceArgs = {
  input: ConferenceInput;
};


export type QueryListActivatorsForComponentIdArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryListActiveDatasourceSubscriptionsArgs = {
  newsApplicationId: Scalars['ID']['input'];
};


export type QueryListActiveTrackedItemsArgs = {
  component: Scalars['ID']['input'];
};


export type QueryListBarcodesByComponentIdArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryListCalendarByComponentIdArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryListCalendarEventRegistrationsArgs = {
  calendarEventId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListCalendarEventRegistrationsInPeriodArgs = {
  calendarId?: InputMaybe<Scalars['ID']['input']>;
  range: DateRange;
};


export type QueryListComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListComponentWithFilteredEntriesArgs = {
  componentId: Scalars['ID']['input'];
};


export type QueryListEnumValuesArgs = {
  enumIds: Array<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListEventFeedbackArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryListFilesByParentArgs = {
  parent: Scalars['WSFileId']['input'];
};


export type QueryListGroupsArgs = {
  listedGroupsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListOwnCalendarEventRegistrationsArgs = {
  calendarIds: Array<InputMaybe<Scalars['ID']['input']>>;
  range?: InputMaybe<DateRange>;
};


export type QueryListPaymentSessionsArgs = {
  page?: InputMaybe<PageRequest>;
};


export type QueryListProductsByIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryListProductsByTypesArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<ProductType>>>;
};


export type QueryListSelectedGalleryAlbumsArgs = {
  galleryAlbumIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryListTimeSeriesArgs = {
  visibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListTrackedItemsArgs = {
  component: Scalars['ID']['input'];
};


export type QueryListUpcomingCalendarEventsArgs = {
  amount: Scalars['Int']['input'];
  componentId: Scalars['ID']['input'];
};


export type QueryListWorkspaceFileUsagesArgs = {
  file: Scalars['WSFileId']['input'];
};


export type QueryListWorkspaceFilesArgs = {
  parent: Scalars['WSFileId']['input'];
};


export type QueryLoadDownloadStatsTimeSeriesArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLoadFileStoreFileArgs = {
  fileId: Scalars['FSFileId']['input'];
  storeId: Scalars['FSFileId']['input'];
};


export type QueryLoadTimeSeriesDataArgs = {
  period?: InputMaybe<TimePeriod>;
  seriesId: Scalars['ID']['input'];
};


export type QueryLoadWorkbookComponentArgs = {
  workbookId: Scalars['ID']['input'];
};


export type QueryLoadWorksheetArgs = {
  worksheetId: Scalars['ID']['input'];
};


export type QueryLoadWorksheetDataArgs = {
  filter: WorksheetQuery;
};


export type QueryMapComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsEntryArgs = {
  newsId: Scalars['ID']['input'];
};


export type QueryNewsEntryShareUrlArgs = {
  newsApplicationId: Scalars['ID']['input'];
  newsId: Scalars['ID']['input'];
};


export type QueryNewsFeedArgs = {
  datasources: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsFeedDatasourceArgs = {
  datasourceId: Scalars['ID']['input'];
};


export type QueryNuLigaTeamMeetingsArgs = {
  teamId: Scalars['String']['input'];
  upcomingOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNuLigaTeamTableArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryPinboardApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryPinnedChatMessagesArgs = {
  channel: Scalars['ID']['input'];
};


export type QueryProjectSpec_ProjectSpecificationArgs = {
  appId: Scalars['AppID']['input'];
};


export type QueryPushHistoryComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQueryProjectContentArgs = {
  query: ProjectContentQuery;
};


export type QueryResolveFileHierarchyArgs = {
  id: Scalars['FSFileId']['input'];
  storeId?: InputMaybe<Scalars['FSId']['input']>;
};


export type QueryResourceUploadComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTailBatchProcessLogArgs = {
  batchId: Scalars['BatchId']['input'];
  pos?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextImageComponentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTextWidgetArgs = {
  key: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateIbanArgs = {
  iban: Scalars['String']['input'];
};


export type QueryWorkbook_ExportSheetDataArgs = {
  appId: Scalars['AppID']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  worksheetId: Scalars['ID']['input'];
};


export type QueryWorkbook_GetSheetDataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  options: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  worksheetId?: InputMaybe<Scalars['ID']['input']>;
};

/** Eine Zeile in einem Ranking */
export type Rank = {
  __typename?: 'Rank';
  /** Eigenschaften der Zeile, abhängig von der Art der Tabelle */
  properties: Scalars['JSON']['output'];
  /** Position in der Tabelle */
  rank: Scalars['Int']['output'];
  rankStatus?: Maybe<Scalars['String']['output']>;
  teamCode: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
};

/** Eine Tabelle im Rahmen eines Tournierkalenders */
export type Ranking = {
  __typename?: 'Ranking';
  positions: Array<Maybe<Rank>>;
  rankingId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

/** Aggregierte Anzahl einer Reaktion */
export type ReactionCount = {
  __typename?: 'ReactionCount';
  count: Scalars['Int']['output'];
  reaction?: Maybe<ChatMessageReactionEnum>;
};

export enum ReservationInterval {
  HalfHourly = 'HALF_HOURLY',
  Hourly = 'HOURLY',
  QuarterHourly = 'QUARTER_HOURLY'
}

export enum ReservationTimeUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES'
}

export type Resource = {
  __typename?: 'Resource';
  altText?: Maybe<Scalars['String']['output']>;
  contentLength?: Maybe<Scalars['Int']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  resourceCategory?: Maybe<ResourceCategory>;
  resourceCategoryId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ResourceStatus>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_category?: Maybe<Scalars['String']['output']>;
  user_comment?: Maybe<Scalars['String']['output']>;
  user_contact?: Maybe<Scalars['String']['output']>;
  user_title?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ResourceCategory = ICategory & {
  __typename?: 'ResourceCategory';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModificationDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

export type ResourceCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

export type ResourceManagementApplicationComponent = ApplicationComponent & {
  __typename?: 'ResourceManagementApplicationComponent';
  /** Typ der Komponente */
  applicationType?: Maybe<ApplicationComponentType>;
  /** Hilfeseite */
  helpPage?: Maybe<IwsFile>;
  id: Scalars['ID']['output'];
  /** Anzeige-Url. Zusätzlich muss der JWT-Token als Cookie gesetzt sein oder dieser per Url-Parameter übergenen werden */
  url: Scalars['String']['output'];
};

export type ResourcePagingResponse = {
  __typename?: 'ResourcePagingResponse';
  content?: Maybe<Array<Maybe<Resource>>>;
  totalcount: Scalars['Int']['output'];
};

export type ResourceSearchCriteria = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  mimeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<ResourceStatus>>>;
  text?: InputMaybe<Scalars['String']['input']>;
  userUploads?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ResourceStatus {
  Active = 'active',
  Converting = 'converting',
  Pending = 'pending',
  Uploading = 'uploading'
}

export type ResourceUploadCompletedInput = {
  /** Kommentar */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Kontakt */
  contact?: InputMaybe<Scalars['String']['input']>;
  /** Geos */
  geoLat?: InputMaybe<Scalars['Float']['input']>;
  geoLng?: InputMaybe<Scalars['Float']['input']>;
  /** Show OptIn */
  optIn1?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show OptIn */
  optIn2?: InputMaybe<Scalars['Boolean']['input']>;
  recipient?: InputMaybe<ResourceUploadComponentRecipientInput>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceUploadComponent = {
  __typename?: 'ResourceUploadComponent';
  /** Hintergrundbild */
  backgroundImage?: Maybe<Resource>;
  backgroundImageId?: Maybe<Scalars['ID']['output']>;
  /** Hintergrundbild */
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  /** Textfarbe Button */
  buttonTextColor?: Maybe<Scalars['String']['output']>;
  /** Label für die Kamera */
  chooseCameraLabel?: Maybe<Scalars['String']['output']>;
  /** Label für die Gallerieauswahl */
  chooseLibraryLabel?: Maybe<Scalars['String']['output']>;
  /** Label für Kommentar */
  commentLabel?: Maybe<Scalars['String']['output']>;
  componentRefs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Bestätigungstext */
  confirmtext?: Maybe<Scalars['String']['output']>;
  /** Label für Kontakt */
  contactLabel?: Maybe<Scalars['String']['output']>;
  /** Geo-Tracking */
  geoTracking?: Maybe<Scalars['Boolean']['output']>;
  /** Hifeseite */
  htmlHelpId?: Maybe<Scalars['ID']['output']>;
  /** Hilfeseite Url  */
  htmlHelpUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Bildkompression */
  imageCompression?: Maybe<Scalars['Int']['output']>;
  /** Maximale Bild-Skalierung: Höhe */
  imageScaleHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximale Bild-Skalierung: Breite */
  imageScaleWidth?: Maybe<Scalars['Int']['output']>;
  /** E-Mail-Empfänger */
  mailReceiver?: Maybe<Scalars['String']['output']>;
  /** Maximale Anzahl Bilder */
  maxImages?: Maybe<Scalars['Int']['output']>;
  /** Show OptIn */
  optIn1?: Maybe<Scalars['Boolean']['output']>;
  /** Optinale Opt-In-Seite */
  optIn1Page?: Maybe<IwsFile>;
  /** Opt-In Text */
  optIn1Text?: Maybe<Scalars['String']['output']>;
  /** Show OptIn */
  optIn2?: Maybe<Scalars['Boolean']['output']>;
  /** Optinale Opt-In-Seite */
  optIn2Page?: Maybe<IwsFile>;
  /** Opt-In Text */
  optIn2Text?: Maybe<Scalars['String']['output']>;
  /** Profildaten automatisch übernehmen, wenn vorhanden */
  profileFill?: Maybe<Scalars['Boolean']['output']>;
  /** Empfänger Auswahl-Text */
  recipientChooserText?: Maybe<Scalars['String']['output']>;
  /** Überschreibung für den Standardempfänger durch unterschiedliche Kategorien. */
  recipients?: Maybe<Array<Maybe<ResourceUploadComponentRecipient>>>;
  /** Gruppen, für welche der Freigabeprozess übersprungen wird */
  skipApprovalForGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Zieln-Alben */
  targetAlbumIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Label für Titel */
  titleLabel?: Maybe<Scalars['String']['output']>;
  /** Label für Upload-Button */
  uploadLabel?: Maybe<Scalars['String']['output']>;
  /** Allows Videos to be uploaded */
  videoSupport?: Maybe<Scalars['Boolean']['output']>;
};

export type ResourceUploadComponentInput = {
  backgroundImageId?: InputMaybe<Scalars['ID']['input']>;
  /** Textfarbe Button */
  buttonTextColor?: InputMaybe<Scalars['String']['input']>;
  /** Label für die Kamera */
  chooseCameraLabel?: InputMaybe<Scalars['String']['input']>;
  /** Label für die Gallerieauswahl */
  chooseLibraryLabel?: InputMaybe<Scalars['String']['input']>;
  /** Label für Kommentar */
  commentLabel?: InputMaybe<Scalars['String']['input']>;
  componentRefs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Bestätigungstext */
  confirmtext?: InputMaybe<Scalars['String']['input']>;
  /** Label für Kontakt */
  contactLabel?: InputMaybe<Scalars['String']['input']>;
  /** Geo-Tracking */
  geoTracking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hifeseite */
  htmlHelpId?: InputMaybe<Scalars['ID']['input']>;
  /** Bildkompression */
  imageCompression?: InputMaybe<Scalars['Int']['input']>;
  /** Maximale Bild-Skalierung: Höhe */
  imageScaleHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Maximale Bild-Skalierung: Breite */
  imageScaleWidth?: InputMaybe<Scalars['Int']['input']>;
  /** E-Mail-Empfänger */
  mailReceiver?: InputMaybe<Scalars['String']['input']>;
  /** Maximale Anzahl Bilder */
  maxImages?: InputMaybe<Scalars['Int']['input']>;
  /** Show OptIn */
  optIn1?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optinale Opt-In-Seite */
  optIn1PageId?: InputMaybe<Scalars['ID']['input']>;
  /** Opt-In Text */
  optIn1Text?: InputMaybe<Scalars['String']['input']>;
  /** Opt-In Text */
  optIn2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optinale Opt-In-Seite */
  optIn2PageId?: InputMaybe<Scalars['ID']['input']>;
  /** Opt-In Text */
  optIn2Text?: InputMaybe<Scalars['String']['input']>;
  /** Profildaten automatisch übernehmen, wenn vorhanden */
  profileFill?: InputMaybe<Scalars['Boolean']['input']>;
  /** Empfänger Auswahl-Text */
  recipientChooserText?: InputMaybe<Scalars['String']['input']>;
  /** Überschreibung für den Standardempfänger durch unterschiedliche Kategorien. */
  recipients?: InputMaybe<Array<InputMaybe<ResourceUploadComponentRecipientInput>>>;
  /** Gruppen, für welche der Freigabeprozess übersprungen wird */
  skipApprovalForGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Zieln-Alben */
  targetAlbumIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Label für Titel */
  titleLabel?: InputMaybe<Scalars['String']['input']>;
  /** Label für Upload-Button */
  uploadLabel?: InputMaybe<Scalars['String']['input']>;
  /** Allows Videos to be uploaded */
  videoSupport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceUploadComponentRecipient = {
  __typename?: 'ResourceUploadComponentRecipient';
  /** E-Mail-Empfänger. Kann per ; sepertiert werden. */
  email?: Maybe<Scalars['String']['output']>;
  /** Name der Kategorie */
  label?: Maybe<Scalars['String']['output']>;
};

export type ResourceUploadComponentRecipientInput = {
  /** E-Mail-Empfänger. Kann per ";" getrennt werden. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name der Kategorie */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceUploadSigningRequest = {
  contentLength?: InputMaybe<Scalars['Int']['input']>;
  filename: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  userCategory?: InputMaybe<Scalars['String']['input']>;
  userComment?: InputMaybe<Scalars['String']['input']>;
  userContact?: InputMaybe<Scalars['String']['input']>;
  userTitle?: InputMaybe<Scalars['String']['input']>;
  userUpload?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceUploadSigningResponse = {
  __typename?: 'ResourceUploadSigningResponse';
  error?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  resource?: Maybe<Resource>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

/** Die Eingaben des SEPA Formulars werden gesendet */
export type SepaMandateInput = {
  /** die eigentliche Bankverbindung */
  IBAN: Scalars['String']['input'];
  /** An diese Mail werden die Rechnungen bzw. Lastschriftankündigungen gesehdet */
  debitorEMail: Scalars['String']['input'];
  debitorHausnummer: Scalars['String']['input'];
  /** (Firmen) Name des Kontoinhabers */
  debitorName: Scalars['String']['input'];
  debitorOrt: Scalars['String']['input'];
  debitorPLZ: Scalars['String']['input'];
  /** Anschrift des Kontoinhabers */
  debitorStrasse: Scalars['String']['input'];
  /** Name des Kontobevollmächtigten */
  erteiltVon: Scalars['String']['input'];
  /** Bezugs-Vertagsnummer die beim 'startSEPAMandateFlow' geliefert wurde */
  vertragsnummer: Scalars['Int']['input'];
};

/** Wie ist der Status des SEPA Mandats des Projekts */
export enum SepaMandateStatus {
  /** Es wurde bereits ein Mandat erteilt */
  Issued = 'ISSUED',
  /** Es wurde noch kein Mandat erteilt */
  NotIssued = 'NOT_ISSUED',
  /** Es ist noch kein Vertrag zugeordnet. Dies ist für die Zuordnung des Mandats notwendig */
  NoContractAssigned = 'NO_CONTRACT_ASSIGNED',
  /**
   * Es wurde explizit auf ein Mandat verzichtet, da per Jahresrechnung bezahlt werden soll.
   * Oder die App wurde bereits gekündigt. Daher läuft der Vertrag im aktuellen Zustand
   * zu Ende.
   */
  Rejected = 'REJECTED'
}

export type SseMessage = {
  __typename?: 'SSEMessage';
  channelId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SseMessageType>;
};

export enum SseMessageType {
  ChannelInfoUpdated = 'CHANNEL_INFO_UPDATED',
  InvitationsUpdated = 'INVITATIONS_UPDATED',
  MessageDeleted = 'MESSAGE_DELETED',
  MessageReceived = 'MESSAGE_RECEIVED',
  MessageUpdated = 'MESSAGE_UPDATED',
  NewMessagesAvailable = 'NEW_MESSAGES_AVAILABLE',
  Ping = 'PING',
  PinnedMessagesUpdated = 'PINNED_MESSAGES_UPDATED',
  ProfileOffline = 'PROFILE_OFFLINE',
  ProfileOnline = 'PROFILE_ONLINE',
  ProfileWriting = 'PROFILE_WRITING'
}

export type ScheduleDayAvailability = {
  __typename?: 'ScheduleDayAvailability';
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type ScheduleDayAvailabilityInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleWeekAvailability = {
  __typename?: 'ScheduleWeekAvailability';
  fri?: Maybe<Array<Maybe<ScheduleDayAvailability>>>;
  mon?: Maybe<Array<Maybe<ScheduleDayAvailability>>>;
  sat?: Maybe<Array<Maybe<ScheduleDayAvailability>>>;
  sun?: Maybe<Array<Maybe<ScheduleDayAvailability>>>;
  thu?: Maybe<Array<Maybe<ScheduleDayAvailability>>>;
  tue?: Maybe<Array<Maybe<ScheduleDayAvailability>>>;
  wed?: Maybe<Array<Maybe<ScheduleDayAvailability>>>;
};

export type ScheduleWeekAvailabilityInput = {
  fri?: InputMaybe<Array<InputMaybe<ScheduleDayAvailabilityInput>>>;
  mon?: InputMaybe<Array<InputMaybe<ScheduleDayAvailabilityInput>>>;
  sat?: InputMaybe<Array<InputMaybe<ScheduleDayAvailabilityInput>>>;
  sun?: InputMaybe<Array<InputMaybe<ScheduleDayAvailabilityInput>>>;
  thu?: InputMaybe<Array<InputMaybe<ScheduleDayAvailabilityInput>>>;
  tue?: InputMaybe<Array<InputMaybe<ScheduleDayAvailabilityInput>>>;
  wed?: InputMaybe<Array<InputMaybe<ScheduleDayAvailabilityInput>>>;
};

/** Das Ergebnis einer erfolgreichen Reservierung ist die Zuweisung eines virtuellen/realen Sitz/Platzes */
export type Seat = {
  __typename?: 'Seat';
  /** Anschrift des Benutzers, falls kein Profil vorhanden */
  address?: Maybe<Scalars['String']['output']>;
  /** Hinweise des Benutzers zu seiner Anmeldung */
  comment?: Maybe<Scalars['String']['output']>;
  /** email Adresse des Benutzers, falls kein Profil vorhanden */
  email?: Maybe<Scalars['String']['output']>;
  /** Vorname des Teilnehmer */
  firstname?: Maybe<Scalars['String']['output']>;
  /** eindeutige Bezeichnung des Sitzes */
  id: Scalars['ID']['output'];
  /** Nachname aus dem Profil */
  name?: Maybe<Scalars['String']['output']>;
  /** Telfonnummer für eventuelle Rückfragen, falls kein Profil vorhanden */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Bezug zum Benutzerprofil falls vorhanden */
  userProfileId?: Maybe<Scalars['String']['output']>;
};

export type SharedResource = {
  __typename?: 'SharedResource';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type SocialNetworkCollection = {
  __typename?: 'SocialNetworkCollection';
  collectionType: SocialNetworkCollectionType;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum SocialNetworkCollectionType {
  Album = 'ALBUM',
  Feed = 'FEED'
}

export type SocialNetworkConfiguration = {
  __typename?: 'SocialNetworkConfiguration';
  /** Collections */
  collections?: Maybe<Array<Maybe<SocialNetworkCollection>>>;
  id: Scalars['ID']['output'];
  /** Login-URL */
  loginUrl?: Maybe<Scalars['String']['output']>;
  /** Names des Social networks */
  name?: Maybe<Scalars['String']['output']>;
  /** zugewiesene scopes */
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Um welchen Soziale Netzwerk geht es? */
  socialNetworkType?: Maybe<SocialNetworkConfigurationType>;
  /** Verbindungsstatus */
  status?: Maybe<SocialNetworkConfigurationStatus>;
};

export type SocialNetworkConfigurationInput = {
  /** Name der Verbindung */
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialNetworkConfigurationStatus {
  Linked = 'LINKED',
  Unlinked = 'UNLINKED'
}

export enum SocialNetworkConfigurationType {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM'
}

export type Sort = {
  direction: Direction;
  property?: InputMaybe<Scalars['String']['input']>;
};

export type Stamp = {
  __typename?: 'Stamp';
  _id?: Maybe<Scalars['String']['output']>;
  stampDate?: Maybe<Scalars['Date']['output']>;
  stamped: Scalars['Boolean']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type StampInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

/**
 * ein generischer Statusanzeiger, der mit einem externen System verbunden wird. Beispielsweise um die Belegung eines
 * Camping-Platzes, einer Veranstaltung, eines Kurses, eines Kontingents an Restposten etc. anzuzeigen.
 */
export type StatusIndicator = {
  __typename?: 'StatusIndicator';
  /** Gerade eingeschaltet bzw. in Benutzung? */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** App Kontext (übergreifend bez. vorhandender Sprachversionen) */
  appGroupId: Scalars['String']['output'];
  /** verfügbare Einheiten */
  available?: Maybe<Scalars['Long']['output']>;
  /** GPS Breitengrad */
  gpsLat?: Maybe<Scalars['Float']['output']>;
  /** GPS Längengrad */
  gpsLng?: Maybe<Scalars['Float']['output']>;
  /** Primärschlüssel */
  id: Scalars['ID']['output'];
  /** wann wurde der Status das letzte Mal aktualisiert */
  lastUpdated: Scalars['Date']['output'];
  /** Statustext */
  statusMessage?: Maybe<Scalars['String']['output']>;
  /** weitere Bezeichnung aus Sicht des externen Systems */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Bezeichnung aus Sicht des externen Systems */
  title?: Maybe<Scalars['String']['output']>;
  /** belegte/verbrauchte Einheiten */
  used?: Maybe<Scalars['Long']['output']>;
};

export type StatusIndicatorInput = {
  /** Gerade eingeschaltet bzw. in Benutzung? */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** verfügbare Einheiten */
  available?: InputMaybe<Scalars['Long']['input']>;
  /** Primärschlüssel */
  id: Scalars['ID']['input'];
  /** Statustext */
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  /** belegte/verbrauchte Einheiten */
  used?: InputMaybe<Scalars['Long']['input']>;
};

/** Der Strukturknoten innerhalb einer App Version */
export type StructureNode = {
  __typename?: 'StructureNode';
  /** optionale Liste der untergeordneten Knoten */
  children?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Optionale Referenz zu einem Modulcontainer */
  container?: Maybe<ModuleContainer>;
  id: Scalars['ID']['output'];
  /** Bezeichnung des Nodes in der Sprache der zugehörigen Projektversion */
  label?: Maybe<Scalars['String']['output']>;
};

export type SystemConfig = {
  __typename?: 'SystemConfig';
  applicationServerUrl: Scalars['String']['output'];
  cdnURL: Scalars['String']['output'];
  portalIcon?: Maybe<Scalars['String']['output']>;
  profile: Scalars['String']['output'];
  qrCodeUrl: Scalars['String']['output'];
};

export type Tax = {
  __typename?: 'Tax';
  /** Betrag in Euro-Cent bzw. der kleinsten Einheit der Währung */
  rate: Scalars['Int']['output'];
};

export type TaxInput = {
  /** Betrag in Euro-Cent bzw. der kleinsten Einheit der Währung */
  rate: Scalars['Int']['input'];
};

/** Eine Mannschaft. */
export type Team = {
  __typename?: 'Team';
  /** Hat dieses Team ggfs. eine zugehörige App? */
  appId?: Maybe<Scalars['String']['output']>;
  /** Farbe des Auswärts Trikots */
  awayShirtColor?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  /** Farbe des Heim Trikots */
  homeShirtColor?: Maybe<Scalars['String']['output']>;
  /** Logo/Wappen des Vereins */
  logoUrl?: Maybe<Scalars['Url']['output']>;
  /** Mitglieder des Teams */
  members?: Maybe<Array<Maybe<Person>>>;
  name: Scalars['String']['output'];
  /** an welchen Tournieren nimmt das Team aktuell teil */
  participations?: Maybe<Array<Maybe<Participation>>>;
  shortName: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
  /** Id des Stadions / der Spielstätte */
  venueId?: Maybe<Scalars['ID']['output']>;
  /** Name des Stadions / der Spielstätte */
  venueName?: Maybe<Scalars['String']['output']>;
};

/** Ein Team innerhalb des Clubs */
export type TeamAbbrDto = {
  __typename?: 'TeamAbbrDTO';
  clubNr: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tableRank?: Maybe<Scalars['Int']['output']>;
  teamId: Scalars['String']['output'];
};

export type TextAttachment = {
  body: Scalars['String']['input'];
  encoding?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
};

export type TextImageComponent = {
  __typename?: 'TextImageComponent';
  /** Id der Audio Ressource aus der Mediathek */
  audio?: Maybe<Resource>;
  /** Id der Audio Ressource aus der Mediathek */
  audioId?: Maybe<Scalars['String']['output']>;
  /** optionale URL zu einer Audio Datei */
  audioUrl?: Maybe<Scalars['String']['output']>;
  /** Verewndetes Workspace File */
  content?: Maybe<IwsFile>;
  /** Optionale Id der Datenquelle welche der Seite zu Grunde liegt */
  contentId?: Maybe<Scalars['String']['output']>;
  /** URL zur HTML Seite, die dargestellt werden soll */
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Social share */
  facebookEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** eindeutige Id der Komponente */
  id: Scalars['ID']['output'];
  /** Ressource aus der Mediathek */
  image?: Maybe<Resource>;
  /** Id der Image Ressource aus der Mediathek */
  imageId?: Maybe<Scalars['String']['output']>;
  /** optionlale URL zu einem header Bild */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** wann wurde die Komponente erstellt bzw. zuletzt geändert */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** wer hat die letzte Änderung durchgeführt */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** ob die Seite vom User per Zoom zu vergrössern ist */
  zoomEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Eingabe Daten zur Erzeugung oder Update einer TextImage Komponente. */
export type TextImageComponentInput = {
  audioId?: InputMaybe<Scalars['ID']['input']>;
  contentId?: InputMaybe<Scalars['WSFileId']['input']>;
  facebookEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  zoomEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Ein Widget, welches ein oder mehrere Abschnitte enthält, die optional Ein-/Ausgeklappt werden können. */
export type TextWidget = {
  __typename?: 'TextWidget';
  /** Header Text */
  footer?: Maybe<Scalars['String']['output']>;
  /** Footer Text */
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Widget-Schlüssel */
  key: Scalars['String']['output'];
  /** Aktuelle Sprache */
  language: Scalars['String']['output'];
  /** verfügbare Sprachen des Widgets */
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Abschnitte/Elemente des Widgets */
  sections: Array<Maybe<TextWidgetSection>>;
  /** Einstellungen */
  settings: WidgetSettings;
  /** Titel */
  title: Scalars['String']['output'];
};

export type TextWidgetInput = {
  /** Footer Text */
  header?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<TextWidgetSectionInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Element eines TextWidget */
export type TextWidgetSection = {
  __typename?: 'TextWidgetSection';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TextWidgetSectionInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Schwellenwert Einstellung eines Users zu einer Serie für die er/sie benachrichtigt werden möchte */
export type Threshold = {
  __typename?: 'Threshold';
  /** optionale Obergrenze */
  lower?: Maybe<Scalars['Float']['output']>;
  profileId: Scalars['ID']['output'];
  timeSeriesId: Scalars['ID']['output'];
  /** optionale Untergrenze */
  upper?: Maybe<Scalars['Float']['output']>;
};

export type ThresholdInput = {
  lower?: InputMaybe<Scalars['Float']['input']>;
  timeSeriesId: Scalars['ID']['input'];
  upper?: InputMaybe<Scalars['Float']['input']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  appId: Scalars['AppID']['output'];
  id: Scalars['ID']['output'];
  ownerId: Scalars['ID']['output'];
  product?: Maybe<ProductDefinition>;
  type?: Maybe<ProductType>;
  usageCount?: Maybe<Scalars['Int']['output']>;
  /** Mehrfachtickets */
  usageLimit?: Maybe<Scalars['Int']['output']>;
  /** ob das Ticket noch gültig ist */
  valid?: Maybe<Scalars['Boolean']['output']>;
  /** Zeitbasierte Karte  */
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

/** Verwendete Zeitspannen bei der Anzeige von Messerten */
export enum TimePeriod {
  All = 'ALL',
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Twoyears = 'TWOYEARS',
  Week = 'WEEK',
  Year = 'YEAR'
}

/**
 * Eine Gruppe von gleichartigen Werten über einen zeitlichen Verlauf.
 * Beispiele sind:
 * - der Kursveraluf einer Aktie
 * - der Verlauf eines Sensors (Temperatur)
 * - Eine Preisentwicklung (Gas, Strom)
 */
export type TimeSeries = {
  __typename?: 'TimeSeries';
  /** App Kontext */
  appId: Scalars['AppID']['output'];
  /** Differenz aus dem letzten und vorletzten Datenpunkt */
  delta?: Maybe<Scalars['Float']['output']>;
  /** Erwartete Frequenz mit der neue Werte ins System kommen */
  granularity?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Zeitpunkt an dem zuletzt ein Wert zu dieser Serie hinzugefügt wurde */
  lastModified?: Maybe<Scalars['Date']['output']>;
  /** der aktuellste Datenpunkt */
  latestEntry?: Maybe<TimeSeriesData>;
  /** anwendungsspezifische Zusatzdaten zu der Serie */
  metaData?: Maybe<Scalars['JSON']['output']>;
  /** Anzeigename */
  name: Scalars['String']['output'];
  /** Sichtbarkeit für bestimmte Rollen des aktuellen Users begrenzen. */
  roleVisibility?: Maybe<Array<Maybe<CustomEnumValue>>>;
  /** Einheit für alle Werte dieser Serie */
  unit: Scalars['String']['output'];
  /**
   * Schalter um die temporäre Sichtbarkeit zu ändern, z.B wenn eine Serie bereits angelegt wird aber erst später
   * für die Kunden sichtbar sein soll.
   */
  visible: Scalars['Boolean']['output'];
};

/** Wert innerhalb einer Serie, z.B Messwert eines Sensors, Kurs einer Aktie, Strompreis etc. */
export type TimeSeriesData = {
  __typename?: 'TimeSeriesData';
  /** eindeutige Id des Messwerts/Datenpunktes */
  id: Scalars['ID']['output'];
  /** Zusatzinformationen zu dem Wert, z.B ein Defekt wurde erkannt oder von welchem sensor stammt der Wert etc. */
  metaData?: Maybe<Scalars['JSON']['output']>;
  /** Zu welcher Serie gehört der Wert */
  timeSeriesId: Scalars['ID']['output'];
  /** Wann wurde der Wert erhoben/gemessen */
  timestamp?: Maybe<Scalars['Date']['output']>;
  /** Der eigentliche Wert in der Einheit der Serie */
  value?: Maybe<Scalars['Float']['output']>;
};

export type TimeSeriesDataInput = {
  /** optionaler Update auf bestehenden Datenpunkt */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** meta Informationen zu dem Wert z.B manuelle Messung oder sensorbasiert, von wem durchgeführt etc. */
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  /** Wann wurde der Wert erhoben/gemessen */
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Der eigentliche Wert in der Einheit der Serie */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Input Daten zum Erzeugen einer neuen TimeSeries. */
export type TimeSeriesInput = {
  /** Erwartete Frequenz mit der neue Werte ins System kommen */
  granularity?: InputMaybe<Scalars['String']['input']>;
  /** Zusatzinformationen zu dem Wert, z.B ein Defekt wurde erkannt oder von welchem sensor stammt der Wert etc. */
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  /** Anzeigename */
  name: Scalars['String']['input'];
  /** Einheit für alle Werte dieser Serie */
  unit: Scalars['String']['input'];
};

export type TrackedItem = {
  __typename?: 'TrackedItem';
  /** Internal description */
  description?: Maybe<Scalars['String']['output']>;
  /** Gerät, welches zuletzt mit dem Item verbunden */
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Bezeichnung */
  label?: Maybe<Scalars['String']['output']>;
  lastPositionUpdate?: Maybe<Scalars['Date']['output']>;
  /** Nummernschild oder Identifier */
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** Symbol */
  marker?: Maybe<Scalars['String']['output']>;
  /** Pin-Code */
  pinCode?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type TrackedItemInput = {
  /** Internal description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Gerät, welches zuletzt mit dem Item verbunden */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** Bezeichnung */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Nummernschild oder Identifier */
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  /** Symbol */
  marker?: InputMaybe<Scalars['String']['input']>;
  /** Pin-Code */
  pinCode?: InputMaybe<Scalars['String']['input']>;
};

export type UsageStatisticItem = {
  __typename?: 'UsageStatisticItem';
  bytesUsed: Scalars['Long']['output'];
  count: Scalars['Int']['output'];
};

export type UsageStatistics = {
  __typename?: 'UsageStatistics';
  /** App Kontext */
  appId: Scalars['AppID']['output'];
  /** Audio Dateien (mimetype audio/*) */
  audios: UsageStatisticItem;
  /** Chats */
  chats: UsageStatisticItem;
  /** Anwendungsdateien Word, Excel, (mimetype application/*) */
  documents: UsageStatisticItem;
  /** Filestores */
  filestores: UsageStatisticItem;
  /** Alle Bilder (mimetype image/*)  */
  images: UsageStatisticItem;
  /** Alle HTML Seiten (mimetype text/*) */
  pages: UsageStatisticItem;
  /** freier Speicherplatz in Prozent */
  storageFreePercentage: Scalars['Float']['output'];
  /** verfügbares Gesamt Speicherkontingent in Bytes */
  storageQuota: Scalars['Long']['output'];
  /** belegter Speicherplatz in Prozent */
  storageUsedPercentage: Scalars['Float']['output'];
  /** aktuell verwendeter Speicher in Bytes */
  storageUsedTotal: Scalars['Long']['output'];
  /** Videos (mimetype video/*) */
  videos: UsageStatisticItem;
};

/** CMS User */
export type User = {
  __typename?: 'User';
  appIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** wurde eine Authenticator-App als 2FA aktiviert ? */
  authenticatorEnabled: Scalars['Boolean']['output'];
  cnumber?: Maybe<Scalars['String']['output']>;
  currentAppDivisions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currentAppId: Scalars['AppID']['output'];
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  emailPending?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  invalidLoginAttemps?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastAppLogin?: Maybe<Scalars['Date']['output']>;
  lastLogin?: Maybe<Scalars['Date']['output']>;
  /** Date of last active password change */
  lastPasswordChange?: Maybe<Scalars['Date']['output']>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  technicalAppUser?: Maybe<Scalars['Boolean']['output']>;
  username: Scalars['String']['output'];
};

export type UserBookmarkRef = {
  __typename?: 'UserBookmarkRef';
  ref: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type UserBookmarkRefInput = {
  ref?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UserBookmarks = {
  __typename?: 'UserBookmarks';
  refs?: Maybe<Array<Maybe<UserBookmarkRef>>>;
};

export type UserBookmarksInput = {
  refs: Array<InputMaybe<UserBookmarkRefInput>>;
};

export type UserInput = {
  /** AppIds, auf welcher der Benutzer Zugriff erhält */
  appIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentAppDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** E-Mail des Benutzers */
  email: Scalars['String']['input'];
  /** Name des Benutzers */
  firstname: Scalars['String']['input'];
  /** Benutzer aktivieren oder deaktivieren */
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Berechtigungen des Benutzers */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserPagingResponse = {
  __typename?: 'UserPagingResponse';
  content?: Maybe<Array<Maybe<User>>>;
  totalcount: Scalars['Int']['output'];
};

/** Das Benutzerprofil eines App Nutzers */
export type UserProfile = {
  __typename?: 'UserProfile';
  accountActive?: Maybe<Scalars['Boolean']['output']>;
  activationCode?: Maybe<Scalars['String']['output']>;
  /** Darf die E-Mail in der App angezeigt werden? */
  agreedDisplayMail?: Maybe<Scalars['Boolean']['output']>;
  /** Darf der Name in der App angezeigt werden? */
  agreedDisplayName?: Maybe<Scalars['Boolean']['output']>;
  /** Darf die Telefonnummer in der App angezeigt werden? */
  agreedDisplayPhone?: Maybe<Scalars['Boolean']['output']>;
  agreedToAds?: Maybe<Scalars['Boolean']['output']>;
  /** App-Gruppe */
  appGroup?: Maybe<Scalars['String']['output']>;
  /** AppId */
  appId?: Maybe<Scalars['String']['output']>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankBIC?: Maybe<Scalars['String']['output']>;
  bankIBAN?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankSEPADate?: Maybe<Scalars['Date']['output']>;
  bankSEPARef?: Maybe<Scalars['String']['output']>;
  /** Geburtsdatum */
  birthday?: Maybe<Scalars['Date']['output']>;
  chatAccount?: Maybe<Scalars['Boolean']['output']>;
  chatRulesAccepted?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubNumber?: Maybe<Scalars['String']['output']>;
  coachingLicense?: Maybe<Scalars['Boolean']['output']>;
  community?: Maybe<Scalars['String']['output']>;
  companyDepartment?: Maybe<Scalars['String']['output']>;
  companyFunction?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CustomEnumValue>;
  /** Erstellungsdatum */
  created?: Maybe<Scalars['Date']['output']>;
  /** Projekt-spezifische Felder */
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  dataPrivacyStatementAccepted?: Maybe<Scalars['String']['output']>;
  dataTermsOfUseAccepted?: Maybe<Scalars['String']['output']>;
  datePrivacyStatementAccepted?: Maybe<Scalars['Date']['output']>;
  dateTermsOfUseAccepted?: Maybe<Scalars['Date']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  /** Abteilungen */
  departments: Array<Maybe<CustomEnumValue>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** email Adresse */
  email: Scalars['String']['output'];
  entryDate?: Maybe<Scalars['Date']['output']>;
  exitDate?: Maybe<Scalars['Date']['output']>;
  /** Id des externen Benutzerverwaltungssystems sofern vorhanden */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Familiennummer. Muss bei allen Mitgliedern der Familie gesetzt und gleich sein */
  familyProfileNumber?: Maybe<Scalars['String']['output']>;
  feeAmount?: Maybe<Scalars['String']['output']>;
  feeKind?: Maybe<Scalars['String']['output']>;
  /** Vorname */
  firstname?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Group>>>;
  /** eindeutige Id */
  id?: Maybe<Scalars['String']['output']>;
  identityNumber?: Maybe<Scalars['String']['output']>;
  /** Avatar bzw. Profilbild */
  imageId?: Maybe<Scalars['String']['output']>;
  imageThumbId?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Scalars['String']['output']>;
  /** letzte Änderung */
  lastModified?: Maybe<Scalars['Date']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  /** Lizenznummer */
  licenseNumber?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  mailConfirmationPending?: Maybe<Scalars['Boolean']['output']>;
  mainProfile?: Maybe<Scalars['Boolean']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  /** membershipNumber */
  membershipNumber?: Maybe<Scalars['String']['output']>;
  /** Nachname */
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  offers?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  personnelNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneMobile?: Maybe<Scalars['String']['output']>;
  /** Requested Telefonnummer - verifizierung steht aus */
  phoneMobileRequest?: Maybe<Scalars['String']['output']>;
  /** Status der Verifikation der Mobilnummer */
  phoneMobileVerificationStatus?: Maybe<PhoneNumberVerificationStatus>;
  playerHeight?: Maybe<Scalars['Int']['output']>;
  playerNumber?: Maybe<Scalars['String']['output']>;
  playerPosition?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  publicProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Vorname und Nachname */
  realname?: Maybe<Scalars['String']['output']>;
  /** Beziehungen des Nutzers */
  relations?: Maybe<Array<Maybe<UserProfileRelation>>>;
  remarks?: Maybe<Scalars['String']['output']>;
  /** Rollen, die der Benutzer zuletzt angefordert hat */
  requestedRoles?: Maybe<Array<Maybe<CustomEnumValue>>>;
  /** Rollen, die der Benutzer gerade hat */
  roles: Array<Maybe<CustomEnumValue>>;
  /** Die Anrede */
  salutation?: Maybe<CustomEnumValue>;
  skills?: Maybe<Scalars['String']['output']>;
  specialization?: Maybe<Scalars['String']['output']>;
  sports?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  statutesAccepted?: Maybe<Scalars['Boolean']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  /** Titel */
  title?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
  verificationPending?: Maybe<Scalars['Boolean']['output']>;
};

export type UserProfileAssignDeviceCodeInput = {
  code: Scalars['String']['input'];
  privacyStatementAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  termsOfUseAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfileAssignDeviceInput = {
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyStatementAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  termsOfUseAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfileBasicData = {
  __typename?: 'UserProfileBasicData';
  /** Geburtstag */
  birthday?: Maybe<Scalars['Date']['output']>;
  /** email Adresse */
  email?: Maybe<Scalars['String']['output']>;
  /** Vorname */
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['ID']['output']>;
  imageThumbId?: Maybe<Scalars['ID']['output']>;
  /** membershipNumber */
  membershipNumber?: Maybe<Scalars['String']['output']>;
  /** Nachname */
  name?: Maybe<Scalars['String']['output']>;
  /** Nickname */
  nickname?: Maybe<Scalars['String']['output']>;
  /** mobile phone */
  phoneMobile?: Maybe<Scalars['String']['output']>;
  /** Beziehungen des Nutzers */
  relations?: Maybe<Array<Maybe<UserProfileRelation>>>;
};

/**
 * Definiert die App spezifischen Einstellungen bezüglich des Verhaltens und der
 * verwendeten Felder bei den Benutzer Profilen.
 */
export type UserProfileConfiguration = {
  __typename?: 'UserProfileConfiguration';
  /** Direktaktivierung erlauben */
  allowDirectActivation?: Maybe<Scalars['Boolean']['output']>;
  /** Darf Orte anlegen ohne CMS-Berechtigung */
  allowNonAdminLocationCreation?: Maybe<Scalars['Boolean']['output']>;
  /** Das Profil automatisch am Austrittsdatum löschen */
  autodeleteOnExitDate?: Maybe<Scalars['Boolean']['output']>;
  /** Funktion: Geburtstagsgruß aktiviert */
  birthdayMessageActive?: Maybe<Scalars['Boolean']['output']>;
  /** Funktion: Geburtstagsgruß Ziel-Komponente */
  birthdayMessageTargetComponent?: Maybe<Scalars['String']['output']>;
  /** Funktion: Geburtstagsgruß Text */
  birthdayMessageText?: Maybe<Scalars['String']['output']>;
  /** QR-Code-Aktivierung erlauben */
  codeActivation?: Maybe<Scalars['Boolean']['output']>;
  /** Profil Feld Erweiterungen, die im Rahmen der App gemacht wurden */
  customFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Link zur Datenschuterklärung */
  dataPrivacyStatementUrl?: Maybe<Scalars['String']['output']>;
  /** Link zur Datenschuterklärung */
  dataTermsOfUseUrl?: Maybe<Scalars['String']['output']>;
  /** Standard-Rollen */
  defaultRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Benutzer dürfen Ihr Profil ändern */
  editingAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Dürfen Hauptmitglieder Ihre Familenmitglieder selbst verwalten? */
  familyMembershipEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Alle Felder, die im Kontext der App bekannt sind */
  fields?: Maybe<Array<Maybe<WorksheetColumnMetaData>>>;
  /** zu welcher App gehört die Konfiguration */
  id: Scalars['AppID']['output'];
  /** Soll der Ausweis angezeigt werden ? */
  idCard?: Maybe<Scalars['Boolean']['output']>;
  /** Hinweise */
  note?: Maybe<Scalars['String']['output']>;
  /** App Verantwortlichen bei Daten Änderungen benachrichtigen */
  notifyOnChange?: Maybe<Scalars['Boolean']['output']>;
  /** App Verantwortlichen bei Neu-Anmeldungen benachrichtigen */
  notifyOnRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Muss die Handy-Nummer vor der Freigabe des Profils validiert werden */
  phoneNumberVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Verantwortlicher für Profil Freigaben */
  profileManagerEMail?: Maybe<Scalars['String']['output']>;
  /** Benutzer können sich selbst anmdelden (default) oder die Anmeldung erfolgt per Datenübernahme vom Herausgeber */
  registrationAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Benutze Rollen */
  roleKeysToUse?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Genehmigungspflichtige Rollen */
  roleKeysToVerify?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Soll eine Rollenauswahl bei der Neuregistrierung möglich sein */
  rolesVisibleOnRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Familienmitgliedschaft wird unterstützt */
  supportFamilyMembership?: Maybe<Scalars['Boolean']['output']>;
  /** Feldnamen, die von der App nicht benutzt werden */
  unusedFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** URL des Profilmoduls */
  url?: Maybe<Scalars['String']['output']>;
  /** Wird die Gruppenverwaltung benutzt */
  useGroups?: Maybe<Scalars['Boolean']['output']>;
  /** Soll ein Externes Identitätsmanagement benutzt werden. Bitte kontaktieren Sie uns */
  useOpenIDConnect?: Maybe<Scalars['Boolean']['output']>;
  /** Soll die Datenschutzseite benutzt werden? */
  usePrivacyPage?: Maybe<Scalars['Boolean']['output']>;
  /** Soll die Nutzungsbedinungen benutzt werden? */
  useTermsOfUsePage?: Maybe<Scalars['Boolean']['output']>;
  /** Feldnamen, die von der App benutzt werden in der definierten Reihenfolge */
  usedFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** User kann sein Profil selbst löschen */
  userProfileDeletion?: Maybe<Scalars['Boolean']['output']>;
};

/** Eingabe Objekt bei Änderungen an der Profil Konfiguration einer App. */
export type UserProfileConfigurationInput = {
  /** Direktaktivierung erlauben */
  allowDirectActivation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Darf Orte anlegen ohne CMS-Berechtigung */
  allowNonAdminLocationCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Das Profil automatisch am Austrittsdatum löschen */
  autodeleteOnExitDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Funktion: Geburtstagsgruß aktiviert */
  birthdayMessageActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Funktion: Geburtstagsgruß Ziel-Komponente */
  birthdayMessageTargetComponent?: InputMaybe<Scalars['String']['input']>;
  /** Funktion: Geburtstagsgruß Text */
  birthdayMessageText?: InputMaybe<Scalars['String']['input']>;
  /** QR-Code-Aktivierung erlauben */
  codeActivation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Standard-Rollen */
  defaultRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Benutzer dürfen Ihr Profil ändern */
  editingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dürfen Hauptmitglieder Ihre Familenmitglieder selbst verwalten? */
  familyMembershipEditable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soll der Ausweis angezeigt werden ? */
  idCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hinweise */
  note?: InputMaybe<Scalars['String']['input']>;
  /** App Verantwortlichen bei Daten Änderungen benachrichtigen */
  notifyOnChange?: InputMaybe<Scalars['Boolean']['input']>;
  /** App Verantwortlichen bei Neu-Anmeldungen benachrichtigen */
  notifyOnRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Muss die Handy-Nummer vor der Freigabe des Profils validiert werden */
  phoneNumberVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Verantwortlicher für Profil Freigaben */
  profileManagerEMail?: InputMaybe<Scalars['String']['input']>;
  /** Benutzer können sich selbst anmdelden (default) oder die Anmeldung erfolgt per Datenübernahme vom Herausgeber */
  registrationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Benutze Rollen */
  roleKeysToUse?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Genehmigungspflichtige Rollen */
  roleKeysToVerify?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Soll eine Rollenauswahl bei der Neuregistrierung möglich sein */
  rolesVisibleOnRegistration: Scalars['Boolean']['input'];
  /** Familienmitgliedschaft wird unterstützt */
  supportFamilyMembership?: InputMaybe<Scalars['Boolean']['input']>;
  /** Wird die Gruppenverwaltung benutzt */
  useGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soll ein Externes Identitätsmanagement benutzt werden. Bitte kontaktieren Sie uns */
  useOpenIDConnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soll die Datenschutzseite benutzt werden? */
  usePrivacyPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soll die Nutzungsbedinungen benutzt werden? */
  useTermsOfUsePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feldnamen, die von der App benutzt werden in der definierten Reihenfolge */
  usedFieldsConfig?: InputMaybe<Array<InputMaybe<ProfileFieldInput>>>;
  /** User kann sein Profil selbst löschen */
  userProfileDeletion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfileExcelImportSettings = {
  /** Achtung: Löscht alle Benutzer vor dem Import */
  clearDatabase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Erstellt für jeden importierten App-Nutzer automatisch ein Aktivierungs-Code */
  createActivationCode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Führt nur ein Delta-Import aus. Ersetzt nur bestehende Datensätze. */
  delta?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optionale Id des Adapters, der als Import Logik verwendet werden soll,
   * wenn das Excel inhaltlich nicht unserem Appack Standard passt. z.B. Kann per 'EasyVerein' auf deren Excel Format
   * umgestellt werden.
   */
  importAdapterId?: InputMaybe<Scalars['String']['input']>;
  /** Simuliert: Simuliert den Import */
  simulate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserProfileExportFormat {
  Excel = 'EXCEL',
  Html = 'HTML'
}

/** Input Type zum Erzeugen bzw. Ändern eines Benutzerprofils. */
export type UserProfileInput = {
  /** Darf die E-Mail in der App angezeigt werden? */
  agreedDisplayMail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Darf der Name in der App angezeigt werden? */
  agreedDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Darf die Telefonnummer in der App angezeigt werden? */
  agreedDisplayPhone?: InputMaybe<Scalars['Boolean']['input']>;
  agreedToAds?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  bankBIC?: InputMaybe<Scalars['String']['input']>;
  bankIBAN?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bankSEPADate?: InputMaybe<Scalars['Date']['input']>;
  bankSEPARef?: InputMaybe<Scalars['String']['input']>;
  /** Geburtsdatum */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  chatRulesAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubNumber?: InputMaybe<Scalars['String']['input']>;
  coachingLicense?: InputMaybe<Scalars['Boolean']['input']>;
  community?: InputMaybe<Scalars['String']['input']>;
  companyDepartment?: InputMaybe<Scalars['String']['input']>;
  companyFunction?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CustomEnumValueInput>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  dataPrivacyStatementAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  dataTermsOfUseAccepted?: InputMaybe<Scalars['String']['input']>;
  datePrivacyStatementAccepted?: InputMaybe<Scalars['Date']['input']>;
  dateTermsOfUseAccepted?: InputMaybe<Scalars['Date']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  departments?: InputMaybe<Array<InputMaybe<CustomEnumValueInput>>>;
  /** email Adresse muss bei der Neuanlage zwingend mitgegeben werden */
  email?: InputMaybe<Scalars['String']['input']>;
  entryDate?: InputMaybe<Scalars['Date']['input']>;
  exitDate?: InputMaybe<Scalars['Date']['input']>;
  /** optionale externe Id */
  externalId?: InputMaybe<Scalars['String']['input']>;
  familyProfileNumber?: InputMaybe<Scalars['String']['input']>;
  feeAmount?: InputMaybe<Scalars['String']['input']>;
  feeKind?: InputMaybe<Scalars['String']['input']>;
  /** Vorname */
  firstname?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  identityNumber?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  mailConfirmationPending?: InputMaybe<Scalars['Boolean']['input']>;
  mainProfile?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  membershipNumber?: InputMaybe<Scalars['String']['input']>;
  /** Nachname */
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  personnelNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  playerHeight?: InputMaybe<Scalars['Int']['input']>;
  playerNumber?: InputMaybe<Scalars['String']['input']>;
  playerPosition?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  publicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<CustomEnumValueInput>>>;
  salutation?: InputMaybe<CustomEnumValueInput>;
  skills?: InputMaybe<Scalars['String']['input']>;
  specialization?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  statutesAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
  verificationPending?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfilePagingResponse = {
  __typename?: 'UserProfilePagingResponse';
  content?: Maybe<Array<Maybe<UserProfile>>>;
  totalcount: Scalars['Int']['output'];
};

export type UserProfileRegistrationResult = {
  __typename?: 'UserProfileRegistrationResult';
  code: UserProfileRegistrationResultStatusCode;
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Wird gesetzt, sofern für die App ein externes Primärsystem konfiguriert ist, welches die Erzeugung von
   * neuen Profilen übernimmt
   */
  redirectUrl?: Maybe<Scalars['Url']['output']>;
};

export enum UserProfileRegistrationResultStatusCode {
  /** Dieses Gerät ist bereits verbunden */
  AlreadyAssigned = 'ALREADY_ASSIGNED',
  /** Zu dieser Mail Adresse gibt es kein Profil. Es muss eine Neu Registrierung erfolgen */
  EmailUnknown = 'EMAIL_UNKNOWN',
  /** Mail Adresse ist nicht eindeutig, z.B bei einer Familienfreigabe oder im verbundenen Primärsystem */
  NotUnique = 'NOT_UNIQUE',
  /** Die Mobilnummer muss noch eingegeben werden, bevor die Verifikation erfolgen kann */
  PhoneVerificationRequired = 'PHONE_VERIFICATION_REQUIRED',
  /** Warten auf Bestätigung der Mail Adresse */
  VerificationPending = 'VERIFICATION_PENDING'
}

export type UserProfileRelation = {
  __typename?: 'UserProfileRelation';
  /** Profil ID von welcher die Relation ausgeht */
  from?: Maybe<UserProfileBasicData>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Zielprofil */
  to?: Maybe<UserProfileBasicData>;
  /** Relations-Typ */
  type: UserProfileRelationType;
};

export type UserProfileRelationInput = {
  /** Profil ID von welcher die Relation ausgeht */
  from: Scalars['ID']['input'];
  /** Zielprofil */
  to: Scalars['ID']['input'];
  /** Relations-Typ */
  type: UserProfileRelationType;
};

export enum UserProfileRelationType {
  /** ist das aktuelle Profil Kind eines anderen Profiles */
  ChildOf = 'CHILD_OF',
  /** Besteht eine Partnerschaft, beispielsweise Ehe von 2 Profilen (symmetrisch) */
  PartnerOf = 'PARTNER_OF'
}

export type UserSettingsInput = {
  authenticatorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type WsBinary = IwsFile & {
  __typename?: 'WSBinary';
  /** Typ der Datei, wir aus der Endung abgeleitet. */
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Zieladresse inklusive Signatur (d.h private Inhalte können zeitlich begrenzt abgerufen werden) */
  signedURL?: Maybe<Scalars['Url']['output']>;
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  /** Zieladresse */
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsCss = IwsFile & {
  __typename?: 'WSCss';
  /** text/html */
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Zieladresse inklusive Signatur (d.h private Inhalte können zeitlich begrenzt abgerufen werden) */
  signedURL?: Maybe<Scalars['Url']['output']>;
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  /** Zieladresse */
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsDependency = {
  __typename?: 'WSDependency';
  label?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WsDependencyAnalysis = {
  __typename?: 'WSDependencyAnalysis';
  invalidDependencies?: Maybe<Array<Maybe<WsDependency>>>;
  validDependencies?: Maybe<Array<Maybe<WsDependency>>>;
};

/** ehemalige dynamische Seiten */
export type WsDynamicPage = IwsFile & {
  __typename?: 'WSDynamicPage';
  /** text/html */
  contentType: Scalars['String']['output'];
  cssCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  sharedResourceId?: Maybe<Scalars['Int']['output']>;
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Id der Datenquelle */
  targetComponentId?: Maybe<Scalars['String']['output']>;
  /** Typ der Datenquelle */
  targetComponentType?: Maybe<Scalars['String']['output']>;
  /** Zieladresse dem Quellcode der dynamischen Seite */
  templateUrl?: Maybe<Scalars['Url']['output']>;
  type: WsFileType;
  /** Zieladresse zum anzeigen des gerenderten Ergebnisses */
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsFileMetaUpdate = {
  cssCode?: InputMaybe<Scalars['String']['input']>;
  /** Beschreibung */
  description?: InputMaybe<Scalars['String']['input']>;
  mailTemplateKey?: InputMaybe<Scalars['String']['input']>;
  sharedResourceId?: InputMaybe<Scalars['Int']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  targetComponentId?: InputMaybe<Scalars['String']['input']>;
  targetComponentType?: InputMaybe<Scalars['String']['input']>;
};

/** Unterstützte Datei Arten innerhalb des Workspace */
export enum WsFileType {
  /** Eine CSS-Datei */
  Css = 'CSS',
  /** eine HTML Seite mit Datenquelle (dynamische Seite) */
  DynamicPage = 'DYNAMIC_PAGE',
  /** ein binary File */
  File = 'FILE',
  /** ein Verzeichnis */
  Folder = 'FOLDER',
  /** Eine Javascript-Datei */
  Javascript = 'JAVASCRIPT',
  /** Eine JSON-Datei */
  Json = 'JSON',
  /** ein externer Verweis */
  Link = 'LINK',
  /** eine Mail Vorlage */
  MailTemplate = 'MAIL_TEMPLATE',
  /** eine HTML Seite */
  Page = 'PAGE',
  /** Der Root Folder des Workspace */
  Root = 'ROOT'
}

export type WsFolder = IwsFile & {
  __typename?: 'WSFolder';
  /** Anzahl der Unterelemente */
  children: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsJavaScript = IwsFile & {
  __typename?: 'WSJavaScript';
  /** text/html */
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Zieladresse inklusive Signatur (d.h private Inhalte können zeitlich begrenzt abgerufen werden) */
  signedURL?: Maybe<Scalars['Url']['output']>;
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  /** Zieladresse */
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsJson = IwsFile & {
  __typename?: 'WSJson';
  /** text/html */
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Zieladresse inklusive Signatur (d.h private Inhalte können zeitlich begrenzt abgerufen werden) */
  signedURL?: Maybe<Scalars['Url']['output']>;
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  /** Zieladresse */
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['WSFileId']['output'];
};

/** ehemalige externe Seiten */
export type WsLink = IwsFile & {
  __typename?: 'WSLink';
  /** text/html */
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  /** Zieladresse zum anzeigen des gerenderten Ergebnisses */
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['WSFileId']['output'];
};

/**
 * Eine HTML Datei auf Basis der thymeleaf Template Engine, welche Variablen enthalten kann.
 * Beim Erzeugen einer E-Mail auf Basis einer solchen Vorlage, müssen die konkreten Werte
 * für die einzelnen Variablen als Kontext gesetzt werden.
 */
export type WsMailTemplate = IwsFile & {
  __typename?: 'WSMailTemplate';
  /** text/html */
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** EMAIL-Schlüssel */
  mailTemplateKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** signierte Url */
  signedURL?: Maybe<Scalars['Url']['output']>;
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Betreff der Mail (kann selbst Variablen enthalten) */
  subject?: Maybe<Scalars['String']['output']>;
  type: WsFileType;
  /** Zieladresse zum anzeigen des gerenderten Ergebnisses */
  url?: Maybe<Scalars['String']['output']>;
  /** Variablen Namen, die in der Vorlage verwendet werden */
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsPage = IwsFile & {
  __typename?: 'WSPage';
  /** text/html */
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Zieladresse inklusive Signatur (d.h private Inhalte können zeitlich begrenzt abgerufen werden) */
  signedURL?: Maybe<Scalars['Url']['output']>;
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  /** Zieladresse */
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsRoot = IwsFile & {
  __typename?: 'WSRoot';
  /** Anzahl der Unterelemente */
  children: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WSFileId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastModified: Scalars['Date']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Übergeordnerter Knoten */
  parentId?: Maybe<Scalars['String']['output']>;
  readonly: Scalars['Boolean']['output'];
  /** Grösse in Bytes */
  size?: Maybe<Scalars['Int']['output']>;
  type: WsFileType;
  workspaceId: Scalars['WSFileId']['output'];
};

export type WsTextContent = WsCss | WsDynamicPage | WsJavaScript | WsJson | WsMailTemplate | WsPage;

export type WhoamiResponse = {
  __typename?: 'WhoamiResponse';
  /** Security Context des JWT Tokens */
  appScope?: Maybe<Scalars['String']['output']>;
  /** Die claims aus dem JWT Token */
  claims?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** connect token, deprecated */
  connectToken?: Maybe<Scalars['String']['output']>;
  /** der aktuelle Gerätekontext, sofern vorhanden */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Ablaufzeitpunkt des aktuellen JWT Token. */
  expiresAt?: Maybe<Scalars['Date']['output']>;
  /** aktueller Benutzer */
  user?: Maybe<User>;
  /** aktuelles Benutzerprofil */
  userProfile?: Maybe<UserProfile>;
};

export type WidgetSettings = {
  __typename?: 'WidgetSettings';
  /** Background color */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Checkable */
  checkable?: Maybe<Scalars['Boolean']['output']>;
  /** Name des Close Buttons */
  closeButtonText?: Maybe<Scalars['String']['output']>;
  /** mit oder ohne Einklapp-Funktion */
  collapsable?: Maybe<Scalars['Boolean']['output']>;
  /** Kann vom benutzer als gelesen markiert und vom Dashboard entfernt werden */
  dismissible?: Maybe<Scalars['Boolean']['output']>;
  /** Wiedervorlage nach Tagen */
  followUpInDays?: Maybe<Scalars['Int']['output']>;
  /** Priorität */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Verfügbar in Phasen */
  projectPhases?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** verfügbar in folgenden Projekt-Typen */
  projectTypes?: Maybe<Array<Maybe<ProjectType>>>;
  /** Ist das Widget Veröffentlicht */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** verfügbar in folgenden Service-Levels */
  serviceLevels?: Maybe<Array<Maybe<ProjectServiceLevel>>>;
  /** Größe des Widgets. Bezieht sich auf 12- Grid-System */
  size?: Maybe<Scalars['Int']['output']>;
  /** Tag */
  tag?: Maybe<Scalars['String']['output']>;
  /** Text color */
  textColor?: Maybe<Scalars['String']['output']>;
};

export type WidgetSettingsInput = {
  /** Background color */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Checkable */
  checkable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name des Close Buttons */
  closeButtonText?: InputMaybe<Scalars['String']['input']>;
  /** mit oder ohne Einklapp-Funktion */
  collapsable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Kann vom benutzer als gelesen markiert und vom Dashboard entfernt werden */
  dismissible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Wiedervorlage nach Tagen */
  followUpInDays?: InputMaybe<Scalars['Int']['input']>;
  /** Priorität */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Verfügbar in Phasen */
  projectPhases?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** verfügbar in folgenden Projekt-Typen */
  projectTypes?: InputMaybe<Array<InputMaybe<ProjectType>>>;
  /** Ist das Widget Veröffentlicht */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** verfügbar in folgenden Service-Levels */
  serviceLevels?: InputMaybe<Array<InputMaybe<ProjectServiceLevel>>>;
  /** Größe des Widgets. Bezieht sich auf 12- Grid-System */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Tag */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Text color */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Analog zu einem Excel Dokument eine Sammlung von Arbeitsblättern, die als generisches Datenmodell für
 * Spezialentwicklungen benutzt werden.
 */
export type WorkbookComponent = {
  __typename?: 'WorkbookComponent';
  adminMail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  worksheetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  worksheets?: Maybe<Array<Maybe<Worksheet>>>;
};

export type WorkbookInput = {
  adminMail?: InputMaybe<Scalars['String']['input']>;
  worksheetOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Workbook-Vorlagen */
export type WorkbookTemplate = {
  __typename?: 'WorkbookTemplate';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sharedResourceId?: Maybe<Scalars['Int']['output']>;
};

/**
 * Ein von Excel inspiriertes Konzept eines Arbeitsblatts. Das Datenmodell umfasst eine beliebige Anzahl von Spalten,
 * die verschiedene Datentypen haben können. Es wird dann zeilenbasiert damit gearbeitet.
 */
export type Worksheet = {
  __typename?: 'Worksheet';
  /** diese Rollen haben Admin Rechte */
  adminRoleKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  columns?: Maybe<Array<Maybe<WorksheetColumnMetaData>>>;
  deleteAccess: WorksheetAccessLevel;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  readAccess: WorksheetAccessLevel;
  writeAccess: WorksheetAccessLevel;
};

export enum WorksheetAccessLevel {
  AlwaysAllow = 'ALWAYS_ALLOW',
  NeverAllow = 'NEVER_ALLOW',
  OwnerAllow = 'OWNER_ALLOW',
  WithDeviceContextAllow = 'WITH_DEVICE_CONTEXT_ALLOW'
}

export type WorksheetColumnMetaData = {
  __typename?: 'WorksheetColumnMetaData';
  /** Anzeigename der Spalte ggfs. Abhängig von der Sprache des Users */
  columnName?: Maybe<Scalars['String']['output']>;
  /** Datentyp der Spalte */
  datatype?: Maybe<WorksheetColumnType>;
  /** Sofern der Datatype 'enum' ist, finden sich hier die verfügbaren Werte */
  enumValues?: Maybe<Array<Maybe<EnumValue>>>;
  /** Angaben zum Format abhängig vom Datentyp */
  format?: Maybe<Scalars['String']['output']>;
  /** Ob es sich um ein Pflichtfeld handelt oder nicht */
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  /** Name des Poperties im Record */
  propertyName?: Maybe<Scalars['String']['output']>;
  /** Ob das Feld nur gelesen werden kann, also vom User nicht selbst geändert */
  readonly?: Maybe<Scalars['Boolean']['output']>;
};

export type WorksheetColumnMetaDataInput = {
  /** Anzeigename der Spalte ggfs. Abhängig von der Sprache des Users */
  columnName?: InputMaybe<Scalars['String']['input']>;
  /** Angaben zum Format abhängig vom Datentyp */
  format?: InputMaybe<Scalars['String']['input']>;
  /** Ob es sich um ein Pflichtfeld handelt oder nicht */
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name des Poperties im Record */
  propertyName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WorksheetColumnType>;
};

export enum WorksheetColumnType {
  /**
   * Eingabefeld Ja/Nein, On/Off
   * Über das Format könnte spezifiziert werden, wie Ja/nein gespeichert werden soll (true/false, 1/0, J/N)
   * legacy mapping: (bool, checkboxfield)
   */
  Boolean = 'BOOLEAN',
  /** Referenz auf eine Componente */
  ComponentRef = 'COMPONENT_REF',
  /**
   * Eingabefeld für Datumsangaben
   * Kann über das Format in der Anzahl des Jahreszahlen bzw. Uhrzeitangabe eingeschränkt werden.
   * legacy mapping: (date, datefield)
   */
  Date = 'DATE',
  /**
   * Aufzählungen.
   * kein legacy mapping
   */
  Enum = 'ENUM',
  /**
   * Eingabefeld für Kommazahlen
   * Könnte über das Format in mix und max bzw. Zahl der Nachkommastellen begrenzt werden
   * legacy mapping: (double, numberfield)
   */
  Float = 'FLOAT',
  /**
   * Referenz auf eine Bild-Ressource in der Mediathek
   * Über das Format wird gesteuert welche Mime Types erlaubt sind (PNG, JPG)
   * legacy mapping: (string, imageRef)
   */
  Image = 'IMAGE',
  /**
   * Referenz auf eine Ressource in der Mediathek
   * Über das Format wird gesteuert welche Mime Types erlaubt sind (AUDIO,VIDEO,IMAGE)
   * legacy mapping: (string, mediaRef)
   */
  Media = 'MEDIA',
  /**
   * Eingabefeld für ganze Zahlen.
   * Könnte über das Format in min und max begrenzt werden
   * legacy mapping: (int, numberfield)
   */
  Number = 'NUMBER',
  /** Referenz auf ein Profil */
  ProfileRef = 'PROFILE_REF',
  /**
   * Ein langer Text der aus mehreren Zeilen besteht.
   * Er beinhält html zeichen und wird mit einem Rich-Text Editor bearbeitet.
   */
  RichText = 'RICH_TEXT',
  /**
   * Refereenz auf eine Rolle in der App Nutzer Verwaltung.
   * legacy mapping: (auto, roleRef)
   */
  RoleRef = 'ROLE_REF',
  /**
   * Ein langer Text der aus mehreren Zeilen besteht.
   * Könnte über das Format kann die Anzahl der Zeilen begrenzt werden
   * legacy mapping: (string, textinput)
   */
  String = 'STRING',
  /**
   * Ein langer Text der aus mehreren Zeilen besteht.
   * Könnte über das Format kann die Anzahl der Zeilen begrenzt werden
   * legacy mapping: (string, textarea)
   */
  Text = 'TEXT',
  /**
   * Referenz auf ein File im GridFS des User Upload Bereichs
   * Über das Format wird gesteuert welche File Typen erlaubt sind. Momentan nur Bilder
   * legacy mapping: (string, gridFSImageRef)
   */
  UserUpload = 'USER_UPLOAD',
  /**
   * Referenz auf ein File im Workspace.
   * Über das Format wird gesteuert welche File Typen erlaubt sind (HTML, JS, CSS)
   * legacy mapping: (string, htmlRef)
   */
  Wsfile = 'WSFILE'
}

export type WorksheetInput = {
  adminRoleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columns?: InputMaybe<Array<InputMaybe<WorksheetColumnMetaDataInput>>>;
  deleteAccess?: InputMaybe<WorksheetAccessLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  readAccess?: InputMaybe<WorksheetAccessLevel>;
  writeAccess?: InputMaybe<WorksheetAccessLevel>;
};

export type WorksheetPagingResponse = {
  __typename?: 'WorksheetPagingResponse';
  content?: Maybe<Array<Maybe<GenericRow>>>;
  totalcount: Scalars['Int']['output'];
};

export type WorksheetQuery = {
  options?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  worksheetId?: InputMaybe<Scalars['ID']['input']>;
};
